import React, { useState, useEffect } from 'react';

const API = 'https://sashtimedix.in/api';
const SHOW_CHAT = false; // set to true to show the live chat bubble again

const categoryImages = {
  'மாத்திரை': 'https://cdn-icons-png.flaticon.com/512/2913/2913461.png',
  'சர்க்கரை': 'https://cdn-icons-png.flaticon.com/512/3159/3159066.png',
  'BP': 'https://cdn-icons-png.flaticon.com/512/2383/2383201.png',
  'சளி': 'https://cdn-icons-png.flaticon.com/512/2913/2913133.png',
  'குழந்தை': 'https://cdn-icons-png.flaticon.com/512/3140/3140343.png',
  'வைட்டமின்': 'https://cdn-icons-png.flaticon.com/512/2913/2913569.png',
  'காயம்': 'https://cdn-icons-png.flaticon.com/512/2382/2382461.png',
  'ஆயுர்வேதம்': 'https://cdn-icons-png.flaticon.com/512/2913/2913284.png',
};

// ---- Payment methods strip (name badges, no official logos) ----
const PAY_GROUPS = [
  ['UPI', [['GPay','#5f6368'],['PhonePe','#5f259f'],['Paytm','#00539b'],['BHIM UPI','#1f7a4d']]],
  ['Cards', [['VISA','#1a1f71'],['Mastercard','#c62828'],['RuPay','#c75a12']]],
  ['More', [['Netbanking','#455a64'],['Cash on Delivery','#455a64']]],
];
const PayChip = ({name, color, dark}) => (
  <span style={{display:'inline-flex',alignItems:'center',gap:'6px',background:dark?'rgba(255,255,255,0.08)':'#ffffff',border:dark?'1px solid rgba(255,255,255,0.2)':'1px solid #e3e8ef',color:dark?'#e5e7eb':color,borderRadius:'9px',padding:'6px 11px',fontSize:'11px',fontWeight:700,letterSpacing:'0.2px',boxShadow:dark?'none':'0 1px 2px rgba(16,24,40,0.05)',whiteSpace:'nowrap'}}>
    <span style={{width:'7px',height:'7px',borderRadius:'50%',background:color,flexShrink:0}}></span>{name}
  </span>
);
const PayStrip = ({compact, dark}) => (
  compact ? (
    <div style={{display:'flex',flexWrap:'wrap',alignItems:'center',gap:'6px'}}>
      <span style={{fontSize:'11px',color:'#8a94a6',fontWeight:600,marginRight:'2px'}}>We accept</span>
      {PAY_GROUPS.map(([, items])=>items.map(([n,c])=>(<PayChip key={n} name={n} color={c} dark={dark}/>)))}
    </div>
  ) : (
    <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
      {PAY_GROUPS.map(([g,items])=>(
        <div key={g} style={{display:'flex',alignItems:'center',gap:'8px',flexWrap:'wrap'}}>
          <span style={{width:'42px',fontSize:'9px',fontWeight:800,letterSpacing:'0.8px',textTransform:'uppercase',color:'#9aa3b2'}}>{g}</span>
          {items.map(([n,c])=>(<PayChip key={n} name={n} color={c} dark={dark}/>))}
        </div>
      ))}
    </div>
  )
);

const rsFmt = n => (Number.isInteger(Number(n)) ? Number(n) : Number(n).toFixed(2));

// ---- line icons (no emoji) ----
const ICON_PATHS = {
  pill: <g><path d="M10.5 20.5l10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7z"/><path d="M8.5 8.5l7 7"/></g>,
  file: <g><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M16 13H8"/><path d="M16 17H8"/><path d="M10 9H8"/></g>,
  flask: <g><path d="M10 2v7.5a2 2 0 0 1-.2.9L4.7 20.5a1 1 0 0 0 .9 1.5h12.8a1 1 0 0 0 .9-1.5l-5.1-10.1a2 2 0 0 1-.2-.9V2"/><path d="M8.5 2h7"/><path d="M7 16h10"/></g>,
  user: <g><circle cx="12" cy="8" r="4"/><path d="M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1"/></g>,
  doctor: <g><circle cx="12" cy="7" r="4"/><path d="M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1"/><path d="M12 16v4"/><path d="M10 18h4"/></g>,
  box: <g><path d="M16.5 9.4l-9-5.2"/><path d="M21 16V8a2 2 0 0 0-1-1.7l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.7l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M3.3 7L12 12l8.7-5"/><path d="M12 22V12"/></g>,
  shield: <g><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></g>,
  check: <g><path d="M22 11.1V12a10 10 0 1 1-5.9-9.1"/><path d="M22 4L12 14l-3-3"/></g>,
  lock: <g><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></g>,
  heart: <g><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21.2l7.8-7.7 1-1.1a5.5 5.5 0 0 0 0-7.8z"/></g>,
  drop: <g><path d="M12 2.7l5.7 5.7a8 8 0 1 1-11.4 0z"/></g>,
  pulse: <g><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></g>,
  wind: <g><path d="M9.6 4.6A2 2 0 1 1 11 8H2"/><path d="M12.6 19.4A2 2 0 1 0 14 16H2"/><path d="M17.7 7.7A2.5 2.5 0 1 1 19.5 12H2"/></g>,
  leaf: <g><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.5 19 2c1 2 2 4.2 2 8 0 5.5-4.8 10-10 10z"/><path d="M2 21c0-3 1.9-5.4 5.1-6C9.5 14.5 12 13 13 12"/></g>,
  sun: <g><circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="M4.9 4.9l1.4 1.4"/><path d="M17.7 17.7l1.4 1.4"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="M6.3 17.7l-1.4 1.4"/><path d="M19.1 4.9l-1.4 1.4"/></g>,
  tag: <g><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8z"/><path d="M7 7h.01"/></g>,
  upload: <g><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="M17 8l-5-5-5 5"/><path d="M12 3v12"/></g>,
  chat: <g><path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8v.5z"/></g>,
  chevron: <g><path d="M9 18l6-6-6-6"/></g>,
  repeat: <g><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></g>,
  truck: <g><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></g>,
};
const Ico = ({ name, size = 22, color = 'currentColor', sw = 1.8 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" style={{display:'block',flexShrink:0}} aria-hidden="true">{ICON_PATHS[name] || null}</svg>
);

let heroTouchX = null;

function App() {
  useEffect(() => {
    const style = document.createElement('style');
    style.setAttribute('data-sashtimedix-responsive', 'true');
    style.innerHTML = `
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Poppins:wght@600;700;800&display=swap');
      .app-shell, .app-shell input, .app-shell button { font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif; }
      .app-shell h1, .app-shell h2, .app-shell h3 { font-family: 'Poppins', 'Inter', -apple-system, sans-serif; }
      .app-shell button { transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease; }
      .app-shell button:active { transform: scale(0.95); }
      .med-card { transition: transform 0.22s ease, box-shadow 0.22s ease; }
      .med-card:hover { transform: translateY(-5px); box-shadow: 0 12px 22px rgba(0,0,0,0.12) !important; }
      .med-card:active { transform: translateY(-1px) scale(0.98); }
      .app-shell a { transition: opacity 0.15s ease, transform 0.15s ease; }
      .app-shell a:active { transform: scale(0.95); }
      .app-shell { max-width: 600px; margin: 0 auto; }
      .app-nav { max-width: 600px; }
      .med-grid { grid-template-columns: 1fr 1fr !important; }
      @media (min-width: 768px) {
        body { background: #eef1f4; }
        .app-shell { max-width: 900px; box-shadow: 0 0 40px rgba(0,0,0,0.08); }
        .app-nav { max-width: 900px; }
        .med-grid { grid-template-columns: repeat(3, 1fr) !important; gap: 16px !important; }
      }
      @media (min-width: 1200px) {
        .app-shell { max-width: 1100px; }
        .app-nav { max-width: 1100px; }
        .med-grid { grid-template-columns: repeat(4, 1fr) !important; }
      }
      .app-shell.dark-mode { filter: invert(1) hue-rotate(180deg); background: #fff; }
      .app-shell.dark-mode img, .app-shell.dark-mode svg, .app-shell.dark-mode .hero-emoji-3d,
      .app-shell.dark-mode .hero-capsule, .app-shell.dark-mode .hero-pill { filter: invert(1) hue-rotate(180deg); }
      @keyframes micPulse {
        0%, 100% { transform: translateY(-50%) scale(1); }
        50% { transform: translateY(-50%) scale(1.25); }
      }
      @keyframes heroFloatCapsule {
        0%, 100% { transform: rotate(-18deg) translateY(0px); }
        50% { transform: rotate(-10deg) translateY(-8px); }
      }
      @keyframes heroFloatPill {
        0%, 100% { transform: translateY(0px) rotate(0deg); }
        50% { transform: translateY(-10px) rotate(10deg); }
      }
      @keyframes heroEmojiTilt {
        0%, 100% { transform: perspective(300px) rotateY(0deg); }
        50% { transform: perspective(300px) rotateY(14deg); }
      }
      .hero-capsule { animation: heroFloatCapsule 4s ease-in-out infinite; }
      .hero-pill { animation: heroFloatPill 3.4s ease-in-out infinite; }
      .hero-emoji-3d { display: inline-block; animation: heroEmojiTilt 3s ease-in-out infinite; filter: drop-shadow(0 8px 10px rgba(0,0,0,0.25)); }

      @keyframes fadeInUp { from { opacity: 0; transform: translateY(14px); } to { opacity: 1; transform: translateY(0); } }
      @keyframes cartBump { 0%,100% { transform: scale(1); } 35% { transform: scale(1.4); } 60% { transform: scale(0.92); } }
      @keyframes shimmer { 0% { background-position: -300px 0; } 100% { background-position: 300px 0; } }
      @keyframes softPulseGlow { 0%,100% { box-shadow: 0 8px 24px rgba(0,88,198,0.18); } 50% { box-shadow: 0 8px 30px rgba(255,107,74,0.28); } }

      .animate-in { animation: fadeInUp 0.45s cubic-bezier(0.22,1,0.36,1) both; }
      .stagger-grid > * { animation: fadeInUp 0.45s cubic-bezier(0.22,1,0.36,1) both; }
      .stagger-grid > *:nth-child(1) { animation-delay: 0.02s; }
      .stagger-grid > *:nth-child(2) { animation-delay: 0.06s; }
      .stagger-grid > *:nth-child(3) { animation-delay: 0.10s; }
      .stagger-grid > *:nth-child(4) { animation-delay: 0.14s; }
      .stagger-grid > *:nth-child(5) { animation-delay: 0.18s; }
      .stagger-grid > *:nth-child(6) { animation-delay: 0.22s; }
      .stagger-grid > *:nth-child(n+7) { animation-delay: 0.26s; }

      .cart-bump { animation: cartBump 0.4s cubic-bezier(0.34,1.56,0.64,1); }

      .skeleton { background: linear-gradient(90deg, #eef0f4 25%, #f7f8fb 37%, #eef0f4 63%); background-size: 400px 100%; animation: shimmer 1.4s ease-in-out infinite; border-radius: 12px; }

      .med-card { transition: transform 0.25s cubic-bezier(0.22,1,0.36,1), box-shadow 0.25s ease; }
      .med-card:hover { transform: translateY(-6px); box-shadow: 0 16px 28px rgba(0,88,198,0.14) !important; }
      .med-card:active { transform: translateY(-1px) scale(0.97); }

      .cta-glow { animation: softPulseGlow 2.6s ease-in-out infinite; }

      .app-shell button { transition: transform 0.15s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.2s ease, opacity 0.15s ease, filter 0.2s ease; }
      .app-shell button:active { transform: scale(0.94); }
      @media (hover:hover) {
        .app-shell button:hover { filter: brightness(1.04); }
      }

      @keyframes tickerScroll {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }

      @keyframes bannerContentIn {
        0% { opacity: 0; transform: translateY(10px) scale(0.98); }
        100% { opacity: 1; transform: translateY(0) scale(1); }
      }
      @keyframes sparkleTwinkle {
        0%, 100% { opacity: 0.2; transform: scale(0.7); }
        50% { opacity: 1; transform: scale(1.2); }
      }
      @keyframes glowSweep {
        0% { transform: translateX(-120%) skewX(-20deg); }
        100% { transform: translateX(220%) skewX(-20deg); }
      }
      @keyframes ringPulse {
        0%, 100% { transform: scale(1); opacity: 0.5; }
        50% { transform: scale(1.15); opacity: 0.15; }
      }
      @keyframes bannerSoftIn { from { opacity: 0.9; } to { opacity: 1; } }
      .banner-content { animation: bannerSoftIn 0.6s ease both; }
      .banner-sparkle { animation: none !important; opacity: 0.5; background: none !important; border-radius: 0 !important; width: 14px !important; height: 14px !important; }
      .banner-sparkle::before, .banner-sparkle::after { content: ''; position: absolute; background: #fff; border-radius: 1px; }
      .banner-sparkle::before { left: 5px; top: 0; width: 4px; height: 14px; }
      .banner-sparkle::after { left: 0; top: 5px; width: 14px; height: 4px; }
      .banner-glow-sweep { animation: none !important; display: none !important; }
      .banner-ring { animation: none !important; }
      .co-input { width: 100%; padding: 12px; border-radius: 10px; border: 1.5px solid #d0d5dd; box-sizing: border-box; font-size: 14px; background: #fff; margin-bottom: 8px; outline: none; }
      .co-input:focus { border-color: #0783ED; box-shadow: 0 0 0 3px rgba(7,131,237,0.18); }
      details.co-details > summary { list-style: none; cursor: pointer; }
      details.co-details > summary::-webkit-details-marker { display: none; }
      .med-list { display: grid !important; grid-template-columns: minmax(0, 1fr) !important; gap: 10px !important; }
      @media (min-width: 768px) { .med-list { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; } }
      @media (min-width: 1200px) { .med-list { grid-template-columns: repeat(3, minmax(0, 1fr)) !important; } }
      .med-list > * { min-width: 0; }
      .cat-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 10px; }
      @media (min-width: 768px) { .cat-grid { grid-template-columns: repeat(5, minmax(0, 1fr)); } }
      a[href*="need%20help%20with%20an%20order"] { right: auto !important; left: 14px !important; }
      .med-list .med-card:hover { transform: none !important; box-shadow: 0 4px 12px rgba(16,24,40,0.10) !important; }
      .app-shell input[type="text"]:focus { box-shadow: 0 0 0 3px rgba(7,131,237,0.28) !important; }
      .hero-emoji-3d, .hero-capsule, .hero-pill { animation: none !important; }
      .hero-capsule { background: none !important; box-shadow: none !important; width: 56px !important; height: 56px !important; border-radius: 0 !important; transform: none !important; top: 34px !important; right: 34px !important; opacity: 0.25; }
      .hero-capsule::before, .hero-capsule::after { content: ''; position: absolute; background: #fff; border-radius: 4px; }
      .hero-capsule::before { left: 20px; top: 0; width: 16px; height: 56px; }
      .hero-capsule::after { left: 0; top: 20px; width: 56px; height: 16px; }
      .hero-pill { background: rgba(255,255,255,0.18) !important; border: 2px solid rgba(255,255,255,0.75); box-shadow: none !important; }
      .hero-pill::after { content: 'Rx'; position: absolute; left: 0; top: 0; right: 0; bottom: 0; display: flex; align-items: center; justify-content: center; color: #fff; font-weight: 800; font-size: 15px; letter-spacing: 0.5px; }

      /* ===== DESKTOP WEBSITE STYLE ===== */
      .desktop-navbar, .desktop-footer { display: none; }
      @media (min-width: 1024px) {
        .app-shell { max-width: 100% !important; box-shadow: none !important; padding-bottom: 0 !important; }
        .app-nav { display: none !important; }
        .mobile-header { display: none !important; }
        .desktop-navbar { display: block; }
        .desktop-footer { display: block; }
      }
      .desktop-navbar .nav-link { color: #333; font-weight: 600; font-size: 14px; cursor: pointer; white-space: nowrap; }
      .desktop-navbar .nav-link:hover { color: #0058C6; }
      .desktop-footer a { color: #ccc; text-decoration: none; font-size: 13px; }
      .desktop-footer a:hover { color: #fff; }
    `;
    if (!document.querySelector('style[data-sashtimedix-responsive]')) {
      document.head.appendChild(style);
    }
  }, []);
  const [screen, setScreen] = useState('login');
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [search, setSearch] = useState('');
  const [voiceListening, setVoiceListening] = useState(false);
  const [rxFilter, setRxFilter] = useState('all');
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('sashtimedix_dark') === '1');
  const [sortBy, setSortBy] = useState('relevance');
  const [inStockOnly, setInStockOnly] = useState(false);
  // Stable pseudo-rating derived from the medicine id, until a real ratings backend exists
  const getRating = (id) => {
    let hash = 0;
    for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
    return (3.6 + (hash % 15) / 10).toFixed(1);
  };
  useEffect(() => { localStorage.setItem('sashtimedix_dark', darkMode ? '1' : '0'); }, [darkMode]);
  const [medicines, setMedicines] = useState([]);
  const [cart, setCart] = useState([]);
  const [tab, setTab] = useState('home');
  const [page, setPage] = useState('');
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [adIdx, setAdIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setAdIdx(i => (i + 1) % 4), 4000);
    return () => clearInterval(t);
  }, []);
  const [medDetail, setMedDetail] = useState(null);
  const [productReviews, setProductReviews] = useState({ reviews: [], avgRating: 0, count: 0 });
  const [couponInput, setCouponInput] = useState('');
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponMsg, setCouponMsg] = useState('');
  const [trackingData, setTrackingData] = useState(null);
  const [trackingLoading, setTrackingLoading] = useState(false);
  const [myRating, setMyRating] = useState(0);
  const [myComment, setMyComment] = useState('');
  const [submittingReview, setSubmittingReview] = useState(false);
  const [scanTypes, setScanTypes] = useState([]);
  const [selectedScan, setSelectedScan] = useState(null);
  const [scanForm, setScanForm] = useState({customerName:'',phone:'',address:'',preferredDate:'',preferredSlot:''});
  const [scanBookingMsg, setScanBookingMsg] = useState('');
  const [consultTypes, setConsultTypes] = useState([]);
  const [selectedConsult, setSelectedConsult] = useState(null);
  const [consultForm, setConsultForm] = useState({customerName:'',phone:'',age:'',gender:'',symptoms:'',mode:'video',preferredDate:'',preferredSlot:''});
  const [consultBookingMsg, setConsultBookingMsg] = useState('');
  const [healthSection, setHealthSection] = useState('labtests');
  const [lastOrder, setLastOrder] = useState(null);
  const [orderDetailView, setOrderDetailView] = useState(null);
  const [membershipPlans, setMembershipPlans] = useState([]);
  const [myMembership, setMyMembership] = useState({active:false});
  const [subscribingPlan, setSubscribingPlan] = useState(null);
  const [myScanBookings, setMyScanBookings] = useState([]);
  const [myConsultBookings, setMyConsultBookings] = useState([]);
  const [bookingsTab, setBookingsTab] = useState('scans');
  const fetchMyBookings = () => {
    fetch(`${API}/scans/mybookings`,{headers:{Authorization:`Bearer ${token}`}}).then(r=>r.json()).then(d=>setMyScanBookings(Array.isArray(d)?d:[])).catch(()=>{});
    fetch(`${API}/consultations/mybookings`,{headers:{Authorization:`Bearer ${token}`}}).then(r=>r.json()).then(d=>setMyConsultBookings(Array.isArray(d)?d:[])).catch(()=>{});
  };
  const cancelScanBooking = async (id) => {
    if (!window.confirm('Cancel this booking?')) return;
    try { const res = await fetch(`${API}/scans/${id}/cancel`,{method:'PATCH',headers:{Authorization:`Bearer ${token}`}}); const data = await res.json(); if (data.success) fetchMyBookings(); else alert(data.error||'Failed to cancel'); } catch (err) { alert('Error: '+err.message); }
  };
  const cancelConsultBooking = async (id) => {
    if (!window.confirm('Cancel this consultation?')) return;
    try { const res = await fetch(`${API}/consultations/${id}/cancel`,{method:'PATCH',headers:{Authorization:`Bearer ${token}`}}); const data = await res.json(); if (data.success) fetchMyBookings(); else alert(data.error||'Failed to cancel'); } catch (err) { alert('Error: '+err.message); }
  };
  const fetchMembershipPlans = () => { fetch(`${API}/membership/plans`).then(r=>r.json()).then(setMembershipPlans).catch(()=>{}); };
  const fetchMyMembership = () => { fetch(`${API}/user/membership`,{headers:{Authorization:`Bearer ${token}`}}).then(r=>r.json()).then(setMyMembership).catch(()=>{}); };
  const subscribeMembership = async (planId) => {
    setSubscribingPlan(planId);
    try {
      const res = await fetch(`${API}/user/membership/subscribe`,{method:'POST',headers:{'Content-Type':'application/json',Authorization:`Bearer ${token}`},body:JSON.stringify({planId})});
      const data = await res.json();
      if (data.success) { setMyMembership(data.membership); alert(data.message||'Membership activated!'); }
      else alert(data.error||'Subscription failed');
    } catch (err) { alert('Error: '+err.message); }
    setSubscribingPlan(null);
  };
  const [symptomText, setSymptomText] = useState('');
  const [chatOpen, setChatOpen] = useState(false);
  const [homeBanners, setHomeBanners] = useState([]);
  useEffect(() => {
    fetch(`${API}/banners/active`)
      .then(r => r.json())
      .then(d => {
        if (!Array.isArray(d)) return;
        const ok = d.filter(b => b && (b.title || b.imageUrl)).slice(0, 8).map(b => ({
          ...b,
          imageUrl: /^https:\/\//i.test(b.imageUrl || '') ? b.imageUrl : ''
        }));
        setHomeBanners(ok);
      })
      .catch(() => {});
  }, []);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [orderFilter, setOrderFilter] = useState('all');
  const [chatHistory, setChatHistory] = useState([{from:'bot',text:'Hi! I am the SashtiMedix Assistant. How can I help you today?'}]);
  const chatTopics = [
    ['Track my order','Go to My Orders and tap Track Order on any active order to see live status and delivery partner location. You can also check the Health Locker for prescription-related orders.'],
    ['Return or refund','You can request a return from My Orders within 48 hours of delivery. Approved refunds are processed within 5-7 business days to your original payment method.'],
    ['Payment issue','We accept UPI, Cards, Netbanking and Cash on Delivery. Online payments are secured via Razorpay. If a payment failed but amount was deducted, it will be auto-refunded within 5-7 days.'],
    ['Prescription help','Upload your prescription from Profile > Health Locker or during checkout for Rx medicines. Our pharmacist verifies it before dispensing.'],
  ];
  const askChatBot = (topic, answer) => {
    setChatHistory(h=>[...h, {from:'user',text:topic}, {from:'bot',text:answer}]);
  };
  const symptomMap = [
    [['fever','cold','cough','body pain','weakness','headache','flu'],'General Physician'],
    [['child','baby','kid','vaccination','infant'],'Pediatrician'],
    [['periods','pregnancy','pcod','menstrual','gynec'],'Gynecologist'],
    [['skin','rash','acne','hair fall','itching'],'Dermatologist'],
    [['chest pain','bp','blood pressure','heart','palpitations'],'Cardiologist'],
    [['joint pain','back pain','fracture','knee','bone'],'Orthopedic'],
    [['ear pain','throat','sinus','hearing','nose'],'ENT Specialist'],
    [['stress','anxiety','sleep','depression','mental'],'Psychiatrist'],
    [['tooth','gum','dental','teeth'],'Dentist'],
    [['sugar','diabetes','thirst','urination'],'Diabetologist'],
  ];
  const suggestedSpecializations = symptomText.trim().length>2
    ? [...new Set(symptomMap.filter(([kws])=>kws.some(k=>symptomText.toLowerCase().includes(k))).map(([,spec])=>spec))]
    : [];
  const [substitutes, setSubstitutes] = useState([]);
  useEffect(() => {
    if (!medDetail) { setSubstitutes([]); return; }
    fetch(`${API}/medicines/${medDetail._id}/substitutes`).then(r=>r.json()).then(d=>setSubstitutes(Array.isArray(d)?d:[])).catch(()=>setSubstitutes([]));
  }, [medDetail]);
  const [dealCountdown, setDealCountdown] = useState('');
  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24,0,0,0);
      const diff = midnight - now;
      const h = String(Math.floor(diff/3600000)).padStart(2,'0');
      const m = String(Math.floor((diff%3600000)/60000)).padStart(2,'0');
      const s = String(Math.floor((diff%60000)/1000)).padStart(2,'0');
      setDealCountdown(`${h}:${m}:${s}`);
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (tab === 'scans' && scanTypes.length === 0) {
      fetch(`${API}/scans/types`).then(r => r.json()).then(setScanTypes).catch(() => {});
    }
    if (tab === 'scans' && consultTypes.length === 0) {
      fetch(`${API}/consultations/types`).then(r => r.json()).then(setConsultTypes).catch(() => {});
    }
  }, [tab]);


  const [recentlyViewed, setRecentlyViewed] = useState(() => {
    try { return JSON.parse(localStorage.getItem('sashtimedix_recent') || '[]'); } catch { return []; }
  });
  useEffect(() => {
    if (!medDetail) return;
    setRecentlyViewed(prev => {
      const updated = [medDetail, ...prev.filter(m => m._id !== medDetail._id)].slice(0, 10);
      localStorage.setItem('sashtimedix_recent', JSON.stringify(updated));
      return updated;
    });
  }, [medDetail]);

  const quickReorder = (order) => {
    order.items.forEach(item => {
      const currentMed = medicines.find(m => m._id === item.medicineId);
      const medToAdd = currentMed || { _id: item.medicineId, name: item.name, price: item.price, mrp: item.price, generic: '', stock: 99 };
      for (let i = 0; i < item.qty; i++) addCart(medToAdd);
    });
    setTab('cart');
  };


  useEffect(() => {
    if (!medDetail) return;
    fetch(`${API}/medicines/${medDetail._id}/reviews`)
      .then(r => r.json())
      .then(d => setProductReviews(d && d.reviews ? d : { reviews: [], avgRating: 0, count: 0 }))
      .catch(() => setProductReviews({ reviews: [], avgRating: 0, count: 0 }));
    setMyRating(0); setMyComment('');
  }, [medDetail]);

  const submitReview = async () => {
    if (!myRating) { alert('Star rating கொடுங்க'); return; }
    setSubmittingReview(true);
    try {
      await fetch(`${API}/reviews`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ medicineId: medDetail._id, rating: myRating, comment: myComment })
      });
      const res = await fetch(`${API}/medicines/${medDetail._id}/reviews`);
      setProductReviews(await res.json());
      setMyRating(0); setMyComment('');
    } catch (err) { console.log(err); }
    setSubmittingReview(false);
  };


  // Make browser/phone "back" button close the current overlay (product detail / cart / checkout / etc.)
  // instead of leaving the app entirely.
  useEffect(() => {
    const handlePopState = () => {
      if (medDetail) { setMedDetail(null); return; }
      if (page) { setPage(''); return; }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [medDetail, page]);

  useEffect(() => {
    if (medDetail || page) {
      window.history.pushState({ sashtimedixNav: true }, '');
    }
  }, [medDetail, page]);

  const [searchFocused, setSearchFocused] = useState(false);
  const [locationLoading, setLocationLoading] = useState(false);
  const [detectedAddress, setDetectedAddress] = useState('');
  const [addressSuggestions, setAddressSuggestions] = useState([]);
  const [manualAddr, setManualAddr] = useState({name:'',street:'',area:'',pincode:'',city:'Erode'});

  const erodeAreas = {
    '638001':['Erode City','Town Hall','Big Bazaar Street','Railway Station'],
    '638002':['Perundurai Road','Sathy Road','Chithode'],
    '638003':['Surampatti','Kasipalayam','Veerappanchathiram'],
    '638004':['Thindal','Muthampalayam','Nanjai Uthukuli'],
    '638005':['Karungalpalayam','Nethaji Road','Sivaji Nagar'],
    '638006':['Veerappanchathiram','Ammapet','Gandhinagar'],
    '638007':['Kollampalayam','Chinnakarai','Agraharam'],
    '638008':['Bargur','Bhavanisagar'],
    '638011':['Bhavani','Unjalur'],
    '638012':['Gobichettipalayam','Vijayamangalam'],
    '638051':['Perundurai','SIDCO'],
    '638052':['Modakurichi','Nambiyur'],
    '638060':['Anthiyur'],
    '638101':['Kangeyam','Dharapuram'],
    '638103':['Uthukuli'],
    '638109':['Palladam'],
    '638115':['Avinashi'],
    '638183':['Tiruppur'],
  };

  const detectLocation = () => {
    setLocationLoading(true);
    if (!navigator.geolocation) {
      alert('Location not supported');
      setLocationLoading(false);
      return;
    }
    navigator.geolocation.getCurrentPosition(async (pos) => {
      const { latitude, longitude } = pos.coords;
      try {
        const res = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json&accept-language=en`);
        const data = await res.json();
        const addr = data.address;
        const pincode = addr.postcode || '';
        const street = addr.road || addr.suburb || '';
        const area = addr.neighbourhood || addr.suburb || addr.village || addr.town || 'Erode';
        const city = addr.city || addr.town || 'Erode';
        const fullAddr = `${street}, ${area}, ${city} - ${pincode}`;
        setDetectedAddress(fullAddr);
        setManualAddr({
          name: manualAddr.name,
          street: street,
          area: area,
          pincode: pincode,
          city: city
        });
      } catch (err) {
        setDetectedAddress('Location detected but address fetch failed. Enter manually.');
      }
      setLocationLoading(false);
    }, (err) => {
      alert('Location access denied. Please enter manually.');
      setLocationLoading(false);
    });
  };

  const searchPincode = (pin) => {
    setManualAddr(prev => ({...prev, pincode: pin}));
    if (pin.length === 6 && erodeAreas[pin]) {
      setAddressSuggestions(erodeAreas[pin]);
    } else {
      setAddressSuggestions([]);
    }
  };
  const [loyalty, setLoyalty] = useState({points:0,totalEarned:0,totalRedeemed:0});
  const [useCoins, setUseCoins] = useState(false);
  const [coinsToRedeem, setCoinsToRedeem] = useState(0);

  const ads = [
    {bg:'linear-gradient(135deg,#0058C6,#0783ED)',title:'₹50 OFF on Your Order!',sub:'Use code WELCOME50 on orders above ₹200',emoji:'🎉',tag:'LIMITED OFFER'},
    {bg:'linear-gradient(135deg,#278018,#3FA21B)',title:'Free Delivery',sub:'On orders above ₹200',emoji:'🛵',tag:'FREE DELIVERY'},
    {bg:'linear-gradient(135deg,#0143AC,#278018)',title:'Prescription Service',sub:'Upload & get medicines at home',emoji:'📋',tag:'NEW'},
    {bg:'linear-gradient(135deg,#036926,#0058C6)',title:'Diabetes Care Pack',sub:'Special combo at 30% off',emoji:'💊',tag:'COMBO OFFER'},
  ];

  const categories = [
    {name:'Medicines',icon:'💊',color:'#e3f2fd',iconColor:'#1565c0'},
    {name:'Diabetes',icon:'🩺',color:'#f3e5f5',iconColor:'#6a1b9a'},
    {name:'Heart Care',icon:'❤️',color:'#fce4ec',iconColor:'#c62828'},
    {name:'Cold & Flu',icon:'🤧',color:'#e8f5e9',iconColor:'#2e7d32'},
    {name:'Baby Care',icon:'👶',color:'#fff8e1',iconColor:'#f57f17'},
    {name:'Vitamins',icon:'💪',color:'#e1f5fe',iconColor:'#0277bd'},
    {name:'First Aid',icon:'🩹',color:'#fbe9e7',iconColor:'#bf360c'},
    {name:'Ayurveda',icon:'🌿',color:'#f1f8e9',iconColor:'#33691e'},
  ];

  useEffect(() => {
    if (token) { setScreen('app'); fetchMedicines(); fetchOrders(); fetchLoyalty(); fetchWishlist(); fetchNotifications(); fetchActiveCoupons(); fetchProfile(); }
  }, [token]);

  const fetchLoyalty = async () => {
    try {
      const res = await fetch(`${API}/user/loyalty`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      if (data && typeof data.points === 'number') {
        setLoyalty({ points: data.points });
      }
    } catch (err) { console.log(err); }
  };

  useEffect(() => {
    if (screen === 'app') fetchMedicines();
  }, [search, selectedCategory]);

  useEffect(() => {
    const slideCount = homeBanners.length || 3;
    const timer = setInterval(() => setAdIdx(i => (i+1) % slideCount), 5000);
    return () => clearInterval(timer);
  }, [homeBanners.length]);

  const [medsLoading, setMedsLoading] = useState(false);
  const fetchMedicines = async () => {
    setMedsLoading(true);
    try {
      const catQ = (selectedCategory && selectedCategory !== 'ALL') ? `&category=${encodeURIComponent(selectedCategory)}` : '';
      const res = await fetch(`${API}/medicines?search=${encodeURIComponent(search)}${catQ}`);
      const data = await res.json();
      setMedicines(Array.isArray(data) ? data : []);
    } catch (err) { console.log(err); }
    setMedsLoading(false);
  };

  const fetchOrders = async () => {
    try {
      const res = await fetch(`${API}/orders/my`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setOrders(Array.isArray(data) ? data : []);
    } catch (err) { console.log(err); }
  };

  const fetchTracking = async (orderId) => {
    setTrackingLoading(true);
    setTrackingData({ _loading: true });
    try {
      const res = await fetch(`${API}/orders/${orderId}/track`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setTrackingData(data);
    } catch (err) {
      console.log(err);
      setTrackingData({ error: true });
    }
    setTrackingLoading(false);
  };

  const cancelOrder = async (orderId) => {
    if (!window.confirm('Order-ஐ cancel பண்ணணுமா?')) return;
    try {
      const res = await fetch(`${API}/orders/${orderId}/cancel`, { method: 'PATCH', headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      if (data.success) { fetchOrders(); alert('Order cancelled'); }
      else { alert(data.error || 'Cancel failed'); }
    } catch (err) { alert('Error: ' + err.message); }
  };

  const [addressList, setAddressList] = useState([]);
  const [newAddr, setNewAddr] = useState({label:'Home',name:'',phone:'',street:'',area:'',city:'',pincode:''});
  const [showAddrForm, setShowAddrForm] = useState(false);

  const fetchAddresses = async () => {
    try {
      const res = await fetch(`${API}/user/addresses`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setAddressList(Array.isArray(data) ? data : []);
    } catch (err) { console.log(err); }
  };

  const addAddress = async () => {
    if (!newAddr.name || !newAddr.street || !newAddr.city || !newAddr.pincode) { alert('Ella fields-um நிரப்பவும்'); return; }
    try {
      const res = await fetch(`${API}/user/addresses`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(newAddr)
      });
      const data = await res.json();
      if (data.success) { setAddressList(data.addresses); setNewAddr({label:'Home',name:'',phone:'',street:'',area:'',city:'',pincode:''}); setShowAddrForm(false); }
    } catch (err) { alert('Error: ' + err.message); }
  };

  const deleteAddress = async (addrId) => {
    if (!window.confirm('Address-ஐ delete பண்ணணுமா?')) return;
    try {
      const res = await fetch(`${API}/user/addresses/${addrId}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      if (data.success) setAddressList(data.addresses);
    } catch (err) { alert('Error: ' + err.message); }
  };

  const setDefaultAddress = async (addrId) => {
    try {
      const res = await fetch(`${API}/user/addresses/${addrId}`, {
        method: 'PATCH', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ isDefault: true })
      });
      const data = await res.json();
      if (data.success) setAddressList(data.addresses);
    } catch (err) { alert('Error: ' + err.message); }
  };

  const [wishlist, setWishlist] = useState([]);
  const fetchWishlist = async () => {
    try {
      const res = await fetch(`${API}/user/wishlist`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setWishlist(Array.isArray(data) ? data : []);
    } catch (err) { console.log(err); }
  };
  const isWishlisted = (medId) => wishlist.some(m => m._id === medId);
  const toggleWishlist = async (medId) => {
    try {
      if (isWishlisted(medId)) {
        await fetch(`${API}/user/wishlist/${medId}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
      } else {
        await fetch(`${API}/user/wishlist/${medId}`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
      }
      fetchWishlist();
    } catch (err) { console.log(err); }
  };

  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const fetchNotifications = async () => {
    try {
      const res = await fetch(`${API}/user/notifications`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setNotifications(data.notifications || []);
      setUnreadCount(data.unreadCount || 0);
    } catch (err) { console.log(err); }
  };
  const markAllNotificationsRead = async () => {
    try {
      await fetch(`${API}/user/notifications/read-all`, { method: 'PATCH', headers: { Authorization: `Bearer ${token}` } });
      fetchNotifications();
    } catch (err) { console.log(err); }
  };

  const [refills, setRefills] = useState([]);
  const fetchRefills = async () => { try { const res = await fetch(`${API}/user/refills`, { headers: { Authorization: `Bearer ${token}` } }); const data = await res.json(); setRefills(Array.isArray(data) ? data : []); } catch (err) { console.log(err); } };
  const removeRefill = async (id) => { try { await fetch(`${API}/user/refills/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } }); fetchRefills(); } catch (err) { console.log(err); } };
  const setRefillReminder = async (med) => { try { const res = await fetch(`${API}/user/refills`, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify({ medicineId: med._id, medicineName: med.name, intervalDays: 30 }) }); const data = await res.json(); if (data.success) alert('Refill reminder set for every 30 days!'); } catch (err) { alert('Error: ' + err.message); } };

  const [familyMembers, setFamilyMembers] = useState([]);
  const [newFamily, setNewFamily] = useState({name:'',relation:'',age:'',phone:''});
  const [showFamilyForm, setShowFamilyForm] = useState(false);
  const fetchFamily = async () => { try { const res = await fetch(`${API}/user/family`, { headers: { Authorization: `Bearer ${token}` } }); const data = await res.json(); setFamilyMembers(Array.isArray(data) ? data : []); } catch (err) { console.log(err); } };
  const addFamily = async () => { if (!newFamily.name || !newFamily.relation) { alert('Name and relation required'); return; } try { const res = await fetch(`${API}/user/family`, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify(newFamily) }); const data = await res.json(); if (data.success) { setFamilyMembers(data.familyMembers); setNewFamily({name:'',relation:'',age:'',phone:''}); setShowFamilyForm(false); } } catch (err) { alert('Error: ' + err.message); } };
  const removeFamily = async (id) => { try { const res = await fetch(`${API}/user/family/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } }); const data = await res.json(); if (data.success) setFamilyMembers(data.familyMembers); } catch (err) { alert('Error: ' + err.message); } };

  const [walletHistory, setWalletHistory] = useState([]);
  const fetchWalletHistory = async () => { try { const res = await fetch(`${API}/user/loyalty/history`, { headers: { Authorization: `Bearer ${token}` } }); const data = await res.json(); setWalletHistory(Array.isArray(data) ? data : []); } catch (err) { console.log(err); } };

  const [activeCoupons, setActiveCoupons] = useState([]);
  const fetchActiveCoupons = async () => { try { const res = await fetch(`${API}/coupons/active`); const data = await res.json(); setActiveCoupons(Array.isArray(data) ? data : []); } catch (err) { console.log(err); } };
  const copyCoupon = (code) => { navigator.clipboard.writeText(code).then(()=>alert(code+' copied!')); };
  const [paymentMethod, setPaymentMethod] = useState('online');
  const [prescFile, setPrescFile] = useState(null);
  const [recordType, setRecordType] = useState('prescription');
  const [prescUploading, setPrescUploading] = useState(false);
  const [prescMsg, setPrescMsg] = useState('');
  const [myPrescriptions, setMyPrescriptions] = useState([]);
  const fetchMyPrescriptions = async () => {
    try {
      const res = await fetch(`${API}/prescriptions/my`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setMyPrescriptions(Array.isArray(data) ? data : []);
    } catch (err) { console.log(err); }
  };
  const uploadPrescription = async () => {
    if (!prescFile) { setPrescMsg('படம் தேர்ந்தெடுக்கவும்'); return; }
    setPrescUploading(true);
    setPrescMsg('');
    try {
      const formData = new FormData();
      formData.append('prescription', prescFile);
      formData.append('recordType', recordType);
      const res = await fetch(`${API}/prescriptions/upload`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData
      });
      const data = await res.json();
      if (data.success) {
        setPrescMsg('✅ Prescription upload ஆனது! Vendor verify பண்ணும்.');
        setPrescFile(null);
        fetchMyPrescriptions();
      } else {
        setPrescMsg(data.error || 'Upload தோல்வியடைந்தது');
      }
    } catch (err) { setPrescMsg('Error: ' + err.message); }
    setPrescUploading(false);
  };

  const [userName, setUserName] = useState('');
  const [showEditProfile, setShowEditProfile] = useState(false);
  const [editNameInput, setEditNameInput] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userDob, setUserDob] = useState('');
  const [userGender, setUserGender] = useState('');
  const [editFirstName, setEditFirstName] = useState('');
  const [editLastName, setEditLastName] = useState('');
  const [editEmail, setEditEmail] = useState('');
  const [editDob, setEditDob] = useState('');
  const [editGender, setEditGender] = useState('');
  const fetchProfile = async () => { try { const res = await fetch(`${API}/user/profile`, { headers: { Authorization: `Bearer ${token}` } }); const data = await res.json(); setUserName(data.name || ''); setUserEmail(data.email || ''); setUserDob(data.dob ? data.dob.slice(0,10) : ''); setUserGender(data.gender || ''); if (data.phone) setPhone(data.phone); } catch (err) { console.log(err); } };
  const updateProfile = async () => { try { const res = await fetch(`${API}/user/profile`, { method: 'PATCH', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify({ firstName: editFirstName, lastName: editLastName, email: editEmail, dob: editDob, gender: editGender }) }); const data = await res.json(); if (data.success) { setUserName(data.user.name); setUserEmail(data.user.email||''); setUserDob(data.user.dob?data.user.dob.slice(0,10):''); setUserGender(data.user.gender||''); setShowEditProfile(false); } } catch (err) { alert('Error: ' + err.message); } };
  const requestReturn = async (orderId) => { const reason = window.prompt('Return reason?'); if (!reason) return; try { const res = await fetch(`${API}/orders/${orderId}/return`, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify({ reason }) }); const data = await res.json(); if (data.success) alert('Return request submitted'); else alert(data.error || 'Failed to submit return'); } catch (err) { alert('Error: ' + err.message); } };

  const [resendCooldown, setResendCooldown] = useState(0);
  useEffect(() => {
    if (resendCooldown <= 0) return;
    const t = setTimeout(() => setResendCooldown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [resendCooldown]);

  const sendOTP = async () => {
    if (phone.length !== 10) return alert('சரியான தொலைபேசி எண்');
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/send-otp`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone })
      });
      const data = await res.json();
      if (data.success) { setOtpSent(true); setOtp(''); setResendCooldown(45); if (data.otp) alert('OTP: ' + data.otp + ' (Testing mode)'); }
      else { alert(data.error || 'OTP அனுப்ப முடியவில்லை'); }
    } catch (err) { alert('Error: ' + err.message); }
    setLoading(false);
  };

  const verifyOTP = async () => {
    if (otp.length !== 4) return alert('4 இலக்க OTP');
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/verify-otp`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone, otp })
      });
      const data = await res.json();
      if (data.success) { localStorage.setItem('token', data.token); setToken(data.token); setScreen('app'); }
      else alert(data.error || 'தவறான OTP');
    } catch (err) { alert('Error: ' + err.message); }
    setLoading(false);
  };

  const addCart = (med) => {
    setCart(prev => {
      const ex = prev.find(i => i._id === med._id);
      if (ex) return prev.map(i => i._id === med._id ? {...i, qty: i.qty+1} : i);
      return [...prev, {...med, qty: 1}];
    });
  };

  const removeCart = (id) => setCart(prev => prev.filter(i => i._id !== id));
  const updateQty = (id, qty) => {
    if (qty <= 0) removeCart(id);
    else setCart(prev => prev.map(i => i._id === id ? {...i, qty} : i));
  };
  const cartCount = cart.reduce((a, i) => a + i.qty, 0);
  const cartTotal = cart.reduce((a, i) => a + i.price * i.qty, 0);

  const coinDiscount = useCoins ? Math.floor(coinsToRedeem / 100) : 0;
  const couponDiscount = appliedCoupon ? appliedCoupon.discount : 0;
  const finalTotal = Math.max(0, cartTotal - coinDiscount - couponDiscount);
  const applyCoupon = async () => {
    setCouponMsg('');
    if (!couponInput.trim()) return;
    try {
      const afterCoin = Math.max(0, cartTotal - coinDiscount);
      const res = await fetch(`${API}/coupons/validate?code=${encodeURIComponent(couponInput.trim())}&orderValue=${afterCoin}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      if (data.valid) { setAppliedCoupon(data); setCouponMsg('✅ Coupon applied!'); }
      else { setAppliedCoupon(null); setCouponMsg(data.error || 'Invalid coupon'); }
    } catch (err) { setCouponMsg('Error applying coupon'); }
  };

  const submitFinalOrder = async (address, razorpayIds) => {
    try {
      const res = await fetch(`${API}/orders`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          items: cart.map(i => ({ medicineId: i._id, name: i.name, price: i.price, qty: i.qty })),
          total: finalTotal, address, phone,
          paymentMethod: paymentMethod === 'online' ? 'Razorpay' : 'COD',
          couponCode: appliedCoupon ? appliedCoupon.code : undefined,
          coinsToRedeem: useCoins ? coinsToRedeem : 0,
          razorpay_order_id: razorpayIds ? razorpayIds.razorpay_order_id : undefined,
          razorpay_payment_id: razorpayIds ? razorpayIds.razorpay_payment_id : undefined
        })
      });
      const data = await res.json();
      if (data.success) {
        setLastOrder({ orderId: data.orderId, items: cart.map(i=>({name:i.name,qty:i.qty,price:i.price})), total: finalTotal, paymentMethod: paymentMethod==='online'?'Online Payment':'Cash on Delivery' });
        setCart([]); setPage('success'); setUseCoins(false); setCoinsToRedeem(0); setAppliedCoupon(null); setCouponInput(''); setCouponMsg('');
        fetchOrders(); fetchLoyalty();
      } else {
        alert(data.error || 'Order-ஐ create பண்ண முடியவில்லை');
      }
    } catch (err) { alert('Error: ' + err.message); }
    setLoading(false);
  };

  const placeOrder = async (address) => {
    setLoading(true);
    if (paymentMethod === 'cod') {
      await submitFinalOrder(address, null);
      return;
    }
    try {
      const orderRes = await fetch(`${API}/payment/create-order`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ amount: finalTotal, items: cart.map(i => ({ medicineId: i._id, name: i.name, price: i.price, qty: i.qty })), couponCode: appliedCoupon ? appliedCoupon.code : undefined, coinsToRedeem: useCoins ? coinsToRedeem : 0 })
      });
      const orderData = await orderRes.json();
      if (!orderData.success) { alert(orderData.error || 'Payment start பண்ண முடியவில்லை'); setLoading(false); return; }

      const rzp = new window.Razorpay({
        key: orderData.key,
        amount: orderData.amount,
        currency: orderData.currency,
        name: 'SashtiMedix',
        description: 'Medicine Order Payment',
        order_id: orderData.orderId,
        prefill: { contact: phone },
        theme: { color: primaryColor },
        handler: async function (response) {
          try {
            const verifyRes = await fetch(`${API}/payment/verify`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature
              })
            });
            const verifyData = await verifyRes.json();
            if (verifyData.success) {
              await submitFinalOrder(address, {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id
              });
            } else {
              alert('Payment verification தோல்வியடைந்தது');
              setLoading(false);
            }
          } catch (err) { alert('Error: ' + err.message); setLoading(false); }
        },
        modal: { ondismiss: function () { setLoading(false); } }
      });
      rzp.open();
    } catch (err) { alert('Error: ' + err.message); setLoading(false); }
  };

  const logout = () => { localStorage.removeItem('token'); setToken(''); setScreen('login'); setPhone(''); setOtp(''); setOtpSent(false); };

  const startVoiceSearch = () => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) { alert('Voice search-ஐ இந்த browser support பண்ணல'); return; }
    const recognition = new SpeechRecognition();
    recognition.lang = 'en-IN';
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;
    setVoiceListening(true);
    recognition.onresult = (e) => {
      const transcript = e.results[0][0].transcript;
      setSearch(transcript);
      setTab('search');
    };
    recognition.onerror = () => setVoiceListening(false);
    recognition.onend = () => setVoiceListening(false);
    recognition.start();
  };

  // Smart "AI" search suggestions - matches medicine name, generic name, or category
  const searchSuggestions = search.trim().length > 0
    ? medicines.filter(m =>
        m.name.toLowerCase().includes(search.toLowerCase()) ||
        (m.generic && m.generic.toLowerCase().includes(search.toLowerCase())) ||
        (m.category && m.category.toLowerCase().includes(search.toLowerCase()))
      ).slice(0, 5)
    : [];


  // STYLES
  const primaryColor = '#0058C6';
  const secondaryColor = '#278018';
  const accentColor = '#E63950';

  // LOGIN SCREEN
  if (screen === 'login') return (
    <div style={{minHeight:'100vh',background:'linear-gradient(180deg,#f0f7ff 0%,#ffffff 100%)',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'20px'}}>
      <div style={{marginBottom:'32px',textAlign:'center'}}>
        <img src="/logo.jpeg" alt="Sashtimedix" style={{width:'150px',height:'150px',objectFit:'contain',marginBottom:'12px',borderRadius:'20px',boxShadow:'0 8px 24px rgba(0,82,204,0.15)'}} onError={e=>{e.target.style.display='none';}}/>
        <h1 style={{color:primaryColor,margin:'0 0 4px',fontSize:'28px',fontWeight:'800',letterSpacing:'-0.5px'}}>Sashtimedix</h1>
        <p style={{color:secondaryColor,fontSize:'13px',margin:'0 0 2px',fontWeight:'600'}}>Precision in every product</p>
        <p style={{color:'#666',fontSize:'12px',margin:0}}>📍 Tamil Nadu</p>
      </div>

      <div style={{background:'white',padding:'32px 28px',borderRadius:'24px',width:'100%',maxWidth:'380px',boxShadow:'0 20px 60px rgba(0,0,0,0.08)',border:'1px solid #f0f0f0'}}>
        <h2 style={{color:'#1a1a1a',margin:'0 0 6px',fontSize:'22px',fontWeight:'700'}}>{otpSent?'Verify OTP':'Login / Sign Up'}</h2>
        <p style={{color:'#666',fontSize:'13px',margin:'0 0 24px'}}>{otpSent?`OTP sent to +91 ${phone}`:'Enter your mobile number to continue'}</p>

        {!otpSent ? (
          <>
            <div style={{position:'relative',marginBottom:'16px'}}>
              <div style={{position:'absolute',left:'14px',top:'50%',transform:'translateY(-50%)',color:'#333',fontSize:'15px',fontWeight:'600'}}>+91</div>
              <input type="tel" placeholder="10-digit mobile number" value={phone} onChange={e=>setPhone(e.target.value)} maxLength={10}
                style={{width:'100%',padding:'14px 14px 14px 52px',fontSize:'16px',borderRadius:'12px',border:'2px solid #e0e0e0',boxSizing:'border-box',outline:'none',fontWeight:'500',transition:'border 0.2s'}}
                onFocus={e=>e.target.style.border='2px solid '+primaryColor}
                onBlur={e=>e.target.style.border='2px solid #e0e0e0'}/>
            </div>
            <button onClick={sendOTP} disabled={loading || phone.length!==10}
              style={{width:'100%',padding:'15px',fontSize:'16px',fontWeight:'700',background:phone.length===10?`linear-gradient(135deg,${primaryColor},#0783ED)`:'#e0e0e0',color:phone.length===10?'white':'#999',border:'none',borderRadius:'12px',cursor:phone.length===10?'pointer':'not-allowed',transition:'all 0.2s'}}>
              {loading?'Sending OTP...':'Request OTP →'}
            </button>
          </>
        ) : (
          <>
            <div style={{display:'flex',gap:'8px',marginBottom:'20px',justifyContent:'center'}}>
              {[0,1,2,3].map(i=>(
                <input key={i} type="tel" maxLength={1} value={otp[i]||''}
                  onChange={e=>{const newOtp=otp.split('');newOtp[i]=e.target.value;setOtp(newOtp.join(''));if(e.target.value&&e.target.nextSibling)e.target.nextSibling.focus();}}
                  style={{width:'56px',height:'56px',textAlign:'center',fontSize:'24px',fontWeight:'700',borderRadius:'12px',border:'2px solid #e0e0e0',outline:'none',color:primaryColor}}
                  onFocus={e=>e.target.style.border='2px solid '+primaryColor}
                  onBlur={e=>e.target.style.border='2px solid #e0e0e0'}/>
              ))}
            </div>
            <button onClick={verifyOTP} disabled={loading || otp.length!==4}
              style={{width:'100%',padding:'15px',fontSize:'16px',fontWeight:'700',background:otp.length===4?`linear-gradient(135deg,${primaryColor},#0783ED)`:'#e0e0e0',color:otp.length===4?'white':'#999',border:'none',borderRadius:'12px',cursor:otp.length===4?'pointer':'not-allowed'}}>
              {loading?'Verifying...':'Verify & Login →'}
            </button>
            <div style={{textAlign:'center',marginTop:'14px'}}>
              {resendCooldown>0?(
                <p style={{color:'#999',fontSize:'13px',margin:0}}>Resend OTP in {resendCooldown}s</p>
              ):(
                <p onClick={sendOTP} style={{color:primaryColor,cursor:'pointer',fontSize:'13px',fontWeight:'700',margin:0}}>🔁 Resend OTP</p>
              )}
              <p onClick={()=>{setOtpSent(false);setOtp('');}} style={{textAlign:'center',color:'#999',cursor:'pointer',marginTop:'10px',fontSize:'12px',fontWeight:'600'}}>← Change Number</p>
            </div>
          </>
        )}
      </div>

      <div style={{marginTop:'24px',display:'flex',gap:'24px',justifyContent:'center'}}>
        {[['🚀','30 Min Delivery'],['💊','100% Genuine'],['🔒','Secure Payment']].map(([icon,text],i)=>(
          <div key={i} style={{textAlign:'center'}}>
            <div style={{fontSize:'20px'}}>{icon}</div>
            <div style={{color:'#666',fontSize:'11px',marginTop:'4px'}}>{text}</div>
          </div>
        ))}
      </div>
    </div>
  );

  // MEDICINE DETAIL PAGE
  if (medDetail) return (
    <div className="app-shell animate-in" style={{fontFamily:'-apple-system,BlinkMacSystemFont,sans-serif',minHeight:'100vh',background:'#f8f9fa'}}>
      <div style={{background:'white',padding:'12px 16px',display:'flex',alignItems:'center',gap:'12px',boxShadow:'0 1px 4px rgba(0,0,0,0.08)',position:'sticky',top:0,zIndex:100}}>
        <button onClick={()=>setMedDetail(null)} style={{background:'#f5f5f5',border:'none',borderRadius:'50%',width:'36px',height:'36px',cursor:'pointer',fontSize:'18px',display:'flex',alignItems:'center',justifyContent:'center'}}>←</button>
        <h2 style={{margin:0,fontSize:'16px',fontWeight:'700',color:'#1a1a1a',flex:1}}>Product Details</h2>
        <button onClick={()=>setTab('cart')} style={{background:'none',border:'none',cursor:'pointer',position:'relative',fontSize:'22px'}}>
          🛒{cartCount>0&&<span key={cartCount} className="cart-bump" style={{position:'absolute',top:'-6px',right:'-6px',background:accentColor,color:'white',borderRadius:'50%',width:'18px',height:'18px',fontSize:'10px',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:'bold'}}>{cartCount}</span>}
        </button>
      </div>

      <div style={{background:'white',margin:'8px',borderRadius:'16px',overflow:'hidden',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
        <div style={{background:'linear-gradient(135deg,#f0f7ff,#e8f5e9)',padding:'40px 30px',textAlign:'center',position:'relative',minHeight:'200px',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
          <div style={{fontSize:'100px',marginBottom:'8px',filter:'drop-shadow(0 8px 16px rgba(0,0,0,0.12))'}}>💊</div>
          {medDetail.rx&&<span style={{background:'#ff3b30',color:'white',fontSize:'11px',padding:'4px 10px',borderRadius:'20px',fontWeight:'700'}}>Rx REQUIRED</span>}
          <button onClick={()=>toggleWishlist(medDetail._id)} style={{position:'absolute',top:'16px',right:'16px',background:'white',border:'none',borderRadius:'50%',width:'36px',height:'36px',fontSize:'18px',cursor:'pointer',boxShadow:'0 2px 6px rgba(0,0,0,0.15)'}}>
            {isWishlisted(medDetail._id)?'❤️':'🤍'}
          </button>
        </div>
        <div style={{padding:'20px'}}>
          <h1 style={{margin:'0 0 6px',fontSize:'22px',fontWeight:'800',color:'#1a1a1a'}}>{medDetail.name}</h1>
          <p style={{color:'#666',fontSize:'14px',margin:'0 0 8px'}}>{medDetail.generic}</p>
          <div style={{display:'flex',alignItems:'center',gap:'6px',marginBottom:'12px'}}>
            <span style={{color:'#f5a623',fontSize:'14px'}}>{'⭐'.repeat(Math.round(productReviews.avgRating)||0) || '☆'}</span>
            <span style={{fontSize:'13px',fontWeight:'700',color:'#555'}}>{productReviews.avgRating>0?productReviews.avgRating:'No ratings yet'}</span>
            {productReviews.count>0&&<span style={{fontSize:'12px',color:'#999'}}>({productReviews.count} review{productReviews.count>1?'s':''})</span>}
          </div>
          <div style={{display:'flex',alignItems:'center',gap:'12px',marginBottom:'20px'}}>
            <span style={{fontSize:'28px',fontWeight:'800',color:primaryColor}}>₹{medDetail.price}</span>
            <span style={{color:'#999',textDecoration:'line-through',fontSize:'16px'}}>₹{medDetail.mrp}</span>
            <span style={{background:'#e8f5e9',color:secondaryColor,padding:'4px 10px',borderRadius:'20px',fontSize:'13px',fontWeight:'700'}}>{Math.round((medDetail.mrp-medDetail.price)/medDetail.mrp*100)}% OFF</span>
          </div>

          {/* TRUST BADGES */}
          <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'8px',marginBottom:'16px'}}>
            {[['✅','100% Genuine'],['🏥','Licensed Pharmacy'],['🔒','Secure Payment']].map(([icon,label],i)=>(
              <div key={i} style={{background:'#f8f9fa',borderRadius:'10px',padding:'10px 6px',textAlign:'center',border:'1px solid #f0f0f0'}}>
                <div style={{fontSize:'18px',marginBottom:'4px'}}>{icon}</div>
                <div style={{fontSize:'10px',fontWeight:'700',color:'#555',lineHeight:'1.2'}}>{label}</div>
              </div>
            ))}
          </div>

          {/* DELIVERY ESTIMATE */}
          <div style={{background:'#e8f5e9',borderRadius:'10px',padding:'12px 14px',marginBottom:'16px',display:'flex',alignItems:'center',gap:'10px'}}>
            <span style={{fontSize:'22px'}}>🛵</span>
            <div>
              <div style={{fontWeight:'700',color:'#2e7d32',fontSize:'13px'}}>Get it by tomorrow</div>
              <div style={{color:'#555',fontSize:'11px'}}>Free delivery on orders above ₹200</div>
            </div>
          </div>

          <div style={{display:'flex',gap:'8px'}}>
            {cart.find(i=>i._id===medDetail._id) ? (
              <div style={{flex:1,display:'flex',alignItems:'center',justifyContent:'space-between',background:primaryColor,borderRadius:'12px',padding:'4px'}}>
                <button onClick={()=>updateQty(medDetail._id,(cart.find(i=>i._id===medDetail._id)?.qty||1)-1)} style={{background:'rgba(255,255,255,0.2)',border:'none',color:'white',width:'40px',height:'40px',borderRadius:'10px',cursor:'pointer',fontSize:'20px',fontWeight:'bold'}}>−</button>
                <span style={{color:'white',fontWeight:'700',fontSize:'18px'}}>{cart.find(i=>i._id===medDetail._id)?.qty||0}</span>
                <button onClick={()=>addCart(medDetail)} style={{background:'rgba(255,255,255,0.2)',border:'none',color:'white',width:'40px',height:'40px',borderRadius:'10px',cursor:'pointer',fontSize:'20px',fontWeight:'bold'}}>+</button>
              </div>
            ):(
              <button onClick={()=>addCart(medDetail)} style={{flex:1,padding:'14px',background:`linear-gradient(135deg,${primaryColor},#0783ED)`,color:'white',border:'none',borderRadius:'12px',fontSize:'15px',fontWeight:'700',cursor:'pointer'}}>
                + Add to Cart
              </button>
            )}
          </div>
          <button onClick={()=>setRefillReminder(medDetail)} style={{width:'100%',marginTop:'10px',padding:'11px',background:'#f0f7ff',color:primaryColor,border:`1px dashed ${primaryColor}`,borderRadius:'10px',fontSize:'13px',fontWeight:'700',cursor:'pointer'}}>
            🔔 Set Refill Reminder (every 30 days)
          </button>
        </div>
      </div>

      {[
        {title:'Product Details',icon:'📋',content:[
          ['Generic Name',medDetail.generic||'-'],
          ['Category',medDetail.category||'-'],
          ['Schedule',medDetail.schedule||'OTC'],
          ['Drug Type',medDetail.drugType||'Tablet'],
          ['GST',`${medDetail.gstPercent||12}%`],
          ['HSN Code',medDetail.hsnCode||'3004'],
        ]},
        {title:'Uses & Benefits',icon:'✅',items:
          medDetail.category==='காய்ச்சல்'?['Fever & Pain relief','Headache','Body temperature control']:
          medDetail.category==='சர்க்கரை'?['Blood sugar control','Type 2 Diabetes','Insulin sensitivity']:
          medDetail.category==='BP'?['Blood pressure control','Heart disease prevention','Angina']:
          medDetail.category==='வைட்டமின்'?['Bone strength','Immunity boost','Fatigue reduction']:
          ['Use as directed by physician','Relieves symptoms']},
        {title:'Side Effects',icon:'⚠️',items:['Nausea or vomiting','Dizziness','Stomach discomfort (rare)','Allergic reaction (very rare)']},
      ].map((section,idx)=>(
        <div key={idx} style={{background:'white',margin:'8px',borderRadius:'16px',padding:'18px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
          <h3 style={{margin:'0 0 14px',fontSize:'16px',fontWeight:'700',color:'#1a1a1a',display:'flex',alignItems:'center',gap:'8px'}}><span>{section.icon}</span>{section.title}</h3>
          {section.content&&section.content.map(([label,val],i)=>(
            <div key={i} style={{display:'flex',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid #f5f5f5',fontSize:'13px'}}>
              <span style={{color:'#666'}}>{label}</span>
              <span style={{color:'#1a1a1a',fontWeight:'600'}}>{val}</span>
            </div>
          ))}
          {section.items&&section.items.map((item,i)=>(
            <div key={i} style={{display:'flex',gap:'10px',marginBottom:'8px',fontSize:'14px',color:'#444'}}>
              <span style={{color:idx===2?'#e65100':secondaryColor,fontWeight:'bold'}}>{idx===2?'•':'✓'}</span><span>{item}</span>
            </div>
          ))}
        </div>
      ))}

      <div style={{background:'white',margin:'8px',borderRadius:'16px',padding:'18px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
        <h3 style={{margin:'0 0 14px',fontSize:'16px',fontWeight:'700',color:'#1a1a1a',display:'flex',alignItems:'center',gap:'8px'}}><span>⭐</span>Ratings & Reviews</h3>

        {/* Submit a review */}
        <div style={{background:'#f8f9fa',borderRadius:'12px',padding:'14px',marginBottom:'14px'}}>
          <div style={{fontSize:'13px',fontWeight:'600',color:'#555',marginBottom:'8px'}}>Rate this product</div>
          <div style={{display:'flex',gap:'6px',marginBottom:'10px'}}>
            {[1,2,3,4,5].map(n=>(
              <span key={n} onClick={()=>setMyRating(n)} style={{fontSize:'26px',cursor:'pointer',opacity:n<=myRating?1:0.3}}>⭐</span>
            ))}
          </div>
          <textarea value={myComment} onChange={e=>setMyComment(e.target.value)} placeholder="Your review (optional)"
            style={{width:'100%',minHeight:'60px',padding:'10px',borderRadius:'8px',border:'1px solid #ddd',fontSize:'13px',fontFamily:'inherit',boxSizing:'border-box',resize:'vertical'}}/>
          <button onClick={submitReview} disabled={submittingReview} style={{marginTop:'8px',padding:'10px 18px',background:primaryColor,color:'white',border:'none',borderRadius:'10px',fontSize:'13px',fontWeight:'700',cursor:submittingReview?'default':'pointer',opacity:submittingReview?0.6:1}}>
            {submittingReview?'Submitting...':'Submit Review'}
          </button>
        </div>

        {/* Existing reviews */}
        {productReviews.reviews.length===0 ? (
          <p style={{color:'#999',fontSize:'13px',textAlign:'center',padding:'10px 0'}}>இன்னும் reviews இல்ல. முதலில் நீங்க review பண்ணுங்க!</p>
        ) : productReviews.reviews.map((rv,i)=>(
          <div key={i} style={{padding:'10px 0',borderBottom:i<productReviews.reviews.length-1?'1px solid #f0f0f0':'none'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'4px'}}>
              <span style={{fontWeight:'700',fontSize:'13px',color:'#1a1a1a'}}>{rv.userName}</span>
              <span style={{color:'#f5a623',fontSize:'12px'}}>{'⭐'.repeat(rv.rating)}</span>
            </div>
            {rv.comment&&<p style={{margin:0,fontSize:'13px',color:'#555'}}>{rv.comment}</p>}
          </div>
        ))}
      </div>

      {substitutes.length>0&&(
        <div style={{background:'white',margin:'8px',borderRadius:'16px',padding:'18px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)',marginBottom:'16px',border:'1.5px solid #c8e6c9'}}>
          <h3 style={{margin:'0 0 4px',fontSize:'16px',fontWeight:'700',color:'#1a1a1a',display:'flex',alignItems:'center',gap:'6px'}}>💰 Cheaper Alternatives</h3>
          <p style={{margin:'0 0 14px',fontSize:'11px',color:'#888'}}>Same composition ({medDetail.generic}), lower price</p>
          <div style={{display:'flex',gap:'10px',overflowX:'auto',paddingBottom:'4px'}}>
            {substitutes.map((m,i)=>(
              <div key={i} onClick={()=>setMedDetail(m)} style={{background:'#f0fffe',borderRadius:'12px',padding:'12px',cursor:'pointer',minWidth:'140px',border:'1px solid #c8e6c9',position:'relative'}}>
                {m.savings>0&&<div style={{position:'absolute',top:'6px',right:'6px',background:secondaryColor,color:'white',fontSize:'9px',fontWeight:'800',padding:'2px 6px',borderRadius:'6px'}}>Save ₹{m.savings}</div>}
                <div style={{fontSize:'28px',marginBottom:'6px'}}>💊</div>
                <div style={{fontWeight:'700',color:primaryColor,fontSize:'12px',marginBottom:'2px'}}>{m.name}</div>
                <div style={{display:'flex',alignItems:'center',gap:'4px'}}>
                  <span style={{color:secondaryColor,fontSize:'13px',fontWeight:'800'}}>₹{m.price}</span>
                  {m.mrp>m.price&&<span style={{color:'#999',textDecoration:'line-through',fontSize:'10px'}}>₹{m.mrp}</span>}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {medicines.filter(m=>m.category===medDetail.category&&m._id!==medDetail._id).length>0&&(
        <div style={{background:'white',margin:'8px',borderRadius:'16px',padding:'18px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)',marginBottom:'16px'}}>
          <h3 style={{margin:'0 0 14px',fontSize:'16px',fontWeight:'700',color:'#1a1a1a'}}>Similar Products</h3>
          <div style={{display:'flex',gap:'10px',overflowX:'auto',paddingBottom:'4px'}}>
            {medicines.filter(m=>m.category===medDetail.category&&m._id!==medDetail._id).slice(0,6).map((m,i)=>(
              <div key={i} onClick={()=>setMedDetail(m)} style={{background:'#f8f9fa',borderRadius:'12px',padding:'12px',cursor:'pointer',minWidth:'130px',border:'1px solid #f0f0f0'}}>
                <div style={{fontSize:'32px',textAlign:'center',marginBottom:'6px'}}>💊</div>
                <div style={{fontWeight:'700',color:primaryColor,fontSize:'12px',marginBottom:'2px'}}>{m.name}</div>
                <div style={{color:secondaryColor,fontSize:'13px',fontWeight:'700'}}>₹{m.price}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );

  // CHECKOUT PAGE
  if (page === 'addresses') return (
    <div className="app-shell animate-in" style={{minHeight:'100vh',background:'#f8f9fa'}}>
      <div style={{background:'white',padding:'14px 16px',display:'flex',alignItems:'center',gap:'12px',boxShadow:'0 2px 6px rgba(0,0,0,0.06)',position:'sticky',top:0,zIndex:10}}>
        <button onClick={()=>setPage('')} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer'}}>←</button>
        <h2 style={{margin:0,fontSize:'18px',fontWeight:'700'}}>My Addresses</h2>
      </div>
      <div style={{padding:'16px'}}>
        {addressList.length===0 && !showAddrForm && (
          <div style={{textAlign:'center',padding:'40px',color:'#999'}}>No saved addresses yet</div>
        )}
        {addressList.map(addr=>(
          <div key={addr._id} style={{background:'white',borderRadius:'14px',padding:'14px',marginBottom:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'6px'}}>
              <span style={{fontWeight:'800',color:primaryColor,fontSize:'13px'}}>{addr.label}{addr.isDefault?' ⭐ Default':''}</span>
              <div style={{display:'flex',gap:'10px'}}>
                {!addr.isDefault && <span onClick={()=>setDefaultAddress(addr._id)} style={{color:primaryColor,fontSize:'12px',fontWeight:'700',cursor:'pointer'}}>Set Default</span>}
                <span onClick={()=>deleteAddress(addr._id)} style={{color:'#c62828',fontSize:'12px',fontWeight:'700',cursor:'pointer'}}>Delete</span>
              </div>
            </div>
            <div style={{fontSize:'14px',color:'#333',fontWeight:'600'}}>{addr.name}</div>
            <div style={{fontSize:'13px',color:'#666',marginTop:'2px'}}>{addr.street}, {addr.area}, {addr.city} - {addr.pincode}</div>
            {addr.phone && <div style={{fontSize:'12px',color:'#999',marginTop:'2px'}}>📞 {addr.phone}</div>}
          </div>
        ))}
        {showAddrForm ? (
          <div style={{background:'white',borderRadius:'14px',padding:'16px',marginTop:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
            <input placeholder="Label (Home/Work/Other)" value={newAddr.label} onChange={e=>setNewAddr({...newAddr,label:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
            <input placeholder="Full Name *" value={newAddr.name} onChange={e=>setNewAddr({...newAddr,name:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
            <input placeholder="Phone" value={newAddr.phone} onChange={e=>setNewAddr({...newAddr,phone:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
            <input placeholder="Street / House No *" value={newAddr.street} onChange={e=>setNewAddr({...newAddr,street:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
            <input placeholder="Area / Locality" value={newAddr.area} onChange={e=>setNewAddr({...newAddr,area:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
            <div style={{display:'flex',gap:'10px'}}>
              <input placeholder="City *" value={newAddr.city} onChange={e=>setNewAddr({...newAddr,city:e.target.value})} style={{flex:1,padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
              <input placeholder="Pincode *" value={newAddr.pincode} onChange={e=>setNewAddr({...newAddr,pincode:e.target.value})} style={{flex:1,padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
            </div>
            <div style={{display:'flex',gap:'10px'}}>
              <button onClick={()=>setShowAddrForm(false)} style={{flex:1,padding:'13px',background:'#f0f0f0',color:'#666',border:'none',borderRadius:'10px',fontSize:'14px',fontWeight:'700',cursor:'pointer'}}>Cancel</button>
              <button onClick={addAddress} style={{flex:1,padding:'13px',background:primaryColor,color:'white',border:'none',borderRadius:'10px',fontSize:'14px',fontWeight:'700',cursor:'pointer'}}>Save Address</button>
            </div>
          </div>
        ) : (
          <button onClick={()=>setShowAddrForm(true)} style={{width:'100%',padding:'14px',background:'#f0f7ff',color:primaryColor,border:`1px dashed ${primaryColor}`,borderRadius:'12px',fontSize:'14px',fontWeight:'700',cursor:'pointer',marginTop:'6px'}}>+ Add New Address</button>
        )}
      </div>
    </div>
  );

  if (page === 'wishlist') return (
    <div className="app-shell animate-in" style={{minHeight:'100vh',background:'#f8f9fa'}}>
      <div style={{background:'white',padding:'14px 16px',display:'flex',alignItems:'center',gap:'12px',boxShadow:'0 2px 6px rgba(0,0,0,0.06)',position:'sticky',top:0,zIndex:10}}>
        <button onClick={()=>setPage('')} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer'}}>←</button>
        <h2 style={{margin:0,fontSize:'18px',fontWeight:'700'}}>🔖 Saved for Later {wishlist.length>0?`(${wishlist.length})`:''}</h2>
      </div>
      <div style={{padding:'16px'}}>
        {wishlist.length===0?(
          <div style={{textAlign:'center',padding:'60px 20px',background:'white',borderRadius:'16px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
            <div style={{fontSize:'56px',marginBottom:'12px'}}>🔖</div>
            <h3 style={{color:'#1a1a1a',fontWeight:'700',marginBottom:'6px'}}>No saved medicines yet</h3>
            <p style={{color:'#666',fontSize:'13px',marginBottom:'20px'}}>Tap the heart icon on any product to save it here</p>
            <button onClick={()=>{setPage('');setTab('search');}} style={{padding:'12px 28px',background:`linear-gradient(135deg,${primaryColor},#0783ED)`,color:'white',border:'none',borderRadius:'12px',fontSize:'14px',fontWeight:'700',cursor:'pointer'}}>Browse Medicines</button>
          </div>
        ):(
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px'}}>
        {wishlist.map(med=>(
          <div key={med._id} className="med-card" onClick={()=>{setMedDetail(med);setPage('');}} style={{background:'white',borderRadius:'16px',padding:'14px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)',border:'1px solid #f0f0f0',cursor:'pointer',position:'relative'}}>
            <button onClick={(e)=>{e.stopPropagation();toggleWishlist(med._id);}} style={{position:'absolute',top:'8px',right:'8px',background:'white',border:'none',borderRadius:'50%',width:'26px',height:'26px',fontSize:'12px',cursor:'pointer',boxShadow:'0 2px 6px rgba(0,0,0,0.15)',color:'#c62828'}}>✕</button>
            <div style={{fontSize:'40px',textAlign:'center',marginBottom:'8px'}}>💊</div>
            <div style={{fontWeight:'700',fontSize:'13px',color:'#1a1a1a'}}>{med.name}</div>
            <div style={{color:'#666',fontSize:'11px',marginBottom:'6px'}}>{med.generic}</div>
            <div style={{display:'flex',alignItems:'center',gap:'6px',marginBottom:'8px'}}>
              <span style={{fontWeight:'800',color:primaryColor,fontSize:'14px'}}>₹{med.price}</span>
              {med.mrp>med.price&&<span style={{color:'#999',textDecoration:'line-through',fontSize:'11px'}}>₹{med.mrp}</span>}
            </div>
            <button onClick={(e)=>{e.stopPropagation();addCart(med);}} style={{width:'100%',padding:'8px',background:cart.find(i=>i._id===med._id)?secondaryColor:primaryColor,color:'white',border:'none',borderRadius:'8px',fontSize:'11px',fontWeight:'700',cursor:'pointer'}}>{cart.find(i=>i._id===med._id)?'✓ Added':'+ Add to Cart'}</button>
          </div>
        ))}
        </div>
        )}
      </div>
    </div>
  );

  if (page === 'notifications') return (
    <div className="app-shell animate-in" style={{minHeight:'100vh',background:'#f8f9fa'}}>
      <div style={{background:'white',padding:'14px 16px',display:'flex',alignItems:'center',justifyContent:'space-between',boxShadow:'0 2px 6px rgba(0,0,0,0.06)',position:'sticky',top:0,zIndex:10}}>
        <div style={{display:'flex',alignItems:'center',gap:'12px'}}>
          <button onClick={()=>setPage('')} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer'}}>←</button>
          <h2 style={{margin:0,fontSize:'18px',fontWeight:'700'}}>🔔 Notifications</h2>
        </div>
        {unreadCount>0&&<span onClick={markAllNotificationsRead} style={{color:primaryColor,fontSize:'12px',fontWeight:'700',cursor:'pointer'}}>Mark all read</span>}
      </div>
      <div style={{padding:'16px'}}>
        {notifications.length===0&&(
          <div style={{textAlign:'center',padding:'60px 20px',background:'white',borderRadius:'16px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
            <div style={{fontSize:'56px',marginBottom:'12px'}}>🔔</div>
            <h3 style={{color:'#1a1a1a',fontWeight:'700',marginBottom:'6px'}}>No notifications yet</h3>
            <p style={{color:'#666',fontSize:'13px'}}>Order updates and offers will show up here</p>
          </div>
        )}
        {notifications.map(n=>(
          <div key={n._id} style={{background:n.read?'white':'#f0f7ff',borderRadius:'14px',padding:'14px',marginBottom:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)',borderLeft:n.read?'none':`3px solid ${primaryColor}`,display:'flex',gap:'12px'}}>
            <div style={{width:'36px',height:'36px',borderRadius:'10px',background:n.read?'#f5f5f5':'#e3f2fd',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'16px',flexShrink:0}}>
              {(n.title||'').toLowerCase().includes('order')?'📦':(n.title||'').toLowerCase().includes('offer')||(n.title||'').toLowerCase().includes('discount')?'🏷️':(n.title||'').toLowerCase().includes('deliver')?'🚚':'🔔'}
            </div>
            <div style={{flex:1}}>
              <div style={{fontWeight:'700',fontSize:'13px',color:'#1a1a1a'}}>{n.title}</div>
              <div style={{color:'#555',fontSize:'12px',marginTop:'4px'}}>{n.message}</div>
              <div style={{color:'#999',fontSize:'11px',marginTop:'6px'}}>{new Date(n.createdAt).toLocaleString()}</div>
            </div>
            {!n.read&&<div style={{width:'8px',height:'8px',borderRadius:'50%',background:primaryColor,flexShrink:0,marginTop:'4px'}}></div>}
          </div>
        ))}
      </div>
    </div>
  );

  if (page === 'refills') return (
    <div className="app-shell animate-in" style={{minHeight:'100vh',background:'#f8f9fa'}}>
      <div style={{background:'white',padding:'14px 16px',display:'flex',alignItems:'center',gap:'12px',boxShadow:'0 2px 6px rgba(0,0,0,0.06)',position:'sticky',top:0,zIndex:10}}>
        <button onClick={()=>setPage('')} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer'}}>←</button>
        <h2 style={{margin:0,fontSize:'18px',fontWeight:'700'}}>My Subscriptions</h2>
      </div>
      <div style={{padding:'16px'}}>
        <div style={{color:'#666',fontSize:'12px',marginBottom:'14px'}}>Set a refill reminder from a medicine page. We will remind you when it is time to reorder.</div>
        {refills.length===0&&<div style={{textAlign:'center',padding:'40px',color:'#999'}}>No refill reminders set</div>}
        {refills.map(r=>(
          <div key={r._id} style={{background:'white',borderRadius:'14px',padding:'14px',marginBottom:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div>
                <div style={{fontWeight:'700',fontSize:'14px',color:'#1a1a1a'}}>{r.medicineName}</div>
                <div style={{fontSize:'12px',color:r.isDue?'#c62828':'#666',marginTop:'2px'}}>{r.isDue?'Refill due now!':(r.daysRemaining+' days remaining')} (every {r.intervalDays} days)</div>
              </div>
              <span onClick={()=>removeRefill(r._id)} style={{color:'#c62828',fontSize:'12px',fontWeight:'700',cursor:'pointer'}}>Remove</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  if (page === 'support') return (
    <div className="app-shell animate-in" style={{minHeight:'100vh',background:'#f8f9fa'}}>
      <div style={{background:'white',padding:'14px 16px',display:'flex',alignItems:'center',gap:'12px',boxShadow:'0 2px 6px rgba(0,0,0,0.06)',position:'sticky',top:0,zIndex:10}}>
        <button onClick={()=>setPage('')} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer'}}>←</button>
        <h2 style={{margin:0,fontSize:'18px',fontWeight:'700'}}>Help & Support</h2>
      </div>
      <div style={{padding:'16px'}}>
        <div style={{background:'white',borderRadius:'16px',padding:'16px',marginBottom:'16px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
          <div style={{fontWeight:'800',fontSize:'15px',marginBottom:'10px'}}>Contact Us</div>
          <a href="tel:+919876543210" style={{display:'block',padding:'12px',background:'#f0fffe',borderRadius:'10px',marginBottom:'8px',textDecoration:'none',color:'#1a1a1a',fontSize:'13px',fontWeight:'600'}}>📞 Call: +91 98765 43210</a>
          <a href="https://wa.me/919876543210" target="_blank" rel="noreferrer" style={{display:'block',padding:'12px',background:'#f0fffe',borderRadius:'10px',marginBottom:'8px',textDecoration:'none',color:'#1a1a1a',fontSize:'13px',fontWeight:'600'}}>💬 WhatsApp Support</a>
          <a href="mailto:support@sashtimedix.in" style={{display:'block',padding:'12px',background:'#f0fffe',borderRadius:'10px',textDecoration:'none',color:'#1a1a1a',fontSize:'13px',fontWeight:'600'}}>✉️ support@sashtimedix.in</a>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'16px'}}>
          <div onClick={()=>{setPage('');setTab('orders');fetchOrders();}} style={{background:'white',borderRadius:'14px',padding:'14px',textAlign:'center',boxShadow:'0 2px 8px rgba(0,0,0,0.06)',cursor:'pointer'}}>
            <div style={{fontSize:'24px',marginBottom:'6px'}}>📦</div>
            <div style={{fontSize:'12px',fontWeight:'700',color:'#1a1a1a'}}>Track an Order</div>
          </div>
          <div onClick={()=>setPage('legal')} style={{background:'white',borderRadius:'14px',padding:'14px',textAlign:'center',boxShadow:'0 2px 8px rgba(0,0,0,0.06)',cursor:'pointer'}}>
            <div style={{fontSize:'24px',marginBottom:'6px'}}>↩️</div>
            <div style={{fontSize:'12px',fontWeight:'700',color:'#1a1a1a'}}>Returns & Refunds</div>
          </div>
        </div>
        {[
          {title:'Orders & Delivery',icon:'📦',faqs:[['How do I track my order?','Go to My Orders and tap Track Order to see live status.'],['How do I cancel an order?','You can cancel from My Orders before it is shipped.'],['What are the delivery charges?','Free above ₹200, small fee applies below that.']]},
          {title:'Returns & Refunds',icon:'↩️',faqs:[['How do I return an order?','Tap Return on any delivered order and provide a reason.'],['When will I get my refund?','Approved refunds are processed within 5-7 business days.']]},
          {title:'Prescriptions',icon:'📋',faqs:[['Do you deliver Rx medicines?','Yes, upload a valid prescription during checkout.'],['Are your medicines genuine?','Yes, sourced only from licensed pharmacy partners.']]},
          {title:'Payments & Wallet',icon:'💳',faqs:[['What payment methods are accepted?','UPI, Cards, Netbanking, and Cash on Delivery.'],['How does the loyalty wallet work?','Earn coins on every order, redeemable for discounts.']]},
          {title:'Account',icon:'👤',faqs:[['How do I update my profile?','Go to Profile → View & Edit Profile.'],['How do I delete my account?','Contact support@sashtimedix.in.']]},
        ].map((cat,ci)=>(
          <div key={ci} style={{background:'white',borderRadius:'16px',padding:'16px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)',marginBottom:'12px'}}>
            <div style={{fontWeight:'800',fontSize:'15px',marginBottom:'12px',display:'flex',alignItems:'center',gap:'8px'}}><span>{cat.icon}</span>{cat.title}</div>
            {cat.faqs.map(([q,a],i)=>(
              <div key={i} style={{marginBottom:i<cat.faqs.length-1?'14px':0,paddingBottom:i<cat.faqs.length-1?'14px':0,borderBottom:i<cat.faqs.length-1?'1px solid #f5f5f5':'none'}}>
                <div style={{fontWeight:'700',fontSize:'13px',color:'#1a1a1a',marginBottom:'4px'}}>{q}</div>
                <div style={{fontSize:'12px',color:'#666',lineHeight:'1.5'}}>{a}</div>
              </div>
            ))}
          </div>
        ))}
        <div style={{background:'#f0f7ff',borderRadius:'14px',padding:'16px',textAlign:'center'}}>
          <div style={{fontSize:'13px',fontWeight:'700',color:'#1a1a1a',marginBottom:'4px'}}>Still need help?</div>
          <a href="https://wa.me/917598980545" target="_blank" rel="noreferrer" style={{display:'inline-block',padding:'10px 22px',background:primaryColor,color:'white',borderRadius:'10px',fontSize:'12px',fontWeight:'700',textDecoration:'none',marginTop:'6px'}}>Chat on WhatsApp</a>
        </div>
      </div>
    </div>
  );

  if (page === 'legal') return (
    <div className="app-shell animate-in" style={{minHeight:'100vh',background:'#f8f9fa'}}>
      <div style={{background:'white',padding:'14px 16px',display:'flex',alignItems:'center',gap:'12px',boxShadow:'0 2px 6px rgba(0,0,0,0.06)',position:'sticky',top:0,zIndex:10}}>
        <button onClick={()=>setPage('')} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer'}}>←</button>
        <h2 style={{margin:0,fontSize:'18px',fontWeight:'700'}}>Legal Information</h2>
      </div>
      <div style={{padding:'16px'}}>
        <div style={{background:'#f0f7ff',borderRadius:'12px',padding:'12px 14px',marginBottom:'16px',fontSize:'11px',color:'#1565c0'}}>
          Last updated: January 2026. Please read these policies carefully before using SashtiMedix.
        </div>
        {[
          {title:'Terms of Use',icon:'📜',paras:[
            'By accessing or using the SashtiMedix website, app, or services ("Platform"), you agree to be bound by these Terms of Use. If you do not agree, please discontinue use of the Platform.',
            'You must be at least 18 years old, or use the Platform under the supervision of a parent or guardian, to place an order. You agree to provide accurate, current, and complete information during registration and checkout.',
            'Products listed are offered subject to availability. We reserve the right to limit quantities, refuse or cancel any order at our discretion, including in cases of suspected fraud, error in pricing or product information, or violation of these Terms.',
            'All content on the Platform — including text, graphics, logos, and software — is the property of SashtiMedix or its licensors and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works without written permission.',
            'We may update these Terms from time to time. Continued use of the Platform after changes are posted constitutes acceptance of the revised Terms.',
          ]},
          {title:'Privacy Policy',icon:'🔒',paras:[
            'We collect information you provide directly, such as your name, phone number, delivery address, payment details, order history, and uploaded prescriptions, to process orders and provide customer support.',
            'Prescription images and medical information you upload are stored securely and are accessible only to authorized pharmacist and support staff for the purpose of order verification and fulfillment.',
            'We use your information to process transactions, communicate order updates, provide customer support, and improve our services. We do not sell your personal data to third parties.',
            'We may share information with delivery partners, payment gateways, and pharmacy partners solely to fulfill your order, and with law enforcement where required by applicable law.',
            'We use industry-standard security measures to protect your data. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.',
            'You may request access to, correction of, or deletion of your personal data, or withdraw consent for marketing communications, by contacting support@sashtimedix.in.',
          ]},
          {title:'Return, Refund & Cancellation Policy',icon:'↩️',paras:[
            'Orders can be cancelled free of charge before they are packed/shipped. Once an order is out for delivery, cancellation may not be possible.',
            'Due to the nature of pharmaceutical products, medicines can only be returned if delivered in a damaged, incorrect, expired, or defective condition. Please raise a return request within 48 hours of delivery with photos of the item.',
            'Prescription medicines, once dispensed, cannot be returned or exchanged unless there is a genuine dispensing error on our part, in compliance with applicable drug control regulations.',
            'Approved refunds are processed to the original payment method within 5-7 business days. Cash on Delivery refunds are processed via bank transfer or SashtiMedix wallet credit.',
            'For any return or refund dispute, please contact our support team with your order ID for prompt resolution.',
          ]},
          {title:'Shipping & Delivery Policy',icon:'🚚',paras:[
            'We aim to deliver orders within the estimated timeframe shown at checkout, which may vary based on your location, product availability, and courier/delivery partner schedules.',
            'Delivery times are estimates and not guaranteed. SashtiMedix is not liable for delays caused by circumstances beyond our reasonable control, including weather, courier delays, or incorrect address information provided by the customer.',
            'A valid prescription may need to be produced at the time of delivery for Schedule H/H1/X medicines, in addition to being uploaded at checkout, as required by law.',
            'Please inspect your order upon delivery. Report any damage, tampering, or missing items to our support team immediately.',
          ]},
          {title:'Medical & Prescription Disclaimer',icon:'⚕️',paras:[
            'SashtiMedix is an online platform facilitating the sale of medicines through licensed pharmacy partners. We do not provide medical advice, diagnosis, or treatment.',
            'Prescription medicines are dispensed only against a valid prescription issued by a registered medical practitioner, in compliance with the Drugs and Cosmetics Act and applicable pharmacy regulations.',
            'Please consult a qualified doctor or pharmacist before starting, stopping, or changing any medication. Do not rely solely on product descriptions or user reviews on the Platform for medical decisions.',
            'In case of a medical emergency, please contact your nearest hospital or emergency services immediately rather than placing an order.',
          ]},
          {title:'Grievance Redressal',icon:'📞',paras:[
            'If you have any complaints, concerns, or grievances regarding our products, services, or these policies, please reach out to our support team via the Help & Support section, WhatsApp, or email at support@sashtimedix.in.',
            'We aim to acknowledge grievances within 24-48 hours and resolve them within a reasonable timeframe in accordance with applicable consumer protection regulations.',
          ]},
        ].map((section,idx)=>(
          <div key={idx} style={{background:'white',borderRadius:'16px',padding:'16px',marginBottom:'12px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
            <div style={{fontWeight:'800',fontSize:'15px',marginBottom:'10px',display:'flex',alignItems:'center',gap:'8px'}}><span>{section.icon}</span>{section.title}</div>
            {section.paras.map((p,i)=>(
              <p key={i} style={{fontSize:'12px',color:'#666',lineHeight:'1.7',margin:i<section.paras.length-1?'0 0 10px':0}}>{p}</p>
            ))}
          </div>
        ))}
        <div style={{textAlign:'center',padding:'12px',color:'#aaa',fontSize:'11px'}}>
          For any legal queries, contact support@sashtimedix.in
        </div>
      </div>
    </div>
  );

  if (page === 'about') return (
    <div className="app-shell animate-in" style={{minHeight:'100vh',background:'#f8f9fa'}}>
      <div style={{background:'white',padding:'14px 16px',display:'flex',alignItems:'center',gap:'12px',boxShadow:'0 2px 6px rgba(0,0,0,0.06)',position:'sticky',top:0,zIndex:10}}>
        <button onClick={()=>setPage('')} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer'}}>←</button>
        <h2 style={{margin:0,fontSize:'18px',fontWeight:'700'}}>About Us</h2>
      </div>
      <div style={{padding:'16px'}}>
        <div style={{background:`linear-gradient(135deg,${primaryColor},#0783ED)`,borderRadius:'16px',padding:'28px',textAlign:'center',color:'white',marginBottom:'14px'}}>
          <div style={{fontSize:'50px',marginBottom:'10px'}}>🏥</div>
          <div style={{fontWeight:'800',fontSize:'20px',marginBottom:'6px'}}>SashtiMedix</div>
          <div style={{fontSize:'13px',opacity:0.9}}>Precision in every product</div>
        </div>
        <div style={{background:'white',borderRadius:'16px',padding:'18px',marginBottom:'12px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
          <div style={{fontWeight:'800',fontSize:'15px',marginBottom:'10px'}}>Who We Are</div>
          <p style={{fontSize:'13px',color:'#666',lineHeight:'1.7',margin:0}}>SashtiMedix is an online pharmacy platform delivering genuine medicines, lab tests, and healthcare essentials straight to your doorstep. We partner exclusively with licensed pharmacies to ensure every product you receive is authentic, safe, and quality-checked.</p>
        </div>
        <div style={{background:'white',borderRadius:'16px',padding:'18px',marginBottom:'12px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
          <div style={{fontWeight:'800',fontSize:'15px',marginBottom:'10px'}}>Our Mission</div>
          <p style={{fontSize:'13px',color:'#666',lineHeight:'1.7',margin:0}}>To make healthcare simple, affordable, and accessible for every family by combining trusted pharmacy partnerships with fast, reliable delivery.</p>
        </div>
        <div style={{background:'white',borderRadius:'16px',padding:'18px',marginBottom:'12px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
          <div style={{fontWeight:'800',fontSize:'15px',marginBottom:'12px'}}>Why Choose SashtiMedix</div>
          {[['✅','100% Genuine Products','Sourced directly from licensed pharmacies'],['🚚','Fast & Reliable Delivery','Track your order in real time'],['👨‍⚕️','Verified Prescriptions','Every Rx order reviewed by a pharmacist'],['🔒','Secure & Private','Your data is kept confidential'],['💰','Fair, Transparent Pricing','No hidden charges']].map(([icon,title,sub],i)=>(
            <div key={i} style={{display:'flex',gap:'12px',alignItems:'flex-start',marginBottom:i<4?'14px':0}}>
              <div style={{width:'34px',height:'34px',borderRadius:'10px',background:'#f0f7ff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'16px',flexShrink:0}}>{icon}</div>
              <div><div style={{fontWeight:'700',fontSize:'13px',color:'#1a1a1a'}}>{title}</div><div style={{fontSize:'12px',color:'#888',marginTop:'2px'}}>{sub}</div></div>
            </div>
          ))}
        </div>
        <div style={{background:'white',borderRadius:'16px',padding:'18px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
          <div style={{fontWeight:'800',fontSize:'15px',marginBottom:'10px'}}>Get in Touch</div>
          <a href="mailto:support@sashtimedix.in" style={{display:'block',color:'#666',fontSize:'12px',marginBottom:'6px',textDecoration:'none'}}>✉️ support@sashtimedix.in</a>
          <a href="https://wa.me/917598980545" style={{display:'block',color:'#666',fontSize:'12px',textDecoration:'none'}}>💬 WhatsApp Support</a>
        </div>
      </div>
    </div>
  );

  if (page === 'family') return (
    <div className="app-shell animate-in" style={{minHeight:'100vh',background:'#f8f9fa'}}>
      <div style={{background:'white',padding:'14px 16px',display:'flex',alignItems:'center',gap:'12px',boxShadow:'0 2px 6px rgba(0,0,0,0.06)',position:'sticky',top:0,zIndex:10}}>
        <button onClick={()=>setPage('')} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer'}}>←</button>
        <h2 style={{margin:0,fontSize:'18px',fontWeight:'700'}}>Family Members</h2>
      </div>
      <div style={{padding:'16px'}}>
        {familyMembers.length===0&&!showFamilyForm&&<div style={{textAlign:'center',padding:'40px',color:'#999'}}>No family members added</div>}
        {familyMembers.map(m=>(
          <div key={m._id} style={{background:'white',borderRadius:'14px',padding:'14px',marginBottom:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div>
              <div style={{fontWeight:'700',fontSize:'14px',color:'#1a1a1a'}}>{m.name} ({m.relation})</div>
              <div style={{fontSize:'12px',color:'#666',marginTop:'2px'}}>{m.age?m.age+' yrs':''}{m.phone?' • '+m.phone:''}</div>
            </div>
            <span onClick={()=>removeFamily(m._id)} style={{color:'#c62828',fontSize:'12px',fontWeight:'700',cursor:'pointer'}}>Remove</span>
          </div>
        ))}
        {showFamilyForm ? (
          <div style={{background:'white',borderRadius:'14px',padding:'16px',marginTop:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
            <input placeholder="Name *" value={newFamily.name} onChange={e=>setNewFamily({...newFamily,name:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
            <input placeholder="Relation (e.g. Spouse, Child) *" value={newFamily.relation} onChange={e=>setNewFamily({...newFamily,relation:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
            <div style={{display:'flex',gap:'10px'}}>
              <input placeholder="Age" value={newFamily.age} onChange={e=>setNewFamily({...newFamily,age:e.target.value})} style={{flex:1,padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
              <input placeholder="Phone" value={newFamily.phone} onChange={e=>setNewFamily({...newFamily,phone:e.target.value})} style={{flex:1,padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
            </div>
            <div style={{display:'flex',gap:'10px'}}>
              <button onClick={()=>setShowFamilyForm(false)} style={{flex:1,padding:'13px',background:'#f0f0f0',color:'#666',border:'none',borderRadius:'10px',fontSize:'14px',fontWeight:'700',cursor:'pointer'}}>Cancel</button>
              <button onClick={addFamily} style={{flex:1,padding:'13px',background:primaryColor,color:'white',border:'none',borderRadius:'10px',fontSize:'14px',fontWeight:'700',cursor:'pointer'}}>Save</button>
            </div>
          </div>
        ) : (
          <button onClick={()=>setShowFamilyForm(true)} style={{width:'100%',padding:'14px',background:'#f0f7ff',color:primaryColor,border:`1px dashed ${primaryColor}`,borderRadius:'12px',fontSize:'14px',fontWeight:'700',cursor:'pointer',marginTop:'6px'}}>+ Add Family Member</button>
        )}
      </div>
    </div>
  );

  if (page === 'membership') return (
    <div className="app-shell animate-in" style={{minHeight:'100vh',background:'#f8f9fa'}}>
      <div style={{background:'white',padding:'14px 16px',display:'flex',alignItems:'center',gap:'12px',boxShadow:'0 2px 6px rgba(0,0,0,0.06)',position:'sticky',top:0,zIndex:10}}>
        <button onClick={()=>setPage('')} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer'}}>←</button>
        <h2 style={{margin:0,fontSize:'18px',fontWeight:'700'}}>SashtiMedix PLUS</h2>
      </div>
      <div style={{padding:'16px'}}>
        {myMembership.active ? (
          <div style={{background:'linear-gradient(135deg,#f57f17,#ff8f00)',borderRadius:'18px',padding:'22px',color:'white',textAlign:'center',marginBottom:'18px'}}>
            <div style={{fontSize:'32px',marginBottom:'8px'}}>👑</div>
            <div style={{fontWeight:800,fontSize:'17px',marginBottom:'4px'}}>You're a {myMembership.planName} member!</div>
            <div style={{fontSize:'12px',opacity:0.9}}>Valid till {myMembership.expiryDate?new Date(myMembership.expiryDate).toLocaleDateString():''}</div>
            <div style={{fontSize:'12px',opacity:0.9,marginTop:'8px'}}>{myMembership.discountPercent}% extra discount • {myMembership.freeDelivery?'Free delivery':''}</div>
          </div>
        ):(
          <div style={{background:`linear-gradient(135deg,${primaryColor},#0783ED)`,borderRadius:'18px',padding:'22px',color:'white',textAlign:'center',marginBottom:'18px'}}>
            <div style={{fontSize:'32px',marginBottom:'8px'}}>👑</div>
            <div style={{fontWeight:800,fontSize:'17px',marginBottom:'4px'}}>Unlock SashtiMedix PLUS</div>
            <div style={{fontSize:'12px',opacity:0.9}}>Free delivery, extra discounts & priority support</div>
          </div>
        )}
        {membershipPlans.length===0&&<div style={{textAlign:'center',color:'#999',fontSize:'13px',padding:'20px'}}>Loading plans...</div>}
        {membershipPlans.map(plan=>(
          <div key={plan._id} style={{background:'white',borderRadius:'16px',padding:'18px',marginBottom:'14px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)',border:plan.name.includes('Yearly')?`2px solid #f57f17`:'1px solid #f0f0f0',position:'relative'}}>
            {plan.name.includes('Yearly')&&<div style={{position:'absolute',top:'-10px',right:'16px',background:'#f57f17',color:'white',fontSize:'10px',fontWeight:800,padding:'3px 10px',borderRadius:'10px'}}>BEST VALUE</div>}
            <div style={{fontWeight:800,fontSize:'16px',color:'#1a1a1a',marginBottom:'2px'}}>{plan.name}</div>
            <div style={{display:'flex',alignItems:'baseline',gap:'4px',marginBottom:'12px'}}>
              <span style={{fontSize:'24px',fontWeight:800,color:primaryColor}}>₹{plan.price}</span>
              <span style={{fontSize:'12px',color:'#999'}}>/ {plan.durationDays} days</span>
            </div>
            {plan.benefits.map((b,i)=>(
              <div key={i} style={{display:'flex',gap:'8px',marginBottom:'8px',fontSize:'12px',color:'#555'}}>
                <span style={{color:secondaryColor,fontWeight:800}}>✓</span>{b}
              </div>
            ))}
            <button onClick={()=>subscribeMembership(plan._id)} disabled={subscribingPlan===plan._id||myMembership.active}
              style={{width:'100%',padding:'13px',marginTop:'8px',background:myMembership.active?'#ccc':`linear-gradient(135deg,${primaryColor},#0783ED)`,color:'white',border:'none',borderRadius:'12px',fontSize:'14px',fontWeight:700,cursor:myMembership.active?'not-allowed':'pointer'}}>
              {myMembership.active?'Already a Member':subscribingPlan===plan._id?'Activating...':'Subscribe Now'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );

  if (page === 'mybookings') return (
    <div className="app-shell animate-in" style={{minHeight:'100vh',background:'#f8f9fa'}}>
      <div style={{background:'white',padding:'14px 16px',display:'flex',alignItems:'center',gap:'12px',boxShadow:'0 2px 6px rgba(0,0,0,0.06)',position:'sticky',top:0,zIndex:10}}>
        <button onClick={()=>setPage('')} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer'}}>←</button>
        <h2 style={{margin:0,fontSize:'18px',fontWeight:'700'}}>My Bookings</h2>
      </div>
      <div style={{padding:'16px'}}>
        <div style={{display:'flex',gap:'8px',marginBottom:'16px'}}>
          <span onClick={()=>setBookingsTab('scans')} style={{flex:1,textAlign:'center',padding:'10px',borderRadius:'12px',cursor:'pointer',fontSize:'12px',fontWeight:700,background:bookingsTab==='scans'?primaryColor:'white',color:bookingsTab==='scans'?'white':'#555',boxShadow:'0 2px 6px rgba(0,0,0,0.06)'}}>Lab Tests & Scans</span>
          <span onClick={()=>setBookingsTab('consult')} style={{flex:1,textAlign:'center',padding:'10px',borderRadius:'12px',cursor:'pointer',fontSize:'12px',fontWeight:700,background:bookingsTab==='consult'?primaryColor:'white',color:bookingsTab==='consult'?'white':'#555',boxShadow:'0 2px 6px rgba(0,0,0,0.06)'}}>Doctor Consultations</span>
        </div>
        {bookingsTab==='scans'&&(
          myScanBookings.length===0?(
            <div style={{textAlign:'center',padding:'50px 20px',background:'white',borderRadius:'16px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
              <div style={{fontSize:'48px',marginBottom:'10px'}}>🧪</div>
              <p style={{color:'#666',fontSize:'13px'}}>No lab test or scan bookings yet</p>
            </div>
          ):myScanBookings.map(b=>(
            <div key={b._id} style={{background:'white',borderRadius:'14px',padding:'14px',marginBottom:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:'8px'}}>
                <div style={{fontWeight:700,fontSize:'14px',color:'#1a1a1a'}}>{b.scanTypeName}</div>
                <span style={{background:b.status==='completed'?'#e8f5e9':b.status==='cancelled'?'#ffebee':'#fff3e0',color:b.status==='completed'?secondaryColor:b.status==='cancelled'?'#c62828':'#e65100',padding:'4px 10px',borderRadius:'16px',fontSize:'10px',fontWeight:700}}>{b.status==='completed'?'✅ Completed':b.status==='cancelled'?'✕ Cancelled':'⏳ '+b.status}</span>
              </div>
              <div style={{fontSize:'12px',color:'#666'}}>📅 {b.preferredDate} • {b.preferredSlot}</div>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:'4px'}}>
                <div style={{fontSize:'11px',color:'#999'}}>Booked on {new Date(b.createdAt).toLocaleDateString()}</div>
                {!['completed','cancelled'].includes(b.status)&&(
                  <button onClick={()=>cancelScanBooking(b._id)} style={{background:'#ffebee',color:'#c62828',border:'none',borderRadius:'8px',padding:'6px 12px',fontSize:'11px',fontWeight:700,cursor:'pointer'}}>Cancel</button>
                )}
              </div>
            </div>
          ))
        )}
        {bookingsTab==='consult'&&(
          myConsultBookings.length===0?(
            <div style={{textAlign:'center',padding:'50px 20px',background:'white',borderRadius:'16px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
              <div style={{fontSize:'48px',marginBottom:'10px'}}>👨‍⚕️</div>
              <p style={{color:'#666',fontSize:'13px'}}>No doctor consultations booked yet</p>
            </div>
          ):myConsultBookings.map(b=>(
            <div key={b._id} style={{background:'white',borderRadius:'14px',padding:'14px',marginBottom:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:'8px'}}>
                <div style={{fontWeight:700,fontSize:'14px',color:'#1a1a1a'}}>{b.doctorName||b.specialization}</div>
                <span style={{background:b.status==='completed'?'#e8f5e9':b.status==='cancelled'?'#ffebee':'#fff3e0',color:b.status==='completed'?secondaryColor:b.status==='cancelled'?'#c62828':'#e65100',padding:'4px 10px',borderRadius:'16px',fontSize:'10px',fontWeight:700}}>{b.status==='completed'?'✅ Completed':b.status==='cancelled'?'✕ Cancelled':'⏳ '+b.status}</span>
              </div>
              <div style={{fontSize:'12px',color:'#666'}}>{b.specialization} • {b.mode==='video'?'📹 Video':'📞 Audio'}</div>
              <div style={{fontSize:'12px',color:'#666',marginTop:'2px'}}>📅 {b.preferredDate} • {b.preferredSlot}</div>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:'4px'}}>
                <div style={{fontSize:'11px',color:'#999'}}>Booked on {new Date(b.createdAt).toLocaleDateString()}</div>
                {!['completed','cancelled'].includes(b.status)&&(
                  <button onClick={()=>cancelConsultBooking(b._id)} style={{background:'#ffebee',color:'#c62828',border:'none',borderRadius:'8px',padding:'6px 12px',fontSize:'11px',fontWeight:700,cursor:'pointer'}}>Cancel</button>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );

      if (page === 'wallet') return (
    <div className="app-shell animate-in" style={{minHeight:'100vh',background:'#f4f6fa'}}>
      <div style={{background:'white',padding:'12px 16px',display:'flex',alignItems:'center',gap:'12px',boxShadow:'0 1px 3px rgba(16,24,40,0.08)',position:'sticky',top:0,zIndex:10}}>
        <button onClick={()=>setPage('')} style={{background:'#f2f4f7',border:'none',borderRadius:'50%',width:'36px',height:'36px',cursor:'pointer',fontSize:'18px'}}>←</button>
        <h2 style={{margin:0,fontSize:'18px',fontWeight:800,color:'#101828'}}>My Wallet</h2>
      </div>
      <div style={{padding:'14px'}}>
        {/* BALANCE CARD */}
        <div style={{background:`linear-gradient(135deg,${primaryColor},#0783ED)`,borderRadius:'18px',padding:'20px',marginBottom:'12px',color:'white',boxShadow:'0 10px 24px rgba(0,88,198,0.25)'}}>
          <div style={{fontSize:'12px',opacity:0.85,fontWeight:600,letterSpacing:'0.4px'}}>AVAILABLE BALANCE</div>
          <div style={{display:'flex',alignItems:'baseline',gap:'8px',marginTop:'6px'}}>
            <span style={{fontSize:'38px',fontWeight:800,lineHeight:1}}>🪙 {loyalty.points}</span>
            <span style={{fontSize:'14px',opacity:0.9,fontWeight:600}}>coins</span>
          </div>
          <div style={{display:'inline-block',marginTop:'10px',background:'rgba(255,255,255,0.18)',borderRadius:'999px',padding:'5px 12px',fontSize:'13px',fontWeight:700}}>= ₹{Math.floor(loyalty.points/100)} discount available</div>
          <div style={{marginTop:'16px'}}>
            <div style={{height:'6px',background:'rgba(255,255,255,0.25)',borderRadius:'3px',overflow:'hidden'}}>
              <div style={{width:`${loyalty.points%100}%`,height:'100%',background:'white',borderRadius:'3px'}}></div>
            </div>
            <div style={{fontSize:'11px',opacity:0.9,marginTop:'6px'}}>{100-(loyalty.points%100)} more coins for your next ₹1</div>
          </div>
        </div>

        {/* EARNED / REDEEMED */}
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'12px'}}>
          <div style={{background:'white',borderRadius:'14px',padding:'12px 14px',border:'1px solid #eceff4'}}>
            <div style={{fontSize:'11px',color:'#8a94a6',fontWeight:600}}>Earned</div>
            <div style={{fontSize:'18px',fontWeight:800,color:secondaryColor,marginTop:'2px'}}>+{walletHistory.filter(h=>h.type==='earn').reduce((a,h)=>a+(h.points||0),0)}</div>
          </div>
          <div style={{background:'white',borderRadius:'14px',padding:'12px 14px',border:'1px solid #eceff4'}}>
            <div style={{fontSize:'11px',color:'#8a94a6',fontWeight:600}}>Redeemed</div>
            <div style={{fontSize:'18px',fontWeight:800,color:'#c62828',marginTop:'2px'}}>-{walletHistory.filter(h=>h.type!=='earn').reduce((a,h)=>a+(h.points||0),0)}</div>
          </div>
        </div>

        {/* HOW IT WORKS */}
        <div style={{background:'white',borderRadius:'14px',padding:'14px',marginBottom:'16px',border:'1px solid #eceff4'}}>
          <div style={{fontWeight:800,fontSize:'13px',color:'#101828',marginBottom:'10px'}}>How coins work</div>
          <div style={{display:'flex',alignItems:'center',gap:'10px',marginBottom:'8px'}}>
            <span style={{width:'30px',height:'30px',borderRadius:'50%',background:'#e8f5e9',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'14px'}}>🛍️</span>
            <span style={{fontSize:'12px',color:'#475467'}}>Earn 1 coin per ₹100 spent.</span>
          </div>
          <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
            <span style={{width:'30px',height:'30px',borderRadius:'50%',background:'#eef5ff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'14px'}}>🏷️</span>
            <span style={{fontSize:'12px',color:'#475467'}}>100 coins = ₹1 off your next order.</span>
          </div>
        </div>

        {/* HISTORY */}
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'baseline',margin:'0 2px 10px'}}>
          <div style={{fontWeight:800,fontSize:'14px',color:'#101828'}}>Transaction History</div>
          {walletHistory.length>0&&<div style={{fontSize:'11px',color:'#8a94a6',fontWeight:600}}>{walletHistory.length} entries</div>}
        </div>
        {walletHistory.length===0&&(
          <div style={{textAlign:'center',padding:'36px 20px',background:'white',borderRadius:'16px',border:'1px solid #eceff4'}}>
            <div style={{fontSize:'46px',marginBottom:'10px'}}>🪙</div>
            <div style={{fontWeight:800,color:'#101828',fontSize:'15px',marginBottom:'4px'}}>No coins yet</div>
            <p style={{color:'#667085',fontSize:'12px',margin:0}}>Place an order to start earning coins!</p>
          </div>
        )}
        {walletHistory.map((h,i)=>(
          <div key={i} style={{background:'white',borderRadius:'14px',padding:'12px 14px',marginBottom:'8px',border:'1px solid #eceff4',display:'flex',alignItems:'center',gap:'12px'}}>
            <div style={{width:'36px',height:'36px',borderRadius:'50%',background:h.type==='earn'?'#e8f5e9':'#fdecea',color:h.type==='earn'?secondaryColor:'#c62828',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'17px',fontWeight:800,flexShrink:0}}>{h.type==='earn'?'↑':'↓'}</div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontWeight:700,fontSize:'13px',color:'#101828'}}>{h.type==='earn'?'Coins Earned':'Coins Redeemed'}</div>
              <div style={{fontSize:'11px',color:'#8a94a6',marginTop:'2px'}}>{new Date(h.date).toLocaleDateString('en-IN',{day:'numeric',month:'short',year:'numeric'})}{h.billNo?' • '+h.billNo:''}</div>
            </div>
            <div style={{fontWeight:800,fontSize:'15px',color:h.type==='earn'?secondaryColor:'#c62828'}}>{h.type==='earn'?'+':'-'}{h.points}</div>
          </div>
        ))}
      </div>
    </div>
  );

  if (page === 'checkout') {
    const mrpTotal = cart.reduce((s,i)=>s+((i.mrp||i.price))*i.qty,0);
    const productSaved = mrpTotal - cartTotal;
    const totalSaved = productSaved + (useCoins?coinDiscount:0) + (appliedCoupon?couponDiscount:0);
    const rxItems = cart.filter(i=>i.rx);
    const cdesc = c => (c.discountType==='percent' ? `${c.discountValue}% off`+(c.maxDiscount?` up to ₹${c.maxDiscount}`:'') : `Flat ₹${c.discountValue} off`) + (c.minOrderValue?` on orders above ₹${c.minOrderValue}`:'');
    const card = {background:'white',borderRadius:'16px',padding:'16px',marginBottom:'12px',border:'1px solid #eceff4',boxShadow:'0 1px 3px rgba(16,24,40,0.05)'};
    const stepHead = (n,title) => (
      <div style={{display:'flex',alignItems:'center',gap:'10px',marginBottom:'14px'}}>
        <span style={{width:'24px',height:'24px',borderRadius:'50%',background:primaryColor,color:'white',fontSize:'12px',fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>{n}</span>
        <h3 style={{margin:0,fontSize:'15px',fontWeight:800,color:'#101828'}}>{title}</h3>
      </div>
    );
    const row = {display:'flex',justifyContent:'space-between',marginBottom:'8px',fontSize:'13px',color:'#475467'};
    return (
    <div className="app-shell animate-in" style={{fontFamily:'-apple-system,BlinkMacSystemFont,sans-serif',minHeight:'100vh',background:'#f4f6fa'}}>
      <div style={{background:'white',padding:'12px 16px',display:'flex',alignItems:'center',gap:'12px',boxShadow:'0 1px 3px rgba(16,24,40,0.08)',position:'sticky',top:0,zIndex:100}}>
        <button onClick={()=>setPage('')} style={{background:'#f2f4f7',border:'none',borderRadius:'50%',width:'36px',height:'36px',cursor:'pointer',fontSize:'18px'}}>←</button>
        <h2 style={{margin:0,fontSize:'18px',fontWeight:800,color:'#101828',flex:1}}>Checkout</h2>
        <span style={{fontSize:'11px',fontWeight:700,color:secondaryColor,background:'#e8f5e9',padding:'4px 10px',borderRadius:'999px'}}>🔒 Secure</span>
      </div>
      <div style={{padding:'12px',paddingBottom:'130px'}}>
        {rxItems.length>0&&(
          <div style={{background:'#fff4f2',border:'1px solid #f5c6c0',borderRadius:'14px',padding:'12px 14px',marginBottom:'12px',display:'flex',gap:'10px',alignItems:'flex-start'}}>
            <span style={{background:'#e5392d',color:'white',fontSize:'10px',fontWeight:800,padding:'3px 8px',borderRadius:'6px',flexShrink:0,marginTop:'1px'}}>Rx</span>
            <div style={{flex:1}}>
              <div style={{fontWeight:800,color:'#b42318',fontSize:'13px'}}>Prescription required</div>
              <div style={{color:'#7a271a',fontSize:'12px',marginTop:'2px',lineHeight:'1.4'}}>Your order has Rx medicine. It will be accepted only after your prescription is approved by our pharmacist.</div>
              <button onClick={()=>{setPage('prescription');fetchMyPrescriptions();}} style={{marginTop:'8px',padding:'7px 14px',background:'#e5392d',color:'white',border:'none',borderRadius:'8px',fontSize:'12px',fontWeight:700,cursor:'pointer'}}>Upload / View Prescriptions</button>
            </div>
          </div>
        )}

        <div style={card}>
          {stepHead(1,'Delivery Address')}
          {addressList.length>0&&(
            <div style={{display:'flex',flexDirection:'column',gap:'8px',marginBottom:'12px'}}>
              {addressList.map(addr=>{
                const sel = manualAddr.street===addr.street;
                return (
                  <div key={addr._id} onClick={()=>{setManualAddr({name:addr.name,street:addr.street,area:addr.area,city:addr.city,pincode:addr.pincode});setDetectedAddress(null);}}
                    style={{display:'flex',gap:'10px',alignItems:'flex-start',border:`1.5px solid ${sel?primaryColor:'#e3e8ef'}`,background:sel?'#f3f8ff':'white',borderRadius:'12px',padding:'12px',cursor:'pointer'}}>
                    <div style={{width:'18px',height:'18px',borderRadius:'50%',border:`2px solid ${sel?primaryColor:'#c0c6d1'}`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,marginTop:'2px'}}>{sel&&<div style={{width:'8px',height:'8px',borderRadius:'50%',background:primaryColor}}></div>}</div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{display:'flex',alignItems:'center',gap:'6px'}}>
                        <span style={{fontWeight:800,fontSize:'12px',color:primaryColor,background:'#eaf2ff',padding:'1px 8px',borderRadius:'6px'}}>{addr.label}</span>
                        {addr.isDefault&&<span style={{fontSize:'10px',color:'#8a94a6',fontWeight:700}}>⭐ Default</span>}
                      </div>
                      <div style={{fontSize:'12px',color:'#475467',marginTop:'4px',lineHeight:'1.4'}}>{addr.name}, {addr.street}, {addr.area}, {addr.city} - {addr.pincode}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          <button onClick={detectLocation} disabled={locationLoading}
            style={{width:'100%',padding:'12px',background:'white',color:primaryColor,border:`1.5px solid ${primaryColor}`,borderRadius:'12px',fontSize:'13px',fontWeight:700,cursor:'pointer',marginBottom:'12px',display:'flex',alignItems:'center',justifyContent:'center',gap:'8px'}}>
            {locationLoading?'📡 Detecting Location...':'📍 Use My Current Location'}
          </button>

          {detectedAddress&&(
            <div style={{background:'#e8f5e9',borderRadius:'10px',padding:'12px',marginBottom:'12px',border:'1px solid #a5d6a7'}}>
              <div style={{display:'flex',gap:'8px',alignItems:'flex-start'}}>
                <span style={{fontSize:'18px'}}>✅</span>
                <div style={{flex:1}}>
                  <div style={{fontWeight:700,color:'#2e7d32',fontSize:'13px',marginBottom:'2px'}}>Location Detected!</div>
                  <div style={{color:'#555',fontSize:'13px'}}>{detectedAddress}</div>
                </div>
              </div>
            </div>
          )}

          <details className="co-details" open={addressList.length===0&&!detectedAddress}>
            <summary style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'10px 12px',background:'#f2f4f7',borderRadius:'10px',fontSize:'13px',fontWeight:700,color:'#344054',marginBottom:'10px'}}>
              <span>✍️ Enter address manually</span><span style={{color:'#8a94a6'}}>▾</span>
            </summary>
            <input className="co-input" placeholder="Full Name *" value={manualAddr.name}
              onChange={e=>setManualAddr({...manualAddr,name:e.target.value})}/>
            <input className="co-input" placeholder="Street / House No *" value={manualAddr.street}
              onChange={e=>setManualAddr({...manualAddr,street:e.target.value})}/>
            <div style={{position:'relative'}}>
              <input className="co-input" placeholder="Pincode (Enter to auto-fill area)" value={manualAddr.pincode}
                onChange={e=>searchPincode(e.target.value)} maxLength={6} type="tel"
                style={addressSuggestions.length>0?{borderColor:'#1565c0'}:undefined}/>
              {manualAddr.pincode.length===6&&erodeAreas[manualAddr.pincode]&&(
                <div style={{position:'absolute',right:'12px',top:'14px',color:'#2e7d32',fontSize:'12px',fontWeight:700}}>✅ Valid</div>
              )}
              {manualAddr.pincode.length===6&&!erodeAreas[manualAddr.pincode]&&(
                <div style={{position:'absolute',right:'12px',top:'14px',color:'#e65100',fontSize:'12px',fontWeight:700}}>⚠️ Check</div>
              )}
            </div>
            {addressSuggestions.length>0&&(
              <div style={{background:'#f0f7ff',borderRadius:'10px',padding:'12px',marginBottom:'8px',border:'1px solid #c5d0ff'}}>
                <div style={{color:'#1565c0',fontSize:'12px',fontWeight:700,marginBottom:'8px'}}>📍 Areas in this pincode:</div>
                <div style={{display:'flex',flexWrap:'wrap',gap:'6px'}}>
                  {addressSuggestions.map((area,i)=>(
                    <span key={i} onClick={()=>setManualAddr(prev=>({...prev,area}))}
                      style={{background:manualAddr.area===area?'#1565c0':'white',color:manualAddr.area===area?'white':'#1565c0',padding:'4px 12px',borderRadius:'20px',fontSize:'12px',fontWeight:600,cursor:'pointer',border:'1px solid #1565c0'}}>
                      {area}
                    </span>
                  ))}
                </div>
              </div>
            )}
            <input className="co-input" placeholder="Area / Locality *" value={manualAddr.area}
              onChange={e=>setManualAddr({...manualAddr,area:e.target.value})}/>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px'}}>
              <input className="co-input" placeholder="City" value={manualAddr.city}
                onChange={e=>setManualAddr({...manualAddr,city:e.target.value})}/>
              <div style={{padding:'12px',borderRadius:'10px',background:'#f5f5f5',border:'1px solid #e0e0e0',fontSize:'14px',color:'#666',display:'flex',alignItems:'center',marginBottom:'8px'}}>
                📱 Tamil Nadu
              </div>
            </div>
          </details>

          {manualAddr.pincode&&erodeAreas[manualAddr.pincode]&&(
            <div style={{background:'#e8f5e9',borderRadius:'10px',padding:'10px 14px',marginTop:'4px',display:'flex',gap:'8px',alignItems:'center'}}>
              <span style={{fontSize:'20px'}}>🛵</span>
              <div>
                <div style={{fontWeight:700,color:'#2e7d32',fontSize:'13px'}}>Delivery Available!</div>
                <div style={{color:'#555',fontSize:'12px'}}>Estimated: 30-45 minutes</div>
              </div>
            </div>
          )}
        </div>

        <div style={card}>
          {stepHead(2,'Payment Method')}
          <div style={{marginBottom:'14px'}}><PayStrip compact /></div>
          {[['📱 UPI / Card / Netbanking','online','Instant, via Razorpay'],['💵 Cash on Delivery','cod','Pay at door']].map(([label,val,sub],i)=>{
            const sel = paymentMethod === val;
            return (
            <div key={i} onClick={()=>setPaymentMethod(val)} style={{display:'flex',alignItems:'center',gap:'12px',padding:'13px',borderRadius:'12px',border:`1.5px solid ${sel?primaryColor:'#e3e8ef'}`,marginBottom:'8px',background:sel?'#f3f8ff':'white',cursor:'pointer'}}>
              <div style={{width:'20px',height:'20px',borderRadius:'50%',border:`2px solid ${sel?primaryColor:'#c0c6d1'}`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                {sel&&<div style={{width:'10px',height:'10px',borderRadius:'50%',background:primaryColor}}></div>}
              </div>
              <div style={{flex:1}}>
                <div style={{fontWeight:700,fontSize:'14px',color:sel?primaryColor:'#101828'}}>{label}</div>
                <div style={{color:'#8a94a6',fontSize:'12px'}}>{sub}</div>
              </div>
            </div>
          );})}
        </div>

        <div style={card}>
          {stepHead(3,'Offers & Coins')}
          <div style={{display:'flex',gap:'8px'}}>
            <input className="co-input" style={{flex:1,marginBottom:0,width:'auto'}} value={couponInput} onChange={e=>setCouponInput(e.target.value.toUpperCase())} placeholder="Enter coupon code" disabled={!!appliedCoupon}/>
            {appliedCoupon ? (
              <button onClick={()=>{setAppliedCoupon(null);setCouponInput('');setCouponMsg('');}} style={{padding:'11px 16px',background:'#fdecea',color:'#c62828',border:'none',borderRadius:'10px',fontSize:'13px',fontWeight:700,cursor:'pointer'}}>Remove</button>
            ) : (
              <button onClick={applyCoupon} style={{padding:'11px 18px',background:primaryColor,color:'white',border:'none',borderRadius:'10px',fontSize:'13px',fontWeight:700,cursor:'pointer'}}>Apply</button>
            )}
          </div>
          {couponMsg&&<div style={{marginTop:'8px',fontSize:'12px',color:appliedCoupon?'#2e7d32':'#c62828'}}>{couponMsg}</div>}
          {!appliedCoupon&&activeCoupons.length>0&&(
            <div style={{marginTop:'12px'}}>
              <div style={{fontSize:'11px',color:'#8a94a6',fontWeight:700,marginBottom:'6px'}}>AVAILABLE OFFERS (tap to fill, then press Apply)</div>
              {activeCoupons.map(c=>(
                <div key={c.code} onClick={()=>setCouponInput(c.code)} style={{display:'flex',alignItems:'center',gap:'10px',padding:'9px 10px',border:'1px solid #e3e8ef',borderRadius:'10px',marginBottom:'6px',cursor:'pointer'}}>
                  <span style={{border:'1.5px dashed '+primaryColor,color:primaryColor,borderRadius:'8px',padding:'3px 9px',fontSize:'12px',fontWeight:800,flexShrink:0}}>{c.code}</span>
                  <span style={{fontSize:'12px',color:'#475467'}}>{cdesc(c)}</span>
                </div>
              ))}
            </div>
          )}

          {loyalty.points > 0 && (
            <div style={{marginTop:'14px',paddingTop:'14px',borderTop:'1px solid #f2f4f7'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
                  <div style={{width:'38px',height:'38px',background:'linear-gradient(135deg,#f57f17,#ff8f00)',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'18px'}}>🪙</div>
                  <div>
                    <div style={{fontWeight:800,color:'#b45309',fontSize:'15px'}}>{loyalty.points} Coins</div>
                    <div style={{color:'#667085',fontSize:'12px'}}>= ₹{Math.floor(loyalty.points/100)} discount</div>
                  </div>
                </div>
                <div onClick={()=>{setUseCoins(!useCoins);setCoinsToRedeem(useCoins?0:Math.min(loyalty.points,cartTotal*100));}}
                  style={{width:'50px',height:'26px',borderRadius:'13px',background:useCoins?'#f57f17':'#e0e0e0',cursor:'pointer',position:'relative',transition:'background 0.3s'}}>
                  <div style={{width:'22px',height:'22px',borderRadius:'50%',background:'white',position:'absolute',top:'2px',left:useCoins?'26px':'2px',transition:'left 0.3s',boxShadow:'0 2px 4px rgba(0,0,0,0.2)'}}></div>
                </div>
              </div>
              {useCoins&&(
                <div style={{background:'#fff8e1',borderRadius:'10px',padding:'12px',border:'1px solid #ffe082',marginTop:'12px'}}>
                  <div style={{display:'flex',justifyContent:'space-between',marginBottom:'6px',fontSize:'13px'}}>
                    <span style={{color:'#666'}}>Coins to use</span>
                    <span style={{fontWeight:700,color:'#b45309'}}>{coinsToRedeem} coins</span>
                  </div>
                  <input type="range" min="0" max={Math.min(loyalty.points,cartTotal*100)} step="100" value={coinsToRedeem}
                    onChange={e=>setCoinsToRedeem(Number(e.target.value))}
                    style={{width:'100%',accentColor:'#f57f17',marginBottom:'6px'}}/>
                  <div style={{display:'flex',justifyContent:'space-between',fontSize:'13px'}}>
                    <span style={{color:'#666'}}>Discount</span>
                    <span style={{fontWeight:800,color:'#2e7d32',fontSize:'15px'}}>-₹{Math.floor(coinsToRedeem/100)}</span>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        <div style={card}>
          {stepHead(4,'Order Summary')}
          <details className="co-details" style={{marginBottom:'12px'}}>
            <summary style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'10px 12px',background:'#f2f4f7',borderRadius:'10px',fontSize:'13px',fontWeight:700,color:'#344054'}}>
              <span>View items ({cartCount})</span><span style={{color:'#8a94a6'}}>▾</span>
            </summary>
            <div style={{paddingTop:'10px'}}>
              {cart.map(item=>(
                <div key={item._id} style={{display:'flex',justifyContent:'space-between',gap:'10px',marginBottom:'8px',fontSize:'13px'}}>
                  <div style={{minWidth:0}}><div style={{fontWeight:600,color:'#101828'}}>{item.name}</div><div style={{color:'#8a94a6',fontSize:'11px'}}>Qty: {item.qty}</div></div>
                  <span style={{fontWeight:700,color:'#101828',flexShrink:0}}>₹{rsFmt(item.price*item.qty)}</span>
                </div>
              ))}
            </div>
          </details>
          {productSaved>0&&<div style={row}><span>Item total (MRP)</span><span>₹{rsFmt(mrpTotal)}</span></div>}
          {productSaved>0&&<div style={{...row,color:'#2e7d32',fontWeight:600}}><span>Product discount</span><span>-₹{rsFmt(productSaved)}</span></div>}
          <div style={row}><span>Subtotal</span><span>₹{rsFmt(cartTotal)}</span></div>
          {useCoins&&coinDiscount>0&&<div style={{...row,color:'#2e7d32'}}><span>🪙 Coin Discount</span><span style={{fontWeight:700}}>-₹{coinDiscount}</span></div>}
          {appliedCoupon&&couponDiscount>0&&<div style={{...row,color:'#2e7d32'}}><span>🏷️ Coupon ({appliedCoupon.code})</span><span style={{fontWeight:700}}>-₹{couponDiscount}</span></div>}
          <div style={{...row,color:'#2e7d32'}}><span>Delivery</span><span style={{fontWeight:700}}>FREE</span></div>
          <div style={{display:'flex',justifyContent:'space-between',fontSize:'17px',fontWeight:800,color:'#101828',borderTop:'1px solid #f2f4f7',paddingTop:'12px',marginTop:'4px'}}><span>To pay</span><span>₹{rsFmt(finalTotal)}</span></div>
          {totalSaved>0&&<div style={{marginTop:'10px',background:'#e8f5e9',color:'#2e7d32',borderRadius:'8px',padding:'8px 10px',fontSize:'12px',fontWeight:700,textAlign:'center'}}>🎉 You are saving ₹{rsFmt(totalSaved)} on this order</div>}
          {Math.floor(finalTotal/100)>0&&<div style={{color:'#b45309',fontSize:'12px',marginTop:'8px',textAlign:'right'}}>🪙 You'll earn {Math.floor(finalTotal/100)} coin{Math.floor(finalTotal/100)===1?'':'s'} on this order</div>}
        </div>

        <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'8px'}}>
          {[['✅','100% Genuine'],['🏥','Licensed Pharmacy'],['🔒','Secure Checkout']].map(([icon,label],i)=>(
            <div key={i} style={{background:'white',borderRadius:'12px',padding:'10px 4px',textAlign:'center',border:'1px solid #eceff4'}}>
              <div style={{fontSize:'16px'}}>{icon}</div>
              <div style={{fontSize:'10px',fontWeight:700,color:'#475467',marginTop:'2px'}}>{label}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="app-nav" style={{position:'fixed',bottom:0,left:'50%',transform:'translateX(-50%)',width:'100%',background:'white',boxShadow:'0 -4px 20px rgba(16,24,40,0.12)',zIndex:100,padding:'10px 14px',borderTop:'1px solid #eceff4',boxSizing:'border-box',display:'flex',alignItems:'center',gap:'12px'}}>
        <div style={{minWidth:0}}>
          <div style={{fontSize:'11px',color:'#8a94a6',fontWeight:600}}>To pay</div>
          <div style={{fontSize:'19px',fontWeight:800,color:'#101828'}}>₹{rsFmt(finalTotal)}</div>
        </div>
        <button onClick={()=>{
          const addr = detectedAddress ||
            `${manualAddr.name}, ${manualAddr.street}, ${manualAddr.area}, ${manualAddr.city} - ${manualAddr.pincode}`;
          if(!manualAddr.name&&!detectedAddress){alert('Name அவசியம்!');return;}
          if(!manualAddr.street&&!detectedAddress){alert('Address அவசியம்!');return;}
          placeOrder(addr);
        }} disabled={loading}
          style={{flex:1,padding:'15px',background:`linear-gradient(135deg,${primaryColor},#0783ED)`,color:'white',border:'none',borderRadius:'12px',fontSize:'15px',fontWeight:700,cursor:'pointer',boxShadow:'0 6px 16px rgba(0,88,198,0.28)',opacity:loading?0.7:1}}>
          {loading?'Placing Order...':(paymentMethod==='online'?'Pay ₹'+rsFmt(finalTotal):'Place Order · ₹'+rsFmt(finalTotal))}
        </button>
      </div>
    </div>
    );
  }

  // SUCCESS PAGE
  if (page === 'success') return (
    <div className="app-shell" style={{fontFamily:'-apple-system,BlinkMacSystemFont,sans-serif',minHeight:'100vh',background:'#f8f9fa',display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{textAlign:'center',padding:'40px'}}>
        <div style={{width:'100px',height:'100px',background:'linear-gradient(135deg,#00875a,#006644)',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'48px',margin:'0 auto 20px'}}>✅</div>
        <h2 style={{color:'#1a1a1a',fontSize:'24px',fontWeight:'800',margin:'0 0 8px'}}>Order Placed!</h2>
        {lastOrder&&<p style={{color:'#999',fontSize:'12px',margin:'0 0 6px'}}>Order ID: <span style={{fontWeight:700,color:'#1a1a1a'}}>#{lastOrder.orderId}</span></p>}
        <p style={{color:'#666',margin:'0 0 8px'}}>Your medicines will be delivered in 30 minutes 🛵</p>
        <div style={{background:'#fff8e1',borderRadius:'12px',padding:'10px 20px',marginBottom:'16px',border:'1px solid #ffe082',display:'inline-block'}}>
          <span style={{fontSize:'18px'}}>🪙 </span>
          <span style={{fontWeight:'800',color:'#f57f17',fontSize:'15px'}}>{finalTotal} Coins Earned!</span>
          <span style={{color:'#666',fontSize:'12px',display:'block'}}>Total: {loyalty.points + finalTotal} coins = ₹{Math.floor((loyalty.points + finalTotal)/100)} discount</span>
        </div>
        <div style={{background:'white',borderRadius:'16px',padding:'20px',marginBottom:'20px',boxShadow:'0 4px 16px rgba(0,0,0,0.08)'}}>
          <div style={{display:'flex',justifyContent:'space-around'}}>
            {['✅ Confirmed','🏪 Preparing','🛵 On Way','🏠 Delivered'].map((s,i)=>(
              <div key={i} style={{textAlign:'center'}}>
                <div style={{fontSize:'22px',marginBottom:'4px'}}>{s.split(' ')[0]}</div>
                <div style={{fontSize:'10px',color:i===0?secondaryColor:'#ccc',fontWeight:i===0?'700':'400'}}>{s.split(' ').slice(1).join(' ')}</div>
              </div>
            ))}
          </div>
        </div>
        {lastOrder&&(
          <div style={{background:'white',borderRadius:'16px',padding:'18px',marginBottom:'20px',boxShadow:'0 4px 16px rgba(0,0,0,0.08)',textAlign:'left'}}>
            <div style={{fontWeight:700,fontSize:'13px',color:'#1a1a1a',marginBottom:'10px'}}>Order Summary</div>
            {lastOrder.items.map((it,i)=>(
              <div key={i} style={{display:'flex',justifyContent:'space-between',fontSize:'12px',color:'#555',marginBottom:'6px'}}>
                <span>{it.name} x{it.qty}</span><span style={{fontWeight:700,color:'#1a1a1a'}}>₹{it.price*it.qty}</span>
              </div>
            ))}
            <div style={{borderTop:'1px dashed #eee',marginTop:'8px',paddingTop:'8px',display:'flex',justifyContent:'space-between'}}>
              <span style={{fontSize:'13px',fontWeight:800,color:'#1a1a1a'}}>Total Paid</span>
              <span style={{fontSize:'13px',fontWeight:800,color:primaryColor}}>₹{lastOrder.total}</span>
            </div>
            <div style={{fontSize:'11px',color:'#999',marginTop:'6px'}}>Paid via {lastOrder.paymentMethod}</div>
          </div>
        )}
        <div style={{display:'flex',gap:'10px',justifyContent:'center'}}>
          <button onClick={()=>{setPage('');setTab('orders');fetchOrders();}} style={{padding:'12px 24px',background:`linear-gradient(135deg,${primaryColor},#0783ED)`,color:'white',border:'none',borderRadius:'12px',fontSize:'14px',fontWeight:'700',cursor:'pointer'}}>Track Order</button>
          <button onClick={()=>{setPage('');setTab('home');}} style={{padding:'12px 24px',background:'white',color:primaryColor,border:`2px solid ${primaryColor}`,borderRadius:'12px',fontSize:'14px',fontWeight:'700',cursor:'pointer'}}>Continue Shopping</button>
        </div>
      </div>
    </div>
  );

  // PRESCRIPTION PAGE
  if (page === 'prescription') return (
    <div className="app-shell animate-in" style={{fontFamily:'-apple-system,BlinkMacSystemFont,sans-serif',minHeight:'100vh',background:'#f8f9fa'}}>
      <div style={{background:'white',padding:'14px 16px',display:'flex',alignItems:'center',gap:'12px',boxShadow:'0 1px 4px rgba(0,0,0,0.08)'}}>
        <button onClick={()=>setPage('')} style={{background:'#f5f5f5',border:'none',borderRadius:'50%',width:'36px',height:'36px',cursor:'pointer',fontSize:'18px'}}>←</button>
        <h2 style={{margin:0,fontSize:'18px',fontWeight:'700'}}>📁 Health Locker</h2>
      </div>
      <div style={{padding:'16px'}}>
        <div style={{display:'flex',gap:'8px',marginBottom:'14px'}}>
          {[['prescription','📋','Prescription'],['lab_report','🧪','Lab Report'],['other','📄','Other']].map(([val,icon,label])=>(
            <span key={val} onClick={()=>setRecordType(val)} style={{flex:1,textAlign:'center',padding:'10px 4px',borderRadius:'12px',cursor:'pointer',fontSize:'11px',fontWeight:700,background:recordType===val?primaryColor:'white',color:recordType===val?'white':'#555',boxShadow:'0 2px 6px rgba(0,0,0,0.06)'}}>{icon} {label}</span>
          ))}
        </div>
        <div style={{background:'white',borderRadius:'16px',padding:'24px',textAlign:'center',boxShadow:'0 2px 8px rgba(0,0,0,0.06)',marginBottom:'12px'}}>
          <div style={{fontSize:'64px',marginBottom:'12px'}}>{recordType==='prescription'?'📋':recordType==='lab_report'?'🧪':'📄'}</div>
          <h3 style={{color:'#1a1a1a',margin:'0 0 8px',fontSize:'18px',fontWeight:'700'}}>{recordType==='prescription'?'Upload Your Prescription':recordType==='lab_report'?'Upload Lab Report':'Upload Health Record'}</h3>
          <p style={{color:'#666',fontSize:'13px',margin:'0 0 20px'}}>{recordType==='prescription'?'Get medicines delivered with doctor prescription':'Store it safely, access anytime, share with your doctor'}</p>

          {/* HOW IT WORKS */}
          <div style={{display:'flex',justifyContent:'space-between',marginBottom:'20px',padding:'0 4px'}}>
            {[['📸','Upload'],['👨‍⚕️','Pharmacist Verifies'],['🚚','Get Delivered']].map(([icon,label],i)=>(
              <div key={i} style={{display:'flex',flexDirection:'column',alignItems:'center',flex:1,position:'relative'}}>
                {i>0&&<div style={{position:'absolute',top:'18px',right:'50%',width:'100%',height:'2px',background:'#e0e0e0',zIndex:0}}></div>}
                <div style={{width:'36px',height:'36px',borderRadius:'50%',background:'#f0f7ff',border:`2px solid ${primaryColor}`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'16px',zIndex:1,position:'relative'}}>{icon}</div>
                <div style={{fontSize:'10px',fontWeight:'700',color:'#555',marginTop:'6px',textAlign:'center'}}>{label}</div>
              </div>
            ))}
          </div>

          {prescFile && prescFile.type && prescFile.type.startsWith('image/') && (
            <div style={{marginBottom:'12px',borderRadius:'14px',overflow:'hidden',border:`2px solid ${secondaryColor}`}}>
              <img src={URL.createObjectURL(prescFile)} alt="Prescription preview" style={{width:'100%',maxHeight:'220px',objectFit:'contain',display:'block',background:'#f8f9fa'}}/>
            </div>
          )}

          <label style={{display:'block',border:`2px dashed ${prescFile?secondaryColor:'#c5d0ff'}`,borderRadius:'16px',padding:'32px',background:prescFile?'#f0fffe':'#f0f7ff',marginBottom:'16px',cursor:'pointer'}}>
            <div style={{fontSize:'40px',marginBottom:'8px'}}>{prescFile?'✅':'📸'}</div>
            <p style={{color:prescFile?secondaryColor:primaryColor,fontWeight:'700',margin:'0 0 4px'}}>{prescFile?prescFile.name:'Take Photo or Upload'}</p>
            <p style={{color:'#999',fontSize:'12px',margin:0}}>{prescFile?'Tap to change':'JPG, PNG, PDF supported'}</p>
            <input type="file" accept="image/*,.pdf" onChange={e=>{setPrescFile(e.target.files[0]);setPrescMsg('');}} style={{display:'none'}}/>
          </label>
          {prescMsg&&<div style={{marginBottom:'12px',padding:'10px',borderRadius:'10px',fontSize:'13px',background:prescMsg.includes('✅')?'#e8f5e9':'#ffebee',color:prescMsg.includes('✅')?secondaryColor:'#c62828'}}>{prescMsg}</div>}
          <button onClick={uploadPrescription} disabled={prescUploading} style={{width:'100%',padding:'14px',background:`linear-gradient(135deg,${primaryColor},#0783ED)`,color:'white',border:'none',borderRadius:'12px',fontSize:'15px',fontWeight:'700',cursor:prescUploading?'not-allowed':'pointer',opacity:prescUploading?0.7:1}}>
            {prescUploading?'Uploading...':'Save to Health Locker'}
          </button>
        </div>
        {myPrescriptions.length>0&&(
          <div style={{background:'white',borderRadius:'16px',padding:'18px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)',marginBottom:'12px'}}>
            <h3 style={{margin:'0 0 12px',fontSize:'15px',fontWeight:'700'}}>📁 Your Health Records</h3>
            {myPrescriptions.map(p=>(
              <div key={p._id} style={{display:'flex',alignItems:'center',gap:'10px',padding:'10px 0',borderBottom:'1px solid #f5f5f5'}}>
                <div style={{width:'36px',height:'36px',borderRadius:'10px',background:'#f0f7ff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'16px',flexShrink:0}}>{p.recordType==='lab_report'?'🧪':p.recordType==='other'?'📄':'📋'}</div>
                <div style={{flex:1}}>
                  <div style={{fontSize:'12px',fontWeight:'600',color:'#1a1a1a'}}>{p.recordType==='lab_report'?'Lab Report':p.recordType==='other'?'Health Record':'Prescription'}</div>
                  <div style={{fontSize:'11px',color:'#999'}}>{new Date(p.createdAt).toLocaleDateString()} • {new Date(p.createdAt).toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'})}</div>
                </div>
                {(!p.recordType||p.recordType==='prescription')?(
                  <span style={{background:p.status==='approved'?'#e8f5e9':p.status==='rejected'?'#ffebee':'#fff3e0',color:p.status==='approved'?secondaryColor:p.status==='rejected'?'#c62828':'#e65100',padding:'4px 10px',borderRadius:'20px',fontSize:'11px',fontWeight:'700'}}>
                    {p.status==='approved'?'✅ Approved':p.status==='rejected'?'❌ Rejected':'⏳ Pending'}
                  </span>
                ):(
                  <span style={{background:'#f0f7ff',color:'#1565c0',padding:'4px 10px',borderRadius:'20px',fontSize:'11px',fontWeight:'700'}}>💾 Saved</span>
                )}
              </div>
            ))}
          </div>
        )}
        <div style={{background:'#fff8e1',borderRadius:'12px',padding:'14px',border:'1px solid #ffe082'}}>
          <p style={{color:'#f57f17',fontWeight:'700',margin:'0 0 6px',fontSize:'13px'}}>📌 Guidelines</p>
          {['Doctor signature must be visible','Date & stamp should be clear','Valid for 30 days only','Max file size: 10MB'].map((g,i)=>(
            <div key={i} style={{color:'#555',fontSize:'12px',marginBottom:'4px'}}>✓ {g}</div>
          ))}
        </div>
      </div>
    </div>
  );

  // MAIN APP
  return (
    <div className={"app-shell" + (darkMode ? " dark-mode" : "")} style={{fontFamily:'-apple-system,BlinkMacSystemFont,sans-serif',minHeight:'100vh',background:'#f8f9fa',paddingBottom:'70px'}}>

      {/* HEADER - sticky so search stays visible while scrolling */}
      <div className='mobile-header' style={{background:`linear-gradient(135deg,${primaryColor},#0783ED)`,padding:'14px 16px',position:'sticky',top:0,zIndex:90,boxShadow:'0 4px 14px rgba(0,0,0,0.12)'}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px'}}>
          <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
            <button onClick={()=>setTab('profile')} style={{background:'rgba(255,255,255,0.15)',border:'none',borderRadius:'10px',width:'36px',height:'36px',color:'white',cursor:'pointer',fontSize:'18px',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>☰</button>
            <img src="/logo-icon.png" alt="logo" style={{width:'36px',height:'36px',borderRadius:'10px',objectFit:'contain',background:'white',padding:'2px'}} onError={e=>e.target.style.display='none'}/>
            <div>
              <div style={{color:'white',fontWeight:'800',fontSize:'16px',letterSpacing:'-0.3px'}}>Sashtimedix</div>
              <div style={{color:'rgba(255,255,255,0.75)',fontSize:'10px'}}>Precision in every product</div>
            </div>
          </div>
          <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
            <button onClick={()=>setTab('cart')} style={{background:'rgba(255,255,255,0.15)',border:'none',borderRadius:'10px',padding:'8px 12px',color:'white',cursor:'pointer',position:'relative',display:'flex',alignItems:'center',gap:'6px',fontSize:'13px',fontWeight:'600'}}>
              🛒 Cart
              {cartCount>0&&<span key={cartCount} className="cart-bump" style={{background:accentColor,color:'white',borderRadius:'50%',width:'18px',height:'18px',fontSize:'10px',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:'bold',position:'absolute',top:'-6px',right:'-6px'}}>{cartCount}</span>}
            </button>
          </div>
        </div>

        {/* SEARCH BAR */}
        <div style={{position:'relative'}}>
          <span style={{position:'absolute',left:'14px',top:'50%',transform:'translateY(-50%)',display:'flex',pointerEvents:'none'}}><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8a94a6" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg></span>
          <input type="text" placeholder="Search medicines, health products..." value={search}
            onChange={e=>{setSearch(e.target.value);if(e.target.value)setTab('search');}}
            onFocus={()=>setSearchFocused(true)}
            onBlur={()=>setTimeout(()=>setSearchFocused(false),200)}
            style={{width:'100%',padding:'13px 78px 13px 42px',fontSize:'14px',borderRadius:'14px',border:'none',boxSizing:'border-box',outline:'none',fontWeight:'500',background:'white',color:'#101828',boxShadow:'0 4px 14px rgba(16,24,40,0.14)'}}/>
          {search&&<span onClick={()=>setSearch('')} style={{position:'absolute',right:'44px',top:'50%',transform:'translateY(-50%)',width:'22px',height:'22px',borderRadius:'50%',background:'#e4e7ec',color:'#475467',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'15px',lineHeight:1,cursor:'pointer'}}>×</span>}
          <span onClick={startVoiceSearch} style={{position:'absolute',right:'6px',top:'50%',transform:'translateY(-50%)',fontSize:'14px',cursor:'pointer',opacity:voiceListening?1:0.9,animation:voiceListening?'micPulse 1s ease-in-out infinite':'none',background:voiceListening?accentColor:primaryColor,color:'white',width:'28px',height:'28px',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'0 2px 6px rgba(0,0,0,0.15)'}}>🎤</span>
          {searchFocused && searchSuggestions.length > 0 && (
            <div style={{position:'absolute',top:'calc(100% + 6px)',left:0,right:0,background:'white',borderRadius:'12px',boxShadow:'0 10px 26px rgba(0,0,0,0.18)',overflow:'hidden',zIndex:50}}>
              {searchSuggestions.map(m => (
                <div key={m._id} onClick={()=>{setSearch(m.name);setTab('search');setMedDetail(m);}}
                  style={{padding:'10px 14px',display:'flex',alignItems:'center',gap:'10px',cursor:'pointer',borderBottom:'1px solid #f2f2f2',color:'#1a1a1a'}}>
                  <span style={{fontSize:'16px'}}>💊</span>
                  <div>
                    <div style={{fontSize:'13px',fontWeight:'600'}}>{m.name}</div>
                    <div style={{fontSize:'11px',color:'#888'}}>{m.generic || m.category}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* DESKTOP NAVBAR - hidden on mobile */}
      <div className="desktop-navbar" style={{background:'white',borderBottom:'1px solid #eee',position:'sticky',top:0,zIndex:95}}>
        <div style={{maxWidth:'1200px',margin:'0 auto',padding:'14px 24px',display:'flex',alignItems:'center',gap:'24px'}}>
          <div style={{display:'flex',alignItems:'center',gap:'10px',cursor:'pointer'}} onClick={()=>setTab('home')}>
            <img src="/logo-icon.png" alt="logo" style={{width:'40px',height:'40px',borderRadius:'10px',objectFit:'contain'}} onError={e=>e.target.style.display='none'}/>
            <div>
              <div style={{fontWeight:'800',fontSize:'19px',color:primaryColor}}>Sashtimedix</div>
              <div style={{fontSize:'11px',color:'#888'}}>Precision in every product</div>
            </div>
          </div>
          <div style={{flex:1,position:'relative',maxWidth:'480px'}}>
            <span style={{position:'absolute',left:'16px',top:'50%',transform:'translateY(-50%)',display:'flex',pointerEvents:'none'}}><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8a94a6" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg></span>
            <input type="text" placeholder="Search medicines, health products..." value={search}
              onChange={e=>{setSearch(e.target.value);if(e.target.value)setTab('search');}}
              style={{width:'100%',padding:'12px 40px 12px 44px',fontSize:'14px',borderRadius:'24px',border:'1px solid #e0e0e0',boxSizing:'border-box',outline:'none',background:'#f7f8fa'}}/>
            {search&&<span onClick={()=>setSearch('')} style={{position:'absolute',right:'12px',top:'50%',transform:'translateY(-50%)',width:'22px',height:'22px',borderRadius:'50%',background:'#e4e7ec',color:'#475467',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'15px',lineHeight:1,cursor:'pointer'}}>×</span>}
          </div>
          <div className="nav-link" onClick={()=>setTab('search')}>Medicines</div>
          <div className="nav-link" onClick={()=>setTab('scans')}>Lab Tests</div>
          <div className="nav-link" onClick={()=>{setPage('wallet');fetchWalletHistory();}}>Rewards</div>
          <div className="nav-link" onClick={()=>{setTab('orders');fetchOrders();}}>My Orders</div>
          <div onClick={()=>setTab('profile')} style={{cursor:'pointer',fontWeight:'700',fontSize:'13px'}}>Account</div>
          <button onClick={()=>setTab('cart')} style={{background:primaryColor,border:'none',borderRadius:'10px',padding:'10px 16px',color:'white',cursor:'pointer',position:'relative',display:'flex',alignItems:'center',gap:'6px',fontSize:'13px',fontWeight:'700'}}>
            Cart
            {cartCount>0&&<span style={{background:accentColor,color:'white',borderRadius:'50%',width:'18px',height:'18px',fontSize:'10px',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:'bold',position:'absolute',top:'-6px',right:'-6px'}}>{cartCount}</span>}
          </button>
        </div>
      </div>

      {/* HOME TAB */}
      {tab==='home'&&(
        <div style={{background:'#f4f6fa',paddingBottom:'16px'}}>
          {/* BANNER (admin banners, or defaults) */}
          {(()=>{
            const goLink = (link) => {
              const l = String(link||'').trim();
              if (!l) return;
              if (/^https:\/\//i.test(l)) { window.open(l, '_blank', 'noopener'); return; }
              if (l.startsWith('category:')) { setSearch(''); if (typeof setSelectedCategory === 'function') setSelectedCategory(l.slice(9).trim()); setTab('search'); return; }
              if (l.startsWith('search:')) { setSearch(l.slice(7).trim()); setTab('search'); return; }
              if (l === 'prescription') { setPage('prescription'); fetchMyPrescriptions(); return; }
              if (l === 'labtests') { setTab('scans'); return; }
              if (l === 'medicines') { setTab('search'); return; }
            };
            const defaults = [
              {bg:`linear-gradient(135deg,${primaryColor},#0783ED)`,tag:'WELCOME OFFER',title:'₹50 OFF on your order',sub:'Use code WELCOME50 on orders above ₹200',btn:'Shop Now',link:'medicines'},
              {bg:'linear-gradient(135deg,#0143AC,#278018)',tag:'PRESCRIPTION',title:'Upload prescription, get medicines at home',sub:'Verified by our pharmacist',btn:'Upload Now',link:'prescription'},
              {bg:'linear-gradient(135deg,#278018,#3FA21B)',tag:'HOME DELIVERY',title:'Free home delivery',sub:'Genuine medicines from a licensed pharmacy',btn:'Order Now',link:'medicines'},
            ];
            const slides = homeBanners.length ? homeBanners.map(b=>({img:b.imageUrl,title:b.title,sub:b.subtitle,btn:b.buttonText,link:b.linkUrl||b.link})) : defaults;
            const n = slides.length;
            const cur = adIdx % n;
            return (
              <div style={{padding:'12px 12px 0'}}>
                <div style={{position:'relative',borderRadius:'16px',overflow:'hidden',boxShadow:'0 8px 24px rgba(16,24,40,0.14)',background:'#e9eef7'}}
                  onTouchStart={e=>{heroTouchX=e.touches[0].clientX;}}
                  onTouchEnd={e=>{ if (heroTouchX===null) return; const dx=e.changedTouches[0].clientX-heroTouchX; heroTouchX=null; if (Math.abs(dx)>40) setAdIdx(i=>(i+(dx<0?1:-1)+n)%n); }}>
                  <div style={{display:'flex',transform:`translateX(-${cur*100}%)`,transition:'transform 0.5s ease'}}>
                    {slides.map((s,i)=>(
                      <div key={i} onClick={()=>goLink(s.link)} style={{flex:'0 0 100%',aspectRatio:'5 / 2',minHeight:'140px',maxHeight:'380px',position:'relative',cursor:s.link?'pointer':'default',background:s.img?'#e9eef7':s.bg,color:'white'}}>
                        {s.img&&<img src={s.img} alt={s.title||'Offer'} draggable={false} loading={i===0?'eager':'lazy'} style={{position:'absolute',inset:0,width:'100%',height:'100%',objectFit:'cover',display:'block'}}/>}
                        {s.img&&(s.title||s.sub)&&<div style={{position:'absolute',left:0,right:0,bottom:0,padding:'30px 16px 14px',background:'linear-gradient(180deg,rgba(0,0,0,0),rgba(0,0,0,0.62))'}}>
                          {s.title&&<div style={{fontSize:'18px',fontWeight:800,lineHeight:'1.2'}}>{s.title}</div>}
                          {s.sub&&<div style={{fontSize:'12px',opacity:0.9,marginTop:'2px'}}>{s.sub}</div>}
                        </div>}
                        {!s.img&&(
                          <div style={{position:'absolute',inset:0,padding:'18px 20px',display:'flex',flexDirection:'column',justifyContent:'center'}}>
                            {s.tag&&<span style={{alignSelf:'flex-start',background:'rgba(255,255,255,0.2)',border:'1px solid rgba(255,255,255,0.4)',borderRadius:'999px',padding:'3px 10px',fontSize:'10px',fontWeight:800,letterSpacing:'0.6px',marginBottom:'8px'}}>{s.tag}</span>}
                            <div style={{fontSize:'21px',fontWeight:800,lineHeight:'1.2',maxWidth:'80%'}}>{s.title}</div>
                            {s.sub&&<div style={{fontSize:'12.5px',opacity:0.9,marginTop:'6px',maxWidth:'80%'}}>{s.sub}</div>}
                            {s.btn&&<span style={{alignSelf:'flex-start',marginTop:'12px',background:'white',color:'#101828',borderRadius:'10px',padding:'8px 16px',fontSize:'12px',fontWeight:800}}>{s.btn} →</span>}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  {n>1&&(
                    <div style={{position:'absolute',left:0,right:0,bottom:'8px',display:'flex',justifyContent:'center',gap:'6px',pointerEvents:'none'}}>
                      {slides.map((_,i)=>(<span key={i} style={{width:i===cur?'18px':'6px',height:'6px',borderRadius:'3px',background:i===cur?'white':'rgba(255,255,255,0.55)',transition:'width 0.3s'}}></span>))}
                    </div>
                  )}
                </div>
              </div>
            );
          })()}

          {/* QUICK ACTIONS */}
          <div style={{padding:'14px 12px 4px',display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'8px'}}>
            {[
              ['pill','Medicines',()=>{setSearch('');if (typeof setSelectedCategory === 'function') setSelectedCategory('');setTab('search');}],
              ['file','Prescription',()=>{setPage('prescription');fetchMyPrescriptions();}],
              ['flask','Lab Tests',()=>{if (typeof setHealthSection === 'function') setHealthSection('labtests');setTab('scans');}],
              ['doctor','Doctor',()=>{if (typeof setHealthSection === 'function') setHealthSection('consult');setTab('scans');}],
            ].map(([ic,label,action],i)=>(
              <div key={i} onClick={action} style={{background:'white',borderRadius:'14px',padding:'12px 4px 10px',textAlign:'center',cursor:'pointer',border:'1px solid #eceff4',boxShadow:'0 1px 3px rgba(16,24,40,0.05)'}}>
                <div style={{width:'44px',height:'44px',margin:'0 auto 7px',borderRadius:'14px',background:'#eef5ff',color:primaryColor,display:'flex',alignItems:'center',justifyContent:'center'}}><Ico name={ic} size={22}/></div>
                <div style={{fontSize:'11px',fontWeight:700,color:'#344054',lineHeight:'1.2'}}>{label}</div>
              </div>
            ))}
          </div>

          {/* ORDER WITH PRESCRIPTION */}
          <div style={{margin:'12px 12px 0',background:'linear-gradient(135deg,#0143AC,#0058C6 55%,#278018)',borderRadius:'18px',padding:'18px',color:'white',position:'relative',overflow:'hidden'}}>
            <div style={{position:'absolute',right:'-18px',top:'-18px',width:'120px',height:'120px',borderRadius:'50%',background:'rgba(255,255,255,0.08)'}}></div>
            <div style={{fontSize:'17px',fontWeight:800,lineHeight:'1.25',maxWidth:'80%'}}>Have a prescription?</div>
            <div style={{fontSize:'12.5px',opacity:0.9,marginTop:'4px',maxWidth:'85%',lineHeight:'1.4'}}>Upload it and our pharmacist will verify it before your order is accepted.</div>
            <div style={{display:'flex',gap:'14px',margin:'14px 0',fontSize:'11px',fontWeight:600,opacity:0.95}}>
              {['Upload','Pharmacist verifies','Delivered'].map((t,i)=>(
                <div key={t} style={{display:'flex',alignItems:'center',gap:'6px'}}>
                  <span style={{width:'18px',height:'18px',borderRadius:'50%',background:'rgba(255,255,255,0.25)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'10px',fontWeight:800}}>{i+1}</span>{t}
                </div>
              ))}
            </div>
            <button onClick={()=>{setPage('prescription');fetchMyPrescriptions();}} style={{display:'inline-flex',alignItems:'center',gap:'8px',background:'white',color:primaryColor,border:'none',borderRadius:'12px',padding:'11px 18px',fontSize:'13px',fontWeight:800,cursor:'pointer'}}><Ico name="upload" size={16} sw={2.2}/>Upload Prescription</button>
          </div>

          {/* SHOP BY CATEGORY */}
          <div style={{padding:'18px 12px 0'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'baseline',margin:'0 2px 10px'}}>
              <h3 style={{margin:0,fontSize:'17px',fontWeight:800,color:'#101828'}}>Shop by Category</h3>
              <span onClick={()=>{setSearch('');if (typeof setSelectedCategory === 'function') setSelectedCategory('');setTab('search');}} style={{color:primaryColor,fontSize:'12px',fontWeight:700,cursor:'pointer'}}>View all</span>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'repeat(4,minmax(0,1fr))',gap:'8px'}}>
              {[['Diabetes','drop'],['Heart & BP','heart'],['Pain Relief','pulse'],['Digestive Care','pill'],['Respiratory','wind'],['Skin Care','leaf'],['Vitamins & Supplements','sun'],["Women's Health",'user']].map(([name,ic])=>(
                <div key={name} onClick={()=>{setSearch('');if (typeof setSelectedCategory === 'function') setSelectedCategory(name);setTab('search');}} style={{background:'white',border:'1px solid #eceff4',borderRadius:'14px',padding:'12px 4px 10px',textAlign:'center',cursor:'pointer',boxShadow:'0 1px 3px rgba(16,24,40,0.05)'}}>
                  <div style={{width:'42px',height:'42px',margin:'0 auto 7px',borderRadius:'50%',background:'#f0f7ff',color:primaryColor,display:'flex',alignItems:'center',justifyContent:'center'}}><Ico name={ic} size={20}/></div>
                  <div style={{fontSize:'10.5px',fontWeight:700,color:'#344054',lineHeight:'1.25',padding:'0 2px'}}>{name}</div>
                </div>
              ))}
            </div>
          </div>

          {/* OFFERS */}
          {activeCoupons.length>0&&(
            <div style={{padding:'18px 0 0'}}>
              <h3 style={{margin:'0 14px 10px',fontSize:'17px',fontWeight:800,color:'#101828'}}>Offers for you</h3>
              <div style={{display:'flex',gap:'10px',overflowX:'auto',padding:'0 12px 4px',scrollbarWidth:'none'}}>
                {activeCoupons.map(c=>(
                  <div key={c.code} style={{flex:'0 0 auto',width:'230px',background:'white',border:'1px solid #eceff4',borderRadius:'14px',padding:'12px 14px',display:'flex',alignItems:'center',gap:'12px'}}>
                    <div style={{width:'38px',height:'38px',borderRadius:'10px',background:'#eef5ff',color:primaryColor,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><Ico name="tag" size={19}/></div>
                    <div style={{minWidth:0,flex:1}}>
                      <div style={{fontSize:'12px',fontWeight:800,color:'#101828'}}>{c.discountType==='percent' ? `${c.discountValue}% off`+(c.maxDiscount?` up to ₹${c.maxDiscount}`:'') : `Flat ₹${c.discountValue} off`}</div>
                      <div style={{fontSize:'10.5px',color:'#8a94a6',marginTop:'1px'}}>{c.minOrderValue?`On orders above ₹${c.minOrderValue}`:'On any order'}</div>
                    </div>
                    <span onClick={()=>{ if (typeof copyCoupon === 'function') copyCoupon(c.code); }} style={{border:'1.5px dashed '+primaryColor,color:primaryColor,borderRadius:'8px',padding:'4px 8px',fontSize:'11px',fontWeight:800,cursor:'pointer',flexShrink:0}}>{c.code}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ORDER AGAIN */}
          {orders&&orders.length>0&&orders[0].items&&orders[0].items.length>0&&(
            <div style={{margin:'18px 12px 0',background:'white',border:'1px solid #eceff4',borderRadius:'16px',padding:'14px',display:'flex',alignItems:'center',gap:'12px'}}>
              <div style={{width:'42px',height:'42px',borderRadius:'12px',background:'#e8f5e9',color:secondaryColor,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><Ico name="repeat" size={20}/></div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:'14px',fontWeight:800,color:'#101828'}}>Order again</div>
                <div style={{fontSize:'11.5px',color:'#8a94a6',marginTop:'2px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{orders[0].items.map(i=>i.name).join(', ')}</div>
              </div>
              <button onClick={()=>quickReorder(orders[0])} style={{background:secondaryColor,color:'white',border:'none',borderRadius:'10px',padding:'9px 14px',fontSize:'12px',fontWeight:800,cursor:'pointer',flexShrink:0}}>Reorder</button>
            </div>
          )}

          {/* QUICK SEARCH */}
          <div style={{padding:'18px 12px 0'}}>
            <h3 style={{margin:'0 2px 10px',fontSize:'17px',fontWeight:800,color:'#101828'}}>Quick search</h3>
            <div style={{display:'flex',flexWrap:'wrap',gap:'8px'}}>
              {['Dolo 650','Paracetamol','Vitamin D3','Metformin','Omeprazole','Cetirizine'].map(q=>(
                <span key={q} onClick={()=>{setSearch(q);setTab('search');}} style={{background:'white',border:'1px solid #e3e8ef',color:'#344054',borderRadius:'999px',padding:'7px 14px',fontSize:'12px',fontWeight:600,cursor:'pointer'}}>{q}</span>
              ))}
            </div>
          </div>

          {/* LAB TESTS + DOCTOR */}
          <div style={{padding:'18px 12px 0',display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px'}}>
            {[['flask','Lab Tests','Book diagnostic tests',()=>{if (typeof setHealthSection === 'function') setHealthSection('labtests');setTab('scans');}],['doctor','Consult a Doctor','Talk to a doctor online',()=>{if (typeof setHealthSection === 'function') setHealthSection('consult');setTab('scans');}]].map(([ic,t,s,action])=>(
              <div key={t} onClick={action} style={{background:'white',border:'1px solid #eceff4',borderRadius:'16px',padding:'14px',cursor:'pointer'}}>
                <div style={{width:'40px',height:'40px',borderRadius:'12px',background:'#eef5ff',color:primaryColor,display:'flex',alignItems:'center',justifyContent:'center',marginBottom:'10px'}}><Ico name={ic} size={20}/></div>
                <div style={{fontSize:'14px',fontWeight:800,color:'#101828'}}>{t}</div>
                <div style={{fontSize:'11.5px',color:'#8a94a6',marginTop:'2px'}}>{s}</div>
              </div>
            ))}
          </div>

          {/* WHY SASHTIMEDIX */}
          <div style={{margin:'18px 12px 0',background:'white',border:'1px solid #eceff4',borderRadius:'18px',padding:'16px'}}>
            <h3 style={{margin:'0 0 12px',fontSize:'16px',fontWeight:800,color:'#101828'}}>Why Sashtimedix</h3>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'14px 12px'}}>
              {[['check','Genuine medicines','Sourced from licensed pharmacies'],['shield','Pharmacist verified','Every Rx order is reviewed'],['lock','Secure payments','UPI, cards, netbanking or pay on delivery'],['truck','Track your order','See the status from your account']].map(([ic,t,s])=>(
                <div key={t} style={{display:'flex',gap:'10px'}}>
                  <div style={{width:'34px',height:'34px',borderRadius:'10px',background:'#e8f5e9',color:secondaryColor,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><Ico name={ic} size={18}/></div>
                  <div style={{minWidth:0}}>
                    <div style={{fontSize:'12.5px',fontWeight:800,color:'#101828',lineHeight:'1.2'}}>{t}</div>
                    <div style={{fontSize:'11px',color:'#8a94a6',marginTop:'2px',lineHeight:'1.3'}}>{s}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* SECURE PAYMENT METHODS */}
          <div style={{margin:'14px 12px 0',background:'white',border:'1px solid #eceff4',borderRadius:'16px',padding:'14px'}}>
            <div style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'10px',color:'#101828'}}>
              <Ico name="lock" size={16} sw={2}/>
              <span style={{fontWeight:800,fontSize:'13px'}}>Secure Payments</span>
              <span style={{fontSize:'10px',color:'#8a94a6',marginLeft:'auto'}}>Powered by Razorpay</span>
            </div>
            <PayStrip />
          </div>

          {/* HELP */}
          <div style={{margin:'14px 12px 0',background:'#f0f7ff',border:'1px solid #d6e6fb',borderRadius:'16px',padding:'14px',display:'flex',alignItems:'center',gap:'12px'}}>
            <div style={{width:'40px',height:'40px',borderRadius:'12px',background:'white',color:primaryColor,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><Ico name="chat" size={20}/></div>
            <div style={{flex:1}}>
              <div style={{fontSize:'13.5px',fontWeight:800,color:'#101828'}}>Need help with your order?</div>
              <div style={{fontSize:'11.5px',color:'#667085',marginTop:'1px'}}>Our team is on WhatsApp.</div>
            </div>
            <a href="https://wa.me/917598980545?text=Hi%20Sashtimedix%2C%20I%20need%20help" target="_blank" rel="noopener noreferrer" style={{background:primaryColor,color:'white',borderRadius:'10px',padding:'9px 14px',fontSize:'12px',fontWeight:800,textDecoration:'none',flexShrink:0}}>Chat</a>
          </div>
        </div>
      )}

      {/* SEARCH TAB */}
      {tab==='search'&&(
        <div style={{padding:'10px 12px'}}>
          {(()=>{
            const CATS = [['Allergy','🤧'],['Antibiotics','💊'],['Antifungal','🧴'],['Antiviral','🦠'],['Anxiety & Sleep','😴'],['Blood Thinner','🩸'],['Cholesterol','🫀'],['Deworming','🐛'],['Diabetes','🩺'],['Digestive Care','🍽️'],['Epilepsy Care','⚡'],['Eye Care','👁️'],['Gastro Care','🔥'],['Heart & BP','❤️'],["Men's Health",'👨'],['Mental Health','💭'],['Muscle Relaxant','💪'],['Nausea & Vomiting','🤢'],['Nerve Pain','🦵'],['Neurology','🧠'],['Pain Relief','🩹'],['Painkiller','🤕'],['Respiratory','🫁'],['Skin Care','✨'],['Steroid','💉'],['Thyroid Care','🦋'],['Vitamins & Supplements','🍊'],["Women's Health",'👩']];
            const rs = n => (Number.isInteger(Number(n)) ? Number(n) : Number(n).toFixed(2));
            const listMode = !!search || !!selectedCategory;
            if (!listMode) return (
              <div>
                <div style={{fontSize:'17px',fontWeight:800,color:'#101828',margin:'4px 2px 4px'}}>Shop by Category</div>
                <div style={{fontSize:'12px',color:'#8a94a6',margin:'0 2px 12px'}}>Pick a category, or browse everything.</div>
                <div className="cat-grid">
                  <div onClick={()=>setSelectedCategory('ALL')} style={{background:`linear-gradient(135deg,${primaryColor},#0783ED)`,borderRadius:'14px',padding:'14px 6px',textAlign:'center',cursor:'pointer',color:'white',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:'6px',minHeight:'92px'}}>
                    <div style={{fontSize:'26px'}}>📋</div>
                    <div style={{fontSize:'12px',fontWeight:800}}>All Medicines</div>
                  </div>
                  {CATS.map(([name,icon])=>(
                    <div key={name} onClick={()=>setSelectedCategory(name)} style={{background:'white',border:'1px solid #eceff4',borderRadius:'14px',padding:'14px 6px',textAlign:'center',cursor:'pointer',boxShadow:'0 1px 3px rgba(16,24,40,0.05)',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:'8px',minHeight:'92px'}}>
                      <div style={{width:'42px',height:'42px',borderRadius:'50%',background:'#eef5ff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'22px'}}>{icon}</div>
                      <div style={{fontSize:'11px',fontWeight:700,color:'#344054',lineHeight:'1.25'}}>{name}</div>
                    </div>
                  ))}
                </div>
              </div>
            );
            const shown = medicines
              .filter(med => !inStockOnly || med.stock > 0)
              .filter(med => rxFilter==='all' || (rxFilter==='rx' ? med.rx : !med.rx))
              .sort((a,b) => sortBy==='priceLow' ? a.price-b.price : sortBy==='priceHigh' ? b.price-a.price : 0);
            const stepBtn = {width:'24px',height:'26px',border:'none',background:'transparent',color:'white',fontSize:'16px',fontWeight:700,cursor:'pointer',padding:0};
            return (
              <div>
                <div style={{display:'flex',alignItems:'center',gap:'10px',margin:'2px 2px 10px'}}>
                  <button onClick={()=>{setSearch('');setSelectedCategory('');}} style={{background:'#f2f4f7',border:'none',borderRadius:'999px',padding:'6px 12px',fontSize:'12px',fontWeight:700,color:'#475467',cursor:'pointer',flexShrink:0}}>‹ Categories</button>
                  <div style={{flex:1,minWidth:0,fontSize:'15px',fontWeight:800,color:'#101828',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{search?`Results for "${search}"`:(selectedCategory==='ALL'?'All Medicines':selectedCategory)}</div>
                  <div style={{fontSize:'11px',color:'#8a94a6',fontWeight:600,flexShrink:0}}>{shown.length} shown</div>
                </div>

                {/* FILTER BAR - everything visible, no side scrolling */}
                <div style={{background:'white',border:'1px solid #eceff4',borderRadius:'14px',padding:'8px',marginBottom:'12px',display:'flex',gap:'8px',alignItems:'center',flexWrap:'wrap'}}>
                  <div style={{display:'inline-flex',background:'#f2f4f7',borderRadius:'10px',padding:'3px'}}>
                    {[['all','All'],['otc','OTC'],['rx','Rx']].map(([key,label])=>(
                      <span key={key} onClick={()=>setRxFilter(key)} style={{padding:'6px 13px',borderRadius:'8px',fontSize:'12px',fontWeight:700,cursor:'pointer',background:rxFilter===key?'white':'transparent',color:rxFilter===key?(key==='rx'?'#e5392d':primaryColor):'#667085',boxShadow:rxFilter===key?'0 1px 2px rgba(16,24,40,0.12)':'none'}}>{label}</span>
                    ))}
                  </div>
                  <span onClick={()=>setInStockOnly(v=>!v)} style={{padding:'6px 12px',borderRadius:'999px',fontSize:'12px',fontWeight:700,cursor:'pointer',background:inStockOnly?'#e8f5e9':'white',color:inStockOnly?secondaryColor:'#475467',border:`1px solid ${inStockOnly?secondaryColor:'#e3e8ef'}`}}>{inStockOnly?'✓ ':''}In Stock</span>
                  <select value={sortBy} onChange={e=>setSortBy(e.target.value)} style={{marginLeft:'auto',padding:'7px 8px',borderRadius:'10px',border:'1px solid #e3e8ef',background:'white',fontSize:'12px',fontWeight:600,color:'#475467',outline:'none'}}>
                    <option value="relevance">Relevance</option>
                    <option value="priceLow">Price: Low to High</option>
                    <option value="priceHigh">Price: High to Low</option>
                  </select>
                </div>

                <div className="med-list">
                  {medsLoading && medicines.length===0 && [1,2,3,4,5,6].map(i=>(
                    <div key={'sk'+i} style={{background:'white',borderRadius:'14px',padding:'10px',border:'1px solid #eceff4',display:'flex',gap:'12px'}}>
                      <div className="skeleton" style={{width:'56px',height:'56px',flexShrink:0}}></div>
                      <div style={{flex:1}}>
                        <div className="skeleton" style={{height:'12px',width:'70%',marginBottom:'8px'}}></div>
                        <div className="skeleton" style={{height:'14px',width:'35%'}}></div>
                      </div>
                    </div>
                  ))}
                  {shown.map(med=>{
                    const ci = cart.find(i=>i._id===med._id);
                    const off = med.mrp>med.price ? Math.round((med.mrp-med.price)/med.mrp*100) : 0;
                    return (
                      <div key={med._id} className="med-card" onClick={()=>setMedDetail(med)} style={{background:'white',borderRadius:'14px',padding:'10px',border:'1px solid #eceff4',boxShadow:'0 1px 3px rgba(16,24,40,0.05)',cursor:'pointer',display:'flex',gap:'12px',alignItems:'center',minWidth:0}}>
                        <div style={{position:'relative',width:'56px',height:'56px',flexShrink:0,borderRadius:'12px',background:'linear-gradient(180deg,#eef5ff,#ffffff)',border:'1px solid #e6eefb',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'24px'}}>
                          💊
                          {med.rx&&<span style={{position:'absolute',top:'-5px',left:'-5px',background:'#e5392d',color:'white',fontSize:'9px',fontWeight:800,padding:'1px 6px',borderRadius:'6px'}}>Rx</span>}
                        </div>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{fontWeight:700,color:'#101828',fontSize:'13px',lineHeight:'1.3',display:'-webkit-box',WebkitLineClamp:2,WebkitBoxOrient:'vertical',overflow:'hidden',wordBreak:'break-word'}}>{med.name}</div>
                          {med.generic&&<div style={{color:'#8a94a6',fontSize:'11px',marginTop:'1px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{med.generic}</div>}
                          <div style={{display:'flex',alignItems:'baseline',gap:'6px',marginTop:'4px',flexWrap:'wrap'}}>
                            <span style={{fontWeight:800,color:'#101828',fontSize:'15px'}}>₹{rs(med.price)}</span>
                            {off>0&&<span style={{color:'#98a2b3',textDecoration:'line-through',fontSize:'11px'}}>₹{rs(med.mrp)}</span>}
                            {off>0&&<span style={{background:'#e8f5e9',color:secondaryColor,fontSize:'10px',fontWeight:800,padding:'1px 6px',borderRadius:'6px'}}>{off}% OFF</span>}
                            {med.stock<=0&&<span style={{fontSize:'10px',fontWeight:700,color:'#e5392d'}}>Out of Stock</span>}
                          </div>
                        </div>
                        <div style={{flexShrink:0,width:'72px'}} onClick={e=>e.stopPropagation()}>
                          {med.stock<=0?(
                            <button disabled style={{width:'100%',padding:'8px 0',background:'#e4e7ec',color:'#98a2b3',border:'none',borderRadius:'10px',fontSize:'11px',fontWeight:700,cursor:'not-allowed'}}>Sold out</button>
                          ):ci?(
                            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',background:primaryColor,borderRadius:'10px',padding:'2px'}}>
                              <button onClick={()=>updateQty(med._id, ci.qty-1)} style={stepBtn}>−</button>
                              <span style={{color:'white',fontWeight:800,fontSize:'12px'}}>{ci.qty}</span>
                              <button onClick={()=>updateQty(med._id, ci.qty+1)} style={stepBtn}>+</button>
                            </div>
                          ):(
                            <button onClick={()=>addCart(med)} style={{width:'100%',padding:'8px 0',background:'white',color:primaryColor,border:`1.5px solid ${primaryColor}`,borderRadius:'10px',fontSize:'12px',fontWeight:800,cursor:'pointer'}}>ADD</button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                  {!medsLoading && shown.length===0 && (
                    <div style={{gridColumn:'1/-1',textAlign:'center',padding:'46px 20px',background:'white',borderRadius:'16px',border:'1px solid #eceff4'}}>
                      <div style={{fontSize:'48px',marginBottom:'10px'}}>🔍</div>
                      <h3 style={{color:'#101828',fontWeight:800,margin:'0 0 6px',fontSize:'16px'}}>No medicines found</h3>
                      <p style={{color:'#667085',fontSize:'13px',margin:'0 0 16px'}}>Try a different search term or clear your filters</p>
                      <button onClick={()=>{setSearch('');setInStockOnly(false);setRxFilter('all');}} style={{padding:'10px 22px',background:primaryColor,color:'white',border:'none',borderRadius:'10px',fontSize:'13px',fontWeight:700,cursor:'pointer'}}>Clear Filters</button>
                    </div>
                  )}
                </div>
                {!medsLoading && medicines.length>=50 && (
                  <div style={{textAlign:'center',color:'#8a94a6',fontSize:'12px',padding:'14px 8px 24px'}}>Showing the first 50 medicines. Use the search bar to find a specific medicine.</div>
                )}
              </div>
            );
          })()}
        </div>
      )}

      {/* SCANS TAB */}
      {tab==='scans'&&(
        <div>
          {/* HERO */}
          <div style={{background:`linear-gradient(135deg,${primaryColor},#0783ED)`,padding:'20px 16px',color:'white'}}>
            <div style={{fontSize:'20px',fontWeight:800,marginBottom:'4px'}}>Lab Tests & Doctor Consultation</div>
            <div style={{fontSize:'12px',opacity:0.85}}>NABL-style verified labs • Certified doctors • Reports you can trust</div>
          </div>

          {/* SECTION TOGGLE */}
          <div style={{display:'flex',gap:'6px',padding:'12px'}}>
            <button onClick={()=>setHealthSection('labtests')} style={{flex:1,padding:'11px 4px',borderRadius:'12px',border:'none',cursor:'pointer',fontWeight:700,fontSize:'11px',background:healthSection==='labtests'?primaryColor:'white',color:healthSection==='labtests'?'white':'#555',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>🧪 Lab Test</button>
            <button onClick={()=>setHealthSection('scan')} style={{flex:1,padding:'11px 4px',borderRadius:'12px',border:'none',cursor:'pointer',fontWeight:700,fontSize:'11px',background:healthSection==='scan'?primaryColor:'white',color:healthSection==='scan'?'white':'#555',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>🩻 Scan</button>
            <button onClick={()=>setHealthSection('consult')} style={{flex:1,padding:'11px 4px',borderRadius:'12px',border:'none',cursor:'pointer',fontWeight:700,fontSize:'11px',background:healthSection==='consult'?primaryColor:'white',color:healthSection==='consult'?'white':'#555',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>👨‍⚕️ Doctor</button>
          </div>

          {/* PROMO BANNER */}
          <div style={{margin:'0 12px 14px',background:'linear-gradient(135deg,#6554c0,#403294)',borderRadius:'16px',padding:'18px',color:'white',position:'relative',overflow:'hidden'}}>
            <div style={{fontSize:'15px',fontWeight:800,marginBottom:'4px'}}>{healthSection==='labtests'?'Full Body Checkup Packages':healthSection==='scan'?'X-Ray, MRI, CT & Ultrasound':'Talk to a Doctor Today'}</div>
            <div style={{fontSize:'12px',opacity:0.85}}>{healthSection==='labtests'?'Get accurate reports from trusted labs':healthSection==='scan'?'Book diagnostic scans at home-collection prices':'Video/audio consultation from home'}</div>
          </div>

          {/* WHY CHOOSE US */}
          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'8px',padding:'0 12px 16px'}}>
            {(healthSection==='labtests'
              ?[['💰','Lowest','Prices'],['🛡️','Verified','Labs'],['🔬','Compare','& Select'],['⚡','Fast','Reports']]
              :healthSection==='scan'
              ?[['🏥','Certified','Centers'],['📷','Digital','Imaging'],['👨‍⚕️','Radiologist','Reviewed'],['⚡','Quick','Reports']]
              :[['👨‍⚕️','Verified','Doctors'],['📹','Video/Audio','Consult'],['💊','e-Prescription','Included'],['🔒','100%','Private']]
            ).map(([icon,l1,l2],i)=>(
              <div key={i} style={{background:'white',borderRadius:'12px',padding:'10px 4px',textAlign:'center',boxShadow:'0 2px 6px rgba(0,0,0,0.06)'}}>
                <div style={{fontSize:'18px',marginBottom:'4px'}}>{icon}</div>
                <div style={{fontSize:'9px',fontWeight:700,color:'#333',lineHeight:'1.3'}}>{l1}<br/>{l2}</div>
              </div>
            ))}
          </div>

          {/* LAB TESTS SECTION */}
          {healthSection==='labtests'&&(
            <div style={{padding:'0 12px'}}>
              <div style={{fontSize:'16px',fontWeight:800,marginBottom:'10px',color:'#1a1a1a'}}>Available Lab Tests</div>
              {scanTypes.filter(st=>(st.category||'lab')==='lab').length===0&&<div style={{color:'#999',fontSize:'13px',padding:'20px',textAlign:'center'}}>Loading...</div>}
              {scanTypes.filter(st=>(st.category||'lab')==='lab').map(st=>(
                <div key={st._id} style={{background:'white',borderRadius:'14px',padding:'14px',marginBottom:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
                  <div style={{display:'flex',alignItems:'center',gap:'12px',marginBottom:(st.description||st.reportTime||st.sampleType||(st.includes&&st.includes.length>0))?'10px':0}}>
                    {st.image ? (
                      <img src={st.image} alt={st.name} style={{width:'56px',height:'56px',borderRadius:'12px',objectFit:'cover',flexShrink:0}}/>
                    ) : (
                      <div style={{width:'56px',height:'56px',borderRadius:'12px',background:'#eef3fb',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'26px',flexShrink:0}}>🩻</div>
                    )}
                    <div style={{flex:1}}>
                      <div style={{fontWeight:700,fontSize:'14px',color:'#1a1a1a'}}>{st.name}</div>
                      <div style={{display:'flex',alignItems:'center',gap:'6px',marginTop:'2px'}}>
                        <span style={{color:secondaryColor,fontWeight:800,fontSize:'14px'}}>₹{st.basePrice}</span>
                        {st.mrpPrice>st.basePrice&&<span style={{color:'#999',textDecoration:'line-through',fontSize:'11px'}}>₹{st.mrpPrice}</span>}
                      </div>
                    </div>
                    <button onClick={()=>{setSelectedScan(st);setScanBookingMsg('');}} style={{background:primaryColor,color:'white',border:'none',borderRadius:'10px',padding:'10px 16px',fontSize:'12px',fontWeight:700,cursor:'pointer',flexShrink:0}}>Book Now</button>
                  </div>
                  {st.description&&<div style={{fontSize:'12px',color:'#666',lineHeight:'1.5',marginBottom:'8px'}}>{st.description}</div>}
                  {(st.reportTime||st.sampleType)&&(
                    <div style={{display:'flex',gap:'8px',flexWrap:'wrap',marginBottom:(st.includes&&st.includes.length>0)?'8px':0}}>
                      {st.reportTime&&<span style={{background:'#f0f7ff',color:'#1565c0',fontSize:'10px',fontWeight:700,padding:'4px 10px',borderRadius:'20px'}}>⏱️ Report in {st.reportTime}</span>}
                      {st.sampleType&&<span style={{background:'#f0fffe',color:secondaryColor,fontSize:'10px',fontWeight:700,padding:'4px 10px',borderRadius:'20px'}}>🧪 {st.sampleType}</span>}
                    </div>
                  )}
                  {st.includes&&st.includes.length>0&&(
                    <div style={{display:'flex',flexWrap:'wrap',gap:'6px'}}>
                      {st.includes.map((inc,i)=>(
                        <span key={i} style={{background:'#f8f9fa',color:'#555',fontSize:'10px',padding:'3px 8px',borderRadius:'6px',border:'1px solid #f0f0f0'}}>✓ {inc}</span>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* SCAN SECTION */}
          {healthSection==='scan'&&(
            <div style={{padding:'0 12px'}}>
              <div style={{fontSize:'16px',fontWeight:800,marginBottom:'10px',color:'#1a1a1a'}}>Available Scans</div>
              {scanTypes.filter(st=>st.category==='scan').length===0&&<div style={{color:'#999',fontSize:'13px',padding:'20px',textAlign:'center'}}>Loading...</div>}
              {scanTypes.filter(st=>st.category==='scan').map(st=>(
                <div key={st._id} style={{background:'white',borderRadius:'14px',padding:'14px',marginBottom:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'}}>
                  <div style={{display:'flex',alignItems:'center',gap:'12px',marginBottom:(st.description||st.reportTime||st.sampleType||(st.includes&&st.includes.length>0))?'10px':0}}>
                    {st.image ? (
                      <img src={st.image} alt={st.name} style={{width:'56px',height:'56px',borderRadius:'12px',objectFit:'cover',flexShrink:0}}/>
                    ) : (
                      <div style={{width:'56px',height:'56px',borderRadius:'12px',background:'#eef3fb',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'26px',flexShrink:0}}>🩻</div>
                    )}
                    <div style={{flex:1}}>
                      <div style={{fontWeight:700,fontSize:'14px',color:'#1a1a1a'}}>{st.name}</div>
                      <div style={{display:'flex',alignItems:'center',gap:'6px',marginTop:'2px'}}>
                        <span style={{color:secondaryColor,fontWeight:800,fontSize:'14px'}}>₹{st.basePrice}</span>
                        {st.mrpPrice>st.basePrice&&<span style={{color:'#999',textDecoration:'line-through',fontSize:'11px'}}>₹{st.mrpPrice}</span>}
                      </div>
                    </div>
                    <button onClick={()=>{setSelectedScan(st);setScanBookingMsg('');}} style={{background:primaryColor,color:'white',border:'none',borderRadius:'10px',padding:'10px 16px',fontSize:'12px',fontWeight:700,cursor:'pointer',flexShrink:0}}>Book Now</button>
                  </div>
                  {st.description&&<div style={{fontSize:'12px',color:'#666',lineHeight:'1.5',marginBottom:'8px'}}>{st.description}</div>}
                  {(st.reportTime||st.sampleType)&&(
                    <div style={{display:'flex',gap:'8px',flexWrap:'wrap',marginBottom:(st.includes&&st.includes.length>0)?'8px':0}}>
                      {st.reportTime&&<span style={{background:'#f0f7ff',color:'#1565c0',fontSize:'10px',fontWeight:700,padding:'4px 10px',borderRadius:'20px'}}>⏱️ Report in {st.reportTime}</span>}
                      {st.sampleType&&<span style={{background:'#f0fffe',color:secondaryColor,fontSize:'10px',fontWeight:700,padding:'4px 10px',borderRadius:'20px'}}>📷 {st.sampleType}</span>}
                    </div>
                  )}
                  {st.includes&&st.includes.length>0&&(
                    <div style={{display:'flex',flexWrap:'wrap',gap:'6px'}}>
                      {st.includes.map((inc,i)=>(
                        <span key={i} style={{background:'#f8f9fa',color:'#555',fontSize:'10px',padding:'3px 8px',borderRadius:'6px',border:'1px solid #f0f0f0'}}>✓ {inc}</span>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* DOCTOR CONSULTATION SECTION */}
          {healthSection==='consult'&&(
            <div style={{padding:'0 12px'}}>
              <div style={{background:'linear-gradient(135deg,#f0f7ff,#e8f5e9)',borderRadius:'14px',padding:'14px',marginBottom:'14px',border:'1px solid #c8e6c9'}}>
                <div style={{fontWeight:800,fontSize:'13px',color:'#1a1a1a',marginBottom:'8px',display:'flex',alignItems:'center',gap:'6px'}}>🤖 Not sure which doctor? Describe your symptoms</div>
                <input value={symptomText} onChange={e=>setSymptomText(e.target.value)} placeholder="e.g. fever, headache, skin rash..." style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',fontSize:'13px',boxSizing:'border-box',marginBottom:'8px',background:'white'}}/>
                {suggestedSpecializations.length>0&&(
                  <div>
                    <div style={{fontSize:'11px',color:'#555',marginBottom:'6px'}}>Suggested specialist{suggestedSpecializations.length>1?'s':''}:</div>
                    <div style={{display:'flex',flexWrap:'wrap',gap:'6px'}}>
                      {suggestedSpecializations.map((spec,i)=>(
                        <span key={i} onClick={()=>{const match=consultTypes.find(ct=>ct.specialization===spec);if(match){setSelectedConsult(match);setConsultBookingMsg('');}}} style={{background:primaryColor,color:'white',padding:'7px 14px',borderRadius:'20px',fontSize:'12px',fontWeight:700,cursor:'pointer'}}>👨‍⚕️ {spec}</span>
                      ))}
                    </div>
                  </div>
                )}
                <div style={{fontSize:'10px',color:'#999',marginTop:'8px'}}>⚠️ This is a suggestion only, not a medical diagnosis. Please consult a doctor for accurate diagnosis.</div>
              </div>

              <div style={{fontSize:'16px',fontWeight:800,marginBottom:'10px',color:'#1a1a1a'}}>Consult a Doctor</div>
              {consultTypes.length===0&&<div style={{color:'#999',fontSize:'13px',padding:'20px',textAlign:'center'}}>Loading...</div>}
              {consultTypes.map(ct=>(
                <div key={ct._id} style={{background:'white',borderRadius:'14px',padding:'14px',marginBottom:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)',display:'flex',alignItems:'center',gap:'12px'}}>
                  <div style={{width:'52px',height:'52px',borderRadius:'50%',background:'#f0f7ff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'24px',flexShrink:0}}>👨‍⚕️</div>
                  <div style={{flex:1}}>
                    <div style={{fontWeight:700,fontSize:'14px',color:'#1a1a1a'}}>{ct.doctorName||ct.specialization}</div>
                    <div style={{color:'#888',fontSize:'11px',marginTop:'1px'}}>{ct.specialization}{ct.qualification?' • '+ct.qualification:''}{ct.experience?' • '+ct.experience:''}</div>
                    <div style={{color:secondaryColor,fontWeight:800,fontSize:'13px',marginTop:'4px'}}>₹{ct.consultFee} consult fee</div>
                  </div>
                  <button onClick={()=>{setSelectedConsult(ct);setConsultBookingMsg('');}} style={{background:primaryColor,color:'white',border:'none',borderRadius:'10px',padding:'10px 16px',fontSize:'12px',fontWeight:700,cursor:'pointer',flexShrink:0}}>Consult</button>
                </div>
              ))}
            </div>
          )}

          {/* SCAN BOOKING MODAL */}
          {selectedScan&&(
            <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:200,display:'flex',alignItems:'flex-end'}} onClick={()=>setSelectedScan(null)}>
              <div onClick={e=>e.stopPropagation()} style={{background:'white',width:'100%',maxHeight:'85vh',overflowY:'auto',borderRadius:'18px 18px 0 0',padding:'20px'}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'14px'}}>
                  <div style={{fontSize:'18px',fontWeight:700}}>Book {selectedScan.name}</div>
                  <button onClick={()=>setSelectedScan(null)} style={{background:'none',border:'none',fontSize:'22px',color:'#888'}}>×</button>
                </div>
                <div style={{background:'#e8f5e9',color:'#2e7d32',fontWeight:700,padding:'6px 10px',borderRadius:'8px',display:'inline-block',fontSize:'13px',marginBottom:'14px'}}>₹{selectedScan.basePrice} onwards</div>

                <input placeholder="பெயர் (Name)" value={scanForm.customerName} onChange={e=>setScanForm({...scanForm,customerName:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
                <input placeholder="Phone Number" value={scanForm.phone} onChange={e=>setScanForm({...scanForm,phone:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
                <textarea placeholder="முகவரி (Address)" value={scanForm.address} onChange={e=>setScanForm({...scanForm,address:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',minHeight:'60px',boxSizing:'border-box'}} />
                <input type="date" value={scanForm.preferredDate} onChange={e=>setScanForm({...scanForm,preferredDate:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
                <select value={scanForm.preferredSlot} onChange={e=>setScanForm({...scanForm,preferredSlot:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'14px',fontSize:'14px',boxSizing:'border-box'}}>
                  <option value="">-- Time Slot தேர்வு செய்யவும் --</option>
                  <option>08:00 AM - 10:00 AM</option>
                  <option>10:00 AM - 12:00 PM</option>
                  <option>12:00 PM - 02:00 PM</option>
                  <option>02:00 PM - 04:00 PM</option>
                  <option>04:00 PM - 06:00 PM</option>
                  <option>06:00 PM - 08:00 PM</option>
                </select>

                <button onClick={async()=>{
                  if(!scanForm.customerName||!scanForm.phone||!scanForm.address||!scanForm.preferredDate||!scanForm.preferredSlot){setScanBookingMsg('தேவையான விவரங்கள் நிரப்பவும்');return;}
                  setScanBookingMsg('Booking...');
                  try{
                    const res=await fetch(`${API}/scans/book`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({scanType:selectedScan._id,...scanForm})});
                    const data=await res.json();
                    if(data.success){setScanBookingMsg(data.message);setScanForm({customerName:'',phone:'',address:'',preferredDate:'',preferredSlot:''});setTimeout(()=>setSelectedScan(null),2000);}
                    else{setScanBookingMsg(data.error||'ஏதோ தவறு நடந்தது');}
                  }catch(err){setScanBookingMsg('Network error. மீண்டும் முயற்சிக்கவும்.');}
                }} style={{width:'100%',background:primaryColor,color:'white',border:'none',padding:'14px',borderRadius:'10px',fontWeight:700,fontSize:'15px',cursor:'pointer'}}>Book Now</button>

                {scanBookingMsg&&<div style={{textAlign:'center',padding:'10px',marginTop:'10px',borderRadius:'9px',fontSize:'13.5px',background:scanBookingMsg.includes('வெற்றிகரமாக')?'#e8f5e9':'#ffebee',color:scanBookingMsg.includes('வெற்றிகரமாக')?'#2e7d32':'#c62828'}}>{scanBookingMsg}</div>}
              </div>
            </div>
          )}

          {/* CONSULTATION BOOKING MODAL */}
          {selectedConsult&&(
            <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:200,display:'flex',alignItems:'flex-end'}} onClick={()=>setSelectedConsult(null)}>
              <div onClick={e=>e.stopPropagation()} style={{background:'white',width:'100%',maxHeight:'85vh',overflowY:'auto',borderRadius:'18px 18px 0 0',padding:'20px'}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'14px'}}>
                  <div style={{fontSize:'18px',fontWeight:700}}>Consult {selectedConsult.doctorName||selectedConsult.specialization}</div>
                  <button onClick={()=>setSelectedConsult(null)} style={{background:'none',border:'none',fontSize:'22px',color:'#888'}}>×</button>
                </div>
                <div style={{background:'#e8f5e9',color:'#2e7d32',fontWeight:700,padding:'6px 10px',borderRadius:'8px',display:'inline-block',fontSize:'13px',marginBottom:'14px'}}>₹{selectedConsult.consultFee} consult fee</div>

                <input placeholder="பெயர் (Name)" value={consultForm.customerName} onChange={e=>setConsultForm({...consultForm,customerName:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
                <input placeholder="Phone Number" value={consultForm.phone} onChange={e=>setConsultForm({...consultForm,phone:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px',marginBottom:'10px'}}>
                  <input placeholder="Age" type="number" value={consultForm.age} onChange={e=>setConsultForm({...consultForm,age:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',fontSize:'14px',boxSizing:'border-box'}} />
                  <select value={consultForm.gender} onChange={e=>setConsultForm({...consultForm,gender:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',fontSize:'14px',boxSizing:'border-box',background:'white'}}>
                    <option value="">Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <textarea placeholder="Symptoms / Reason for consultation" value={consultForm.symptoms} onChange={e=>setConsultForm({...consultForm,symptoms:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',minHeight:'60px',boxSizing:'border-box'}} />
                <div style={{display:'flex',gap:'8px',marginBottom:'10px'}}>
                  {[['video','📹 Video'],['audio','📞 Audio']].map(([val,label])=>(
                    <span key={val} onClick={()=>setConsultForm({...consultForm,mode:val})} style={{flex:1,textAlign:'center',padding:'10px',borderRadius:'9px',cursor:'pointer',fontSize:'13px',fontWeight:700,background:consultForm.mode===val?primaryColor:'#f5f5f5',color:consultForm.mode===val?'white':'#555'}}>{label}</span>
                  ))}
                </div>
                <input type="date" value={consultForm.preferredDate} onChange={e=>setConsultForm({...consultForm,preferredDate:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
                <select value={consultForm.preferredSlot} onChange={e=>setConsultForm({...consultForm,preferredSlot:e.target.value})} style={{width:'100%',padding:'11px',border:'1px solid #ddd',borderRadius:'9px',marginBottom:'14px',fontSize:'14px',boxSizing:'border-box'}}>
                  <option value="">-- Time Slot தேர்வு செய்யவும் --</option>
                  <option>08:00 AM - 10:00 AM</option>
                  <option>10:00 AM - 12:00 PM</option>
                  <option>12:00 PM - 02:00 PM</option>
                  <option>02:00 PM - 04:00 PM</option>
                  <option>04:00 PM - 06:00 PM</option>
                  <option>06:00 PM - 08:00 PM</option>
                </select>

                <button onClick={async()=>{
                  if(!consultForm.customerName||!consultForm.phone||!consultForm.preferredDate||!consultForm.preferredSlot){setConsultBookingMsg('தேவையான விவரங்கள் நிரப்பவும்');return;}
                  setConsultBookingMsg('Booking...');
                  try{
                    const res=await fetch(`${API}/consultations/book`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({consultationType:selectedConsult._id,...consultForm})});
                    const data=await res.json();
                    if(data.success){setConsultBookingMsg(data.message||'உங்கள் ஆலோசனை முன்பதிவு வெற்றிகரமாக செய்யப்பட்டது!');setConsultForm({customerName:'',phone:'',age:'',gender:'',symptoms:'',mode:'video',preferredDate:'',preferredSlot:''});setTimeout(()=>setSelectedConsult(null),2000);}
                    else{setConsultBookingMsg(data.error||'ஏதோ தவறு நடந்தது');}
                  }catch(err){setConsultBookingMsg('Network error. மீண்டும் முயற்சிக்கவும்.');}
                }} style={{width:'100%',background:primaryColor,color:'white',border:'none',padding:'14px',borderRadius:'10px',fontWeight:700,fontSize:'15px',cursor:'pointer'}}>Confirm Booking</button>

                {consultBookingMsg&&<div style={{textAlign:'center',padding:'10px',marginTop:'10px',borderRadius:'9px',fontSize:'13.5px',background:consultBookingMsg.includes('வெற்றிகரமாக')?'#e8f5e9':'#ffebee',color:consultBookingMsg.includes('வெற்றிகரமாக')?'#2e7d32':'#c62828'}}>{consultBookingMsg}</div>}
              </div>
            </div>
          )}
        </div>
      )}

      {/* CART TAB */}
      {tab==='cart'&&(
        <div style={{padding:'12px',background:'#f4f6fa',minHeight:'70vh'}}>
          {(()=>{
            const mrpTotal = cart.reduce((s,i)=>s+((i.mrp||i.price))*i.qty,0);
            const saved = mrpTotal - cartTotal;
            const rxItems = cart.filter(i=>i.rx);
            const cdesc = c => (c.discountType==='percent' ? `${c.discountValue}% off`+(c.maxDiscount?` up to ₹${c.maxDiscount}`:'') : `Flat ₹${c.discountValue} off`) + (c.minOrderValue?` on orders above ₹${c.minOrderValue}`:'');
            if (cart.length===0) return (
              <div style={{textAlign:'center',padding:'56px 20px',background:'white',borderRadius:'16px',border:'1px solid #eceff4'}}>
                <div style={{fontSize:'60px',marginBottom:'10px'}}>🛒</div>
                <h3 style={{color:'#101828',fontWeight:800,margin:'0 0 6px',fontSize:'17px'}}>Your cart is empty</h3>
                <p style={{color:'#667085',fontSize:'13px',margin:'0 0 20px'}}>Add medicines to get started</p>
                <button onClick={()=>setTab('search')} style={{padding:'12px 28px',background:`linear-gradient(135deg,${primaryColor},#0783ED)`,color:'white',border:'none',borderRadius:'12px',fontSize:'14px',fontWeight:700,cursor:'pointer'}}>Browse Medicines</button>
              </div>
            );
            return (
              <div>
                <div style={{display:'flex',alignItems:'baseline',justifyContent:'space-between',margin:'2px 2px 12px'}}>
                  <h2 style={{margin:0,fontSize:'20px',fontWeight:800,color:'#101828'}}>My Cart</h2>
                  <span style={{fontSize:'12px',color:'#8a94a6',fontWeight:600}}>{cartCount} item{cartCount===1?'':'s'}</span>
                </div>

                {rxItems.length>0&&(
                  <div style={{background:'#fff4f2',border:'1px solid #f5c6c0',borderRadius:'14px',padding:'12px 14px',marginBottom:'12px',display:'flex',gap:'10px',alignItems:'flex-start'}}>
                    <span style={{background:'#e5392d',color:'white',fontSize:'10px',fontWeight:800,padding:'3px 8px',borderRadius:'6px',flexShrink:0,marginTop:'1px'}}>Rx</span>
                    <div style={{flex:1}}>
                      <div style={{fontWeight:800,color:'#b42318',fontSize:'13px'}}>Prescription required</div>
                      <div style={{color:'#7a271a',fontSize:'12px',marginTop:'2px',lineHeight:'1.4'}}>{rxItems.length} medicine{rxItems.length===1?'':'s'} in your cart need{rxItems.length===1?'s':''} a valid prescription. Upload it and wait for pharmacist approval before ordering.</div>
                      <button onClick={()=>{setPage('prescription');fetchMyPrescriptions();}} style={{marginTop:'8px',padding:'7px 14px',background:'#e5392d',color:'white',border:'none',borderRadius:'8px',fontSize:'12px',fontWeight:700,cursor:'pointer'}}>Upload / View Prescriptions</button>
                    </div>
                  </div>
                )}

                {cart.map(item=>(
                  <div key={item._id} style={{background:'white',borderRadius:'14px',padding:'12px',marginBottom:'10px',border:'1px solid #eceff4',boxShadow:'0 1px 3px rgba(16,24,40,0.05)'}}>
                    <div style={{display:'flex',gap:'12px'}}>
                      <div style={{position:'relative',width:'56px',height:'56px',flexShrink:0,borderRadius:'12px',background:'linear-gradient(180deg,#eef5ff,#ffffff)',border:'1px solid #e6eefb',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'24px'}}>
                        💊
                        {item.rx&&<span style={{position:'absolute',top:'-5px',left:'-5px',background:'#e5392d',color:'white',fontSize:'9px',fontWeight:800,padding:'1px 6px',borderRadius:'6px'}}>Rx</span>}
                      </div>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontWeight:700,color:'#101828',fontSize:'13px',lineHeight:'1.3',display:'-webkit-box',WebkitLineClamp:2,WebkitBoxOrient:'vertical',overflow:'hidden',wordBreak:'break-word'}}>{item.name}</div>
                        {item.generic&&<div style={{color:'#8a94a6',fontSize:'11px',marginTop:'1px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{item.generic}</div>}
                        <div style={{display:'flex',alignItems:'baseline',gap:'6px',marginTop:'4px'}}>
                          <span style={{fontWeight:800,color:'#101828',fontSize:'15px'}}>₹{rsFmt(item.price*item.qty)}</span>
                          {item.mrp>item.price&&<span style={{color:'#98a2b3',textDecoration:'line-through',fontSize:'11px'}}>₹{rsFmt(item.mrp*item.qty)}</span>}
                        </div>
                      </div>
                      <button onClick={()=>updateQty(item._id,0)} title="Remove" style={{alignSelf:'flex-start',background:'#fdecea',border:'none',borderRadius:'8px',width:'30px',height:'30px',color:'#c62828',cursor:'pointer',fontSize:'13px',flexShrink:0}}>🗑️</button>
                    </div>
                    <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginTop:'10px',paddingTop:'10px',borderTop:'1px dashed #eceff4'}}>
                      <span style={{fontSize:'11px',color:'#8a94a6'}}>₹{rsFmt(item.price)} each</span>
                      <div style={{display:'flex',alignItems:'center',background:primaryColor,borderRadius:'10px',padding:'2px'}}>
                        <button onClick={()=>updateQty(item._id,item.qty-1)} style={{width:'30px',height:'28px',border:'none',background:'transparent',color:'white',fontSize:'17px',fontWeight:700,cursor:'pointer',padding:0}}>−</button>
                        <span style={{color:'white',fontWeight:800,fontSize:'13px',minWidth:'24px',textAlign:'center'}}>{item.qty}</span>
                        <button onClick={()=>updateQty(item._id,item.qty+1)} style={{width:'30px',height:'28px',border:'none',background:'transparent',color:'white',fontSize:'17px',fontWeight:700,cursor:'pointer',padding:0}}>+</button>
                      </div>
                    </div>
                  </div>
                ))}

                {activeCoupons.length>0&&(
                  <div style={{background:'white',borderRadius:'14px',padding:'12px 14px',marginBottom:'10px',border:'1px solid #eceff4'}}>
                    <div style={{fontWeight:800,fontSize:'13px',color:'#101828',marginBottom:'8px'}}>🏷️ Offers for you</div>
                    {activeCoupons.slice(0,3).map(c=>(
                      <div key={c.code} style={{display:'flex',alignItems:'center',gap:'10px',marginBottom:'8px'}}>
                        <span style={{border:'1.5px dashed '+primaryColor,color:primaryColor,borderRadius:'8px',padding:'3px 9px',fontSize:'12px',fontWeight:800,flexShrink:0}}>{c.code}</span>
                        <span style={{fontSize:'12px',color:'#475467'}}>{cdesc(c)}</span>
                      </div>
                    ))}
                    <div style={{fontSize:'11px',color:'#8a94a6'}}>Apply these at checkout.</div>
                  </div>
                )}

                <div style={{background:'white',borderRadius:'14px',padding:'14px',marginBottom:'12px',border:'1px solid #eceff4'}}>
                  <div style={{fontWeight:800,fontSize:'14px',color:'#101828',marginBottom:'10px'}}>Bill details</div>
                  {saved>0&&<div style={{display:'flex',justifyContent:'space-between',marginBottom:'8px',fontSize:'13px',color:'#475467'}}><span>Item total (MRP)</span><span>₹{rsFmt(mrpTotal)}</span></div>}
                  {saved>0&&<div style={{display:'flex',justifyContent:'space-between',marginBottom:'8px',fontSize:'13px',color:secondaryColor,fontWeight:600}}><span>Product discount</span><span>-₹{rsFmt(saved)}</span></div>}
                  <div style={{display:'flex',justifyContent:'space-between',marginBottom:'8px',fontSize:'13px',color:'#475467'}}><span>Subtotal</span><span>₹{rsFmt(cartTotal)}</span></div>
                  <div style={{display:'flex',justifyContent:'space-between',marginBottom:'10px',fontSize:'13px',color:secondaryColor}}><span>Delivery charges</span><span style={{fontWeight:700}}>FREE</span></div>
                  <div style={{display:'flex',justifyContent:'space-between',fontSize:'16px',fontWeight:800,color:'#101828',borderTop:'1px solid #f2f4f7',paddingTop:'10px'}}><span>To pay</span><span>₹{rsFmt(cartTotal)}</span></div>
                  {saved>0&&<div style={{marginTop:'10px',background:'#e8f5e9',color:secondaryColor,borderRadius:'8px',padding:'8px 10px',fontSize:'12px',fontWeight:700,textAlign:'center'}}>🎉 You are saving ₹{rsFmt(saved)} on this order</div>}
                </div>

                <div style={{position:'sticky',bottom:'72px',zIndex:50,background:'white',borderRadius:'16px',padding:'12px 14px',boxShadow:'0 8px 24px rgba(16,24,40,0.18)',display:'flex',alignItems:'center',gap:'12px',border:'1px solid #eceff4'}}>
                  <div style={{minWidth:0}}>
                    <div style={{fontSize:'11px',color:'#8a94a6',fontWeight:600}}>To pay</div>
                    <div style={{fontSize:'19px',fontWeight:800,color:'#101828'}}>₹{rsFmt(cartTotal)}</div>
                  </div>
                  <button onClick={()=>{setPage('checkout');fetchAddresses();}} style={{flex:1,padding:'14px',background:`linear-gradient(135deg,${primaryColor},#0783ED)`,color:'white',border:'none',borderRadius:'12px',fontSize:'15px',fontWeight:700,cursor:'pointer',boxShadow:'0 6px 16px rgba(0,88,198,0.28)'}}>Proceed to Checkout →</button>
                </div>
              </div>
            );
          })()}
        </div>
      )}

      {/* ORDERS TAB */}
      {tab==='orders'&&(
        <div style={{padding:'12px',background:'#f4f6fa',minHeight:'70vh'}}>
          {(()=>{
            const ST = {
              cancelled:['✕ Cancelled','#fdecea','#c62828'],
              pending:['⏳ Processing','#fff4e5','#b45309'],
              confirmed:['✅ Confirmed','#e8f3ff','#1565c0'],
              preparing:['🔄 Preparing','#e8f3ff','#1565c0'],
              packed:['📦 Packed','#e8f3ff','#1565c0'],
              ready:['📦 Ready','#e8f3ff','#1565c0'],
              delivered:['✅ Delivered','#e8f5e9',secondaryColor],
            };
            const STEP = {pending:1,confirmed:2,preparing:2,packed:3,ready:3};
            const isActive = o => !['delivered','cancelled'].includes(o.status);
            const nActive = orders.filter(isActive).length;
            const nDone = orders.filter(o=>o.status==='delivered').length;
            const nCancel = orders.filter(o=>o.status==='cancelled').length;
            const filtered = orders.filter(o=> orderFilter==='all' ? true : orderFilter==='active' ? isActive(o) : o.status===orderFilter);
            const tabs = [['all','All',orders.length],['active','Active',nActive],['delivered','Delivered',nDone],['cancelled','Cancelled',nCancel]];
            const pill = (bg,fg,border) => ({flex:1,padding:'10px 6px',background:bg,color:fg,border:border||'none',borderRadius:'10px',fontSize:'12px',fontWeight:700,cursor:'pointer'});
            return (
              <div>
                <div style={{display:'flex',alignItems:'baseline',justifyContent:'space-between',margin:'2px 2px 12px'}}>
                  <h2 style={{margin:0,fontSize:'20px',fontWeight:800,color:'#101828'}}>My Orders</h2>
                  {orders.length>0&&<span style={{fontSize:'12px',color:'#8a94a6',fontWeight:600}}>{orders.length} total</span>}
                </div>
                {orders.length>0&&(
                  <div style={{display:'flex',gap:'8px',overflowX:'auto',paddingBottom:'4px',marginBottom:'12px',scrollbarWidth:'none'}}>
                    {tabs.map(([key,label,n])=>(
                      <span key={key} onClick={()=>setOrderFilter(key)} style={{padding:'0 14px',height:'34px',display:'inline-flex',alignItems:'center',borderRadius:'999px',cursor:'pointer',fontSize:'12px',fontWeight:600,whiteSpace:'nowrap',flexShrink:0,background:orderFilter===key?primaryColor:'white',color:orderFilter===key?'white':'#475467',border:`1px solid ${orderFilter===key?primaryColor:'#e3e8ef'}`}}>{label} ({n})</span>
                    ))}
                  </div>
                )}
                {filtered.length===0?(
                  <div style={{textAlign:'center',padding:'46px 20px',background:'white',borderRadius:'16px',border:'1px solid #eceff4'}}>
                    <div style={{fontSize:'52px',marginBottom:'10px'}}>📦</div>
                    <div style={{fontWeight:800,color:'#101828',fontSize:'16px',marginBottom:'4px'}}>{orders.length===0?'No orders yet':'No orders here'}</div>
                    <p style={{color:'#667085',fontSize:'13px',margin:'0 0 16px'}}>{orders.length===0?'Your medicine orders will show up here.':'Try another tab above.'}</p>
                    {orders.length===0&&<button onClick={()=>setTab('search')} style={{padding:'11px 24px',background:primaryColor,color:'white',border:'none',borderRadius:'10px',fontSize:'13px',fontWeight:700,cursor:'pointer'}}>Browse Medicines</button>}
                  </div>
                ):filtered.map(order=>{
                  const known = ST[order.status];
                  const raw = String(order.status||'').replace(/[_-]/g,' ');
                  const [label,bg,fg] = known || [raw.charAt(0).toUpperCase()+raw.slice(1),'#e8f3ff','#1565c0'];
                  const active = isActive(order);
                  const step = STEP[order.status] || 4;
                  const names = (order.items||[]).map(i=>i.name);
                  const shown = names.slice(0,2).join(', ');
                  const more = names.length>2 ? ` +${names.length-2} more` : '';
                  const canCancel = ['pending','confirmed','preparing','packed'].includes(order.status);
                  const when = order.createdAt ? new Date(order.createdAt).toLocaleDateString('en-IN',{day:'numeric',month:'short'}) : '';
                  return (
                    <div key={order._id} style={{background:'white',borderRadius:'16px',padding:'14px',marginBottom:'12px',border:'1px solid #eceff4',boxShadow:'0 1px 3px rgba(16,24,40,0.06)'}}>
                      <div onClick={()=>setOrderDetailView(order)} style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',cursor:'pointer',gap:'10px'}}>
                        <div style={{minWidth:0}}>
                          <div style={{fontWeight:800,color:'#101828',fontSize:'15px'}}>#{order.orderId}</div>
                          <div style={{color:'#8a94a6',fontSize:'12px',marginTop:'2px'}}>{when}{when?' • ':''}{order.items?.length||0} item{(order.items?.length||0)===1?'':'s'}</div>
                        </div>
                        <span style={{background:bg,color:fg,padding:'5px 12px',borderRadius:'999px',fontSize:'11px',fontWeight:700,whiteSpace:'nowrap',flexShrink:0}}>{label}</span>
                      </div>
                      <div onClick={()=>setOrderDetailView(order)} style={{color:'#475467',fontSize:'13px',margin:'10px 0',lineHeight:'1.4',cursor:'pointer'}}>{shown}<span style={{color:'#8a94a6'}}>{more}</span></div>
                      {active&&(
                        <div style={{marginBottom:'12px'}}>
                          <div style={{display:'flex',gap:'4px'}}>
                            {[1,2,3,4].map(n=>(<div key={n} style={{flex:1,height:'5px',borderRadius:'3px',background:n<=step?secondaryColor:'#e4e7ec'}}></div>))}
                          </div>
                          <div style={{display:'flex',justifyContent:'space-between',marginTop:'4px',fontSize:'9px',color:'#98a2b3',fontWeight:600}}>
                            <span>Placed</span><span>Confirmed</span><span>Packed</span><span>On the way</span>
                          </div>
                        </div>
                      )}
                      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',paddingTop:'10px',borderTop:'1px solid #f2f4f7',marginBottom:'12px'}}>
                        <div>
                          <div style={{fontWeight:800,color:'#101828',fontSize:'17px'}}>₹{order.total}</div>
                          <div style={{fontSize:'10px',color:'#8a94a6',marginTop:'1px'}}>{order.paymentMethod==='COD'?'Cash on Delivery':order.paymentMethod?'Online payment':''}</div>
                        </div>
                        {order.paymentStatus==='paid'&&<span style={{background:'#e8f5e9',color:secondaryColor,fontSize:'11px',fontWeight:700,padding:'4px 10px',borderRadius:'999px'}}>✓ Paid</span>}
                      </div>
                      <div style={{display:'flex',gap:'8px'}}>
                        {active?(
                          <button onClick={()=>fetchTracking(order._id)} style={pill(primaryColor,'white')}>Track Order</button>
                        ):(
                          <button onClick={()=>quickReorder(order)} style={pill(primaryColor,'white')}>🔁 Reorder</button>
                        )}
                        {active&&<button onClick={()=>quickReorder(order)} style={pill('white',primaryColor,`1px solid ${primaryColor}`)}>🔁 Reorder</button>}
                        {order.status==='delivered'&&<button onClick={()=>requestReturn(order._id)} style={pill('white','#b45309','1px solid #f5d9b5')}>↩ Return</button>}
                        {order.status==='cancelled'&&<button onClick={()=>setOrderDetailView(order)} style={pill('white','#475467','1px solid #e3e8ef')}>Details</button>}
                        {canCancel&&<button onClick={()=>cancelOrder(order._id)} style={pill('#fdecea','#c62828')}>Cancel</button>}
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })()}
        </div>
      )}

      {/* ORDER DETAIL MODAL */}
      {orderDetailView&&(
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'16px'}} onClick={()=>setOrderDetailView(null)}>
          <div onClick={e=>e.stopPropagation()} style={{background:'white',borderRadius:'20px',padding:'22px',width:'100%',maxWidth:'420px',maxHeight:'85vh',overflowY:'auto'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
              <h3 style={{margin:0,fontSize:'18px',fontWeight:'800',color:'#1a1a1a'}}>🧾 Order #{orderDetailView.orderId}</h3>
              <button onClick={()=>setOrderDetailView(null)} style={{background:'none',border:'none',fontSize:'22px',cursor:'pointer',color:'#999'}}>×</button>
            </div>
            <div style={{fontSize:'12px',color:'#999',marginBottom:'14px'}}>{orderDetailView.createdAt?new Date(orderDetailView.createdAt).toLocaleString():''}</div>
            <div style={{background:'#f8f9fa',borderRadius:'12px',padding:'14px',marginBottom:'14px'}}>
              <div style={{fontWeight:700,fontSize:'13px',marginBottom:'10px',color:'#1a1a1a'}}>Items</div>
              {orderDetailView.items?.map((it,i)=>(
                <div key={i} style={{display:'flex',justifyContent:'space-between',fontSize:'12px',color:'#555',marginBottom:'8px'}}>
                  <span>{it.name} x{it.qty}</span><span style={{fontWeight:700,color:'#1a1a1a'}}>₹{it.price*it.qty}</span>
                </div>
              ))}
              <div style={{borderTop:'1px dashed #ddd',marginTop:'8px',paddingTop:'8px',display:'flex',justifyContent:'space-between'}}>
                <span style={{fontSize:'13px',fontWeight:800,color:'#1a1a1a'}}>Total Paid</span>
                <span style={{fontSize:'13px',fontWeight:800,color:primaryColor}}>₹{orderDetailView.total}</span>
              </div>
            </div>
            <div style={{background:'#f8f9fa',borderRadius:'12px',padding:'14px',marginBottom:'14px'}}>
              <div style={{fontWeight:700,fontSize:'13px',marginBottom:'8px',color:'#1a1a1a'}}>📍 Delivery Address</div>
              <div style={{fontSize:'12px',color:'#666'}}>{orderDetailView.address}</div>
            </div>
            <div style={{background:'#f8f9fa',borderRadius:'12px',padding:'14px'}}>
              <div style={{fontWeight:700,fontSize:'13px',marginBottom:'8px',color:'#1a1a1a'}}>💳 Payment</div>
              <div style={{fontSize:'12px',color:'#666'}}>{orderDetailView.paymentMethod||'N/A'} • {orderDetailView.paymentStatus==='paid'?'✅ Paid':'⏳ Pending'}</div>
              {orderDetailView.couponCode&&<div style={{fontSize:'12px',color:'#666',marginTop:'4px'}}>Coupon applied: {orderDetailView.couponCode}</div>}
            </div>
          </div>
        </div>
      )}

      {showEditProfile && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'16px'}} onClick={()=>setShowEditProfile(false)}>
          <div onClick={e=>e.stopPropagation()} style={{background:'white',borderRadius:'20px',padding:'22px',width:'100%',maxWidth:'380px'}}>
            <h3 style={{margin:'0 0 16px',fontSize:'18px',fontWeight:'800'}}>Edit Profile</h3>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'10px'}}>
              <input placeholder="First Name" value={editFirstName} onChange={e=>setEditFirstName(e.target.value)} style={{width:'100%',padding:'12px',border:'1px solid #ddd',borderRadius:'10px',fontSize:'14px',boxSizing:'border-box'}} />
              <input placeholder="Last Name" value={editLastName} onChange={e=>setEditLastName(e.target.value)} style={{width:'100%',padding:'12px',border:'1px solid #ddd',borderRadius:'10px',fontSize:'14px',boxSizing:'border-box'}} />
            </div>
            <input type="email" placeholder="Email ID" value={editEmail} onChange={e=>setEditEmail(e.target.value)} style={{width:'100%',padding:'12px',border:'1px solid #ddd',borderRadius:'10px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box'}} />
            <input placeholder="Mobile Number" value={phone} disabled style={{width:'100%',padding:'12px',border:'1px solid #eee',borderRadius:'10px',marginBottom:'10px',fontSize:'14px',boxSizing:'border-box',background:'#f5f5f5',color:'#999'}} />
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'14px'}}>
              <div>
                <label style={{fontSize:'11px',color:'#999',marginBottom:'4px',display:'block'}}>Date of Birth</label>
                <input type="date" value={editDob} onChange={e=>setEditDob(e.target.value)} style={{width:'100%',padding:'12px',border:'1px solid #ddd',borderRadius:'10px',fontSize:'13px',boxSizing:'border-box'}} />
              </div>
              <div>
                <label style={{fontSize:'11px',color:'#999',marginBottom:'4px',display:'block'}}>Gender</label>
                <select value={editGender} onChange={e=>setEditGender(e.target.value)} style={{width:'100%',padding:'12px',border:'1px solid #ddd',borderRadius:'10px',fontSize:'13px',boxSizing:'border-box',background:'white'}}>
                  <option value="">Select</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
              </div>
            </div>
            <div style={{display:'flex',gap:'10px'}}>
              <button onClick={()=>setShowEditProfile(false)} style={{flex:1,padding:'13px',background:'#f0f0f0',color:'#666',border:'none',borderRadius:'10px',fontSize:'14px',fontWeight:'700',cursor:'pointer'}}>Cancel</button>
              <button onClick={updateProfile} style={{flex:1,padding:'13px',background:primaryColor,color:'white',border:'none',borderRadius:'10px',fontSize:'14px',fontWeight:'700',cursor:'pointer'}}>Save</button>
            </div>
          </div>
        </div>
      )}

      {trackingData && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'16px'}} onClick={()=>setTrackingData(null)}>
          <div onClick={e=>e.stopPropagation()} style={{background:'white',borderRadius:'20px',padding:'22px',width:'100%',maxWidth:'420px',maxHeight:'80vh',overflowY:'auto'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
              <h3 style={{margin:0,fontSize:'18px',fontWeight:'800',color:'#1a1a1a'}}>📦 Track Order</h3>
              <button onClick={()=>setTrackingData(null)} style={{background:'none',border:'none',fontSize:'22px',cursor:'pointer',color:'#999'}}>×</button>
            </div>
            {trackingLoading || trackingData._loading ? (
              <div style={{textAlign:'center',padding:'30px',color:'#999'}}>Loading...</div>
            ) : trackingData.error ? (
              <div style={{textAlign:'center',padding:'30px',color:'#c62828'}}>Unable to load tracking info</div>
            ) : (
              <div>
                <div style={{textAlign:'center',marginBottom:'18px'}}>
                  <div style={{fontWeight:'800',color:primaryColor,fontSize:'16px'}}>#{trackingData.orderId}</div>
                  <span style={{display:'inline-block',marginTop:'8px',background:trackingData.status==='cancelled'?'#ffebee':trackingData.status==='delivered'?'#e8f5e9':'#e3f2fd',color:trackingData.status==='cancelled'?'#c62828':trackingData.status==='delivered'?secondaryColor:'#1565c0',padding:'6px 16px',borderRadius:'20px',fontSize:'13px',fontWeight:'700'}}>
                    {trackingData.status==='cancelled'?'✕ Cancelled':trackingData.status==='pending'?'⏳ Processing':trackingData.status==='delivered'?'✅ Delivered':trackingData.status==='preparing'?'🔄 Preparing':trackingData.status==='ready'?'📦 Ready for pickup':trackingData.status==='confirmed'?'✅ Confirmed':trackingData.status==='packed'?'📦 Packed':'🚚 On the way'}
                  </span>
                </div>

                {/* VISUAL PROGRESS STEPPER */}
                {trackingData.status!=='cancelled' && (()=>{
                  const stepOrder = ['pending','confirmed','packed','outfordelivery','delivered'];
                  const statusMap = {pending:0,confirmed:1,preparing:1,ready:2,packed:2,delivered:4};
                  const curStep = statusMap[trackingData.status] ?? 3;
                  const steps = [['📝','Placed'],['✅','Confirmed'],['📦','Packed'],['🚚','Out for Delivery'],['🏠','Delivered']];
                  return (
                    <div style={{display:'flex',justifyContent:'space-between',marginBottom:'18px',padding:'0 4px'}}>
                      {steps.map(([icon,label],i)=>(
                        <div key={i} style={{display:'flex',flexDirection:'column',alignItems:'center',flex:1,position:'relative'}}>
                          {i>0&&<div style={{position:'absolute',top:'16px',right:'50%',width:'100%',height:'2px',background:i<=curStep?secondaryColor:'#e0e0e0',zIndex:0}}></div>}
                          <div style={{width:'32px',height:'32px',borderRadius:'50%',background:i<=curStep?secondaryColor:'#e0e0e0',color:'white',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'14px',zIndex:1,position:'relative'}}>{icon}</div>
                          <div style={{fontSize:'9px',fontWeight:'700',color:i<=curStep?'#1a1a1a':'#999',marginTop:'4px',textAlign:'center'}}>{label}</div>
                        </div>
                      ))}
                    </div>
                  );
                })()}

                {trackingData.driver ? (
                  <div style={{background:'#f0fffe',borderRadius:'14px',padding:'14px',marginBottom:'14px'}}>
                    <div style={{fontWeight:'700',color:'#1a1a1a',fontSize:'14px',marginBottom:'4px'}}>🏍️ {trackingData.driver.name}</div>
                    <div style={{color:'#666',fontSize:'12px',marginBottom:'8px'}}>{trackingData.driver.vehicleType} • {trackingData.driver.vehicleNumber} • ⭐ {trackingData.driver.rating}</div>
                    {trackingData.driver.currentLocation?.lat ? (
                      <a href={`https://www.google.com/maps?q=${trackingData.driver.currentLocation.lat},${trackingData.driver.currentLocation.lng}`} target="_blank" rel="noreferrer" style={{display:'block',textAlign:'center',padding:'10px',background:primaryColor,color:'white',borderRadius:'10px',fontSize:'13px',fontWeight:'700',textDecoration:'none'}}>📍 View Live Location</a>
                    ) : (
                      <div style={{color:'#999',fontSize:'12px'}}>Location not available yet</div>
                    )}
                    <a href={`tel:${trackingData.driver.phone}`} style={{display:'block',textAlign:'center',padding:'10px',marginTop:'8px',background:'#f0f7ff',color:primaryColor,borderRadius:'10px',fontSize:'13px',fontWeight:'700',textDecoration:'none'}}>📞 Call Delivery Partner</a>
                  </div>
                ) : (
                  <div style={{textAlign:'center',color:'#999',fontSize:'13px',padding:'14px',background:'#f8f9fa',borderRadius:'12px',marginBottom:'14px'}}>Delivery partner not assigned yet</div>
                )}
                <div style={{fontSize:'12px',color:'#666'}}>{trackingData.items?.map(i=>i.name).join(', ')}</div>
                <div style={{fontWeight:'800',color:'#1a1a1a',fontSize:'15px',marginTop:'8px'}}>₹{trackingData.total}</div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* PROFILE TAB */}
      {tab==='profile'&&(
        <div style={{background:'#f4f6fa',minHeight:'100vh'}}>
          {/* ACCOUNT HEADER */}
          <div style={{background:`linear-gradient(135deg,${primaryColor},#0783ED)`,padding:'22px 16px 46px',color:'white'}}>
            <div style={{display:'flex',alignItems:'center',gap:'14px'}}>
              <div style={{width:'60px',height:'60px',borderRadius:'50%',background:'white',color:primaryColor,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'26px',fontWeight:800,flexShrink:0}}>
                {String((userName||phone||'U')[0]).toUpperCase()}
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:800,fontSize:'18px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{userName||(phone?`+91 ${phone}`:'Welcome!')}</div>
                {userName&&<div style={{opacity:0.85,fontSize:'12px',marginTop:'2px'}}>+91 {phone}</div>}
              </div>
              <button onClick={()=>{const parts=(userName||'').split(' ');setEditFirstName(parts[0]||'');setEditLastName(parts.slice(1).join(' ')||'');setEditEmail(userEmail);setEditDob(userDob);setEditGender(userGender);setShowEditProfile(true);}} style={{background:'rgba(255,255,255,0.18)',border:'1px solid rgba(255,255,255,0.45)',color:'white',borderRadius:'999px',padding:'7px 14px',fontSize:'12px',fontWeight:700,cursor:'pointer',flexShrink:0}}>Edit</button>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'8px',marginTop:'16px'}}>
              {[[orders.length,'Orders',()=>{setTab('orders');fetchOrders();}],[loyalty.points,'Coins',()=>{setPage('wallet');fetchWalletHistory();}],[loyalty.points>500?'Gold':loyalty.points>100?'Silver':'New','Member',()=>{setPage('wallet');fetchWalletHistory();}]].map(([val,label,action],i)=>(
                <div key={i} onClick={action} style={{background:'rgba(255,255,255,0.16)',borderRadius:'12px',padding:'10px 6px',textAlign:'center',cursor:'pointer'}}>
                  <div style={{fontWeight:800,fontSize:'17px'}}>{val}</div>
                  <div style={{fontSize:'10px',opacity:0.85,marginTop:'1px'}}>{label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* QUICK ACTIONS */}
          <div style={{margin:'-26px 12px 14px',background:'white',borderRadius:'16px',padding:'14px 6px',boxShadow:'0 6px 18px rgba(16,24,40,0.10)',display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'4px',position:'relative'}}>
            {[
              ['📦','Orders',()=>{setTab('orders');fetchOrders();}],
              ['🏥','Prescriptions',()=>{setPage('prescription');fetchMyPrescriptions();}],
              ['📍','Addresses',()=>{setPage('addresses');fetchAddresses();}],
              ['🔖','Wishlist',()=>{setPage('wishlist');fetchWishlist();}],
            ].map(([icon,label,action],i)=>(
              <div key={i} onClick={action} style={{textAlign:'center',cursor:'pointer',padding:'4px 2px'}}>
                <div style={{width:'46px',height:'46px',margin:'0 auto 6px',borderRadius:'14px',background:'#eef5ff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'22px'}}>{icon}</div>
                <div style={{fontSize:'11px',fontWeight:700,color:'#344054'}}>{label}</div>
              </div>
            ))}
          </div>

          {/* GROUPED MENU */}
          {[
            ['Orders & Health',[
              ['📦','My Orders','Track & manage orders',()=>{setTab('orders');fetchOrders();},null],
              ['📋','My Subscriptions','Auto-refill medicines',()=>{setPage('refills');fetchRefills();},null],
              ['🏥','Health Records','Prescriptions & reports',()=>{setPage('prescription');fetchMyPrescriptions();},null],
              ['🧪','My Bookings','Lab tests, scans & consultations',()=>{setPage('mybookings');fetchMyBookings();},null],
            ]],
            ['Rewards & Plans',[
              ['🪙','My Wallet',loyalty.points+' coins = ₹'+Math.floor(loyalty.points/100)+' discount',()=>{setPage('wallet');fetchWalletHistory();},null],
              ['👑','SashtiMedix PLUS',myMembership.active?'Active member':'Free delivery & extra discounts',()=>{setPage('membership');fetchMembershipPlans();fetchMyMembership();},null],
            ]],
            ['My Details',[
              ['📍','My Addresses','Saved delivery addresses',()=>{setPage('addresses');fetchAddresses();},null],
              ['👨‍👩‍👧','Family Members','Manage family profiles',()=>{setPage('family');fetchFamily();},null],
              ['🔔','Notifications','Order updates & offers',()=>{setPage('notifications');fetchNotifications();},unreadCount>0?unreadCount:null],
              ['🔖','Saved for Later','Wishlist medicines',()=>{setPage('wishlist');fetchWishlist();},null],
            ]],
            ['Help & Info',[
              ['❓','Help & Support','FAQs & contact us',()=>setPage('support'),null],
              ['📄','Legal Information','Terms & privacy policy',()=>setPage('legal'),null],
              ['ℹ️','About Us','Know more about Sashtimedix',()=>setPage('about'),null],
            ]],
          ].map(([title,items])=>(
            <div key={title} style={{margin:'0 12px 14px'}}>
              <div style={{fontSize:'11px',fontWeight:800,letterSpacing:'0.8px',textTransform:'uppercase',color:'#8a94a6',margin:'0 4px 8px'}}>{title}</div>
              <div style={{background:'white',borderRadius:'16px',overflow:'hidden',boxShadow:'0 1px 3px rgba(16,24,40,0.06)',border:'1px solid #eceff4'}}>
                {items.map(([icon,label,sub,action,badge],i)=>(
                  <div key={label} onClick={action} style={{display:'flex',alignItems:'center',gap:'14px',padding:'13px 14px',borderBottom:i<items.length-1?'1px solid #f2f4f7':'none',cursor:'pointer'}}>
                    <div style={{width:'40px',height:'40px',background:'#eef5ff',borderRadius:'12px',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'20px',flexShrink:0}}>{icon}</div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontWeight:700,color:'#101828',fontSize:'14px'}}>{label}</div>
                      <div style={{color:'#8a94a6',fontSize:'11px',marginTop:'1px'}}>{sub}</div>
                    </div>
                    {badge&&<span style={{background:'#e5392d',color:'white',borderRadius:'999px',fontSize:'11px',fontWeight:800,padding:'2px 8px'}}>{badge}</span>}
                    <span style={{color:'#c0c6d1',fontSize:'20px'}}>›</span>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <div style={{padding:'0 12px 8px'}}>
            <button onClick={()=>{ if (window.confirm('Sign out from Sashtimedix?')) logout(); }} style={{width:'100%',padding:'14px',background:'white',color:'#e5392d',border:'1.5px solid #f3c4c0',borderRadius:'14px',fontSize:'14px',fontWeight:700,cursor:'pointer'}}>Sign Out</button>
          </div>

          <div style={{padding:'8px 16px 80px',textAlign:'center'}}>
            <p style={{color:'#b0b7c3',fontSize:'11px',margin:'4px 0'}}>Sashtimedix v1.0</p>
            <p onClick={()=>setPage('legal')} style={{color:'#b0b7c3',fontSize:'10px',cursor:'pointer',textDecoration:'underline',margin:0}}>© 2026 Sashtimedix. All Rights Reserved.</p>
          </div>
        </div>
      )}

      {/* DESKTOP FOOTER - hidden on mobile */}
      <div className="desktop-footer" style={{background:'#1a1a2e',color:'#ccc',padding:'40px 24px 20px',marginTop:'20px'}}>
        <div style={{maxWidth:'1200px',margin:'0 auto',display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'30px'}}>
          <div>
            <div style={{color:'white',fontWeight:'800',fontSize:'18px',marginBottom:'10px'}}>Sashtimedix</div>
            <p style={{fontSize:'13px',lineHeight:'1.6'}}>Your trusted online pharmacy. Genuine medicines, fast delivery, and precision in every product.</p>
          </div>
          <div>
            <div style={{color:'white',fontWeight:'700',fontSize:'14px',marginBottom:'10px'}}>Company</div>
            <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
              <a href="#" onClick={()=>setPage('about')}>About Us</a>
              <a href="#" onClick={()=>setPage('support')}>Help & Support</a>
              <a href="#" onClick={()=>setPage('legal')}>Legal Information</a>
            </div>
          </div>
          <div>
            <div style={{color:'white',fontWeight:'700',fontSize:'14px',marginBottom:'10px'}}>Customer Policies</div>
            <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
              <a href="#" onClick={()=>setPage('legal')}>Terms & Conditions</a>
              <a href="#" onClick={()=>setPage('legal')}>Privacy Policy</a>
              <a href="#" onClick={()=>setPage('legal')}>Return Policy</a>
            </div>
          </div>
          <div>
            <div style={{color:'white',fontWeight:'700',fontSize:'14px',marginBottom:'10px'}}>Get in Touch</div>
            <a href="https://wa.me/917598980545" style={{display:'block',marginBottom:'8px'}}>WhatsApp Support</a>
            <div style={{fontSize:'13px'}}>Tamil Nadu</div>
          </div>
        </div>
        <div style={{maxWidth:'1200px',margin:'24px auto 0',paddingTop:'16px',borderTop:'1px solid #333'}}>
          <div style={{color:'white',fontWeight:'700',fontSize:'13px',marginBottom:'10px'}}>🔒 Secure Payments · Powered by Razorpay</div>
          <PayStrip dark />
        </div>
        <div style={{maxWidth:'1200px',margin:'24px auto 0',paddingTop:'16px',borderTop:'1px solid #333',fontSize:'12px',textAlign:'center',color:'#888'}}>
          <span onClick={()=>setPage('legal')} style={{cursor:'pointer'}}>(c) 2026 Sashtimedix. All rights reserved.</span>
        </div>
      </div>

      {/* BOTTOM NAVIGATION */}
      <div className="app-nav" style={{position:'fixed',bottom:0,left:'50%',transform:'translateX(-50%)',width:'100%',background:'white',boxShadow:'0 -4px 20px rgba(0,0,0,0.1)',zIndex:100,borderTop:'1px solid #f0f0f0'}}>
        <div style={{display:'flex',padding:'4px 0 8px'}}>
          {[['🏠','Home','home'],['☰','Category','search'],['👤','Account','profile'],['🩺','Health','scans'],['🛒','Cart','cart']].map(([icon,label,targetTab],idx)=>{
            const isActive = (idx===0&&tab==='home')||(idx===1&&tab==='search')||(idx===2&&tab==='profile')||(idx===3&&tab==='scans')||(idx===4&&tab==='cart');
            return (
              <button key={idx} onClick={()=>setTab(targetTab)} style={{flex:1,padding:'8px 0',border:'none',background:'none',cursor:'pointer',display:'flex',flexDirection:'column',alignItems:'center',gap:'3px',position:'relative'}}>
                <div style={{fontSize:'22px',opacity:isActive?1:0.45,filter:isActive?'none':'grayscale(100%)'}}>{icon}</div>
                <div style={{fontSize:'10px',fontWeight:'600',color:isActive?'#0058C6':'#999'}}>{label}</div>
                {idx===4&&cartCount>0&&<span key={cartCount} className="cart-bump" style={{position:'absolute',top:'2px',right:'15%',background:accentColor,color:'white',borderRadius:'50%',width:'16px',height:'16px',fontSize:'9px',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:'bold'}}>{cartCount}</span>}
                {isActive&&<div style={{position:'absolute',top:0,left:'50%',transform:'translateX(-50%)',width:'24px',height:'3px',background:'#0058C6',borderRadius:'0 0 4px 4px'}}></div>}
              </button>
            );
          })}
        </div>
      </div>

      {/* LIVE CHAT ASSISTANT */}
      {SHOW_CHAT&&chatOpen&&(
        <div style={{position:'fixed',bottom:'150px',right:'18px',width:'300px',maxWidth:'calc(100vw - 36px)',height:'380px',background:'white',borderRadius:'16px',boxShadow:'0 12px 32px rgba(0,0,0,0.25)',zIndex:200,display:'flex',flexDirection:'column',overflow:'hidden'}}>
          <div style={{background:`linear-gradient(135deg,${primaryColor},#0783ED)`,padding:'12px 14px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div style={{color:'white',fontWeight:700,fontSize:'13px'}}>SashtiMedix Assistant</div>
            <button onClick={()=>setChatOpen(false)} style={{background:'none',border:'none',color:'white',fontSize:'18px',cursor:'pointer'}}>×</button>
          </div>
          <div style={{flex:1,overflowY:'auto',padding:'12px',display:'flex',flexDirection:'column',gap:'8px'}}>
            {chatHistory.map((m,i)=>(
              <div key={i} style={{alignSelf:m.from==='bot'?'flex-start':'flex-end',background:m.from==='bot'?'#f0f7ff':primaryColor,color:m.from==='bot'?'#1a1a1a':'white',padding:'8px 12px',borderRadius:'12px',fontSize:'12px',maxWidth:'85%',lineHeight:'1.4'}}>{m.text}</div>
            ))}
          </div>
          <div style={{padding:'10px',borderTop:'1px solid #f0f0f0'}}>
            <div style={{display:'flex',flexWrap:'wrap',gap:'6px',marginBottom:'8px'}}>
              {chatTopics.map(([topic,answer],i)=>(
                <span key={i} onClick={()=>askChatBot(topic,answer)} style={{background:'#f0f7ff',color:primaryColor,padding:'6px 10px',borderRadius:'16px',fontSize:'11px',fontWeight:600,cursor:'pointer'}}>{topic}</span>
              ))}
            </div>
            <a href="https://wa.me/917598980545?text=Hi%20Sashtimedix%2C%20I%20need%20help" target="_blank" rel="noopener noreferrer" style={{display:'block',textAlign:'center',padding:'9px',background:'#25D366',color:'white',borderRadius:'10px',fontSize:'12px',fontWeight:700,textDecoration:'none'}}>Talk to a Human on WhatsApp</a>
          </div>
        </div>
      )}
      {SHOW_CHAT&&<button onClick={()=>setChatOpen(o=>!o)} style={{position:'fixed',bottom:'150px',right:'18px',width:'54px',height:'54px',borderRadius:'50%',background:primaryColor,border:'none',display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'0 8px 20px rgba(0,88,198,0.4)',zIndex:101,fontSize:'22px',cursor:'pointer'}}>
        {chatOpen?'×':'Chat'}
      </button>}

      {/* WHATSAPP FLOATING BUTTON - replace 919999999999 with the real business WhatsApp number */}
      <a href="https://wa.me/917598980545?text=Hi%20Sashtimedix%2C%20I%20need%20help%20with%20an%20order"
        target="_blank" rel="noopener noreferrer"
        style={{position:'fixed',bottom:'86px',right:'18px',width:'54px',height:'54px',borderRadius:'50%',background:'#25D366',display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'0 8px 20px rgba(37,211,102,0.45)',zIndex:101,textDecoration:'none',animation:'waPulse 2.4s ease-in-out infinite'}}>
        <svg viewBox="0 0 32 32" width="28" height="28" fill="white"><path d="M16.004 3C9.377 3 4 8.373 4 15c0 2.27.633 4.394 1.73 6.207L4 29l7.98-1.687A11.94 11.94 0 0 0 16.004 27C22.63 27 28 21.627 28 15S22.63 3 16.004 3zm0 21.8c-1.99 0-3.86-.55-5.46-1.51l-.39-.23-4.73 1 1.02-4.6-.25-.4A9.77 9.77 0 0 1 6.2 15c0-5.41 4.4-9.8 9.8-9.8s9.8 4.39 9.8 9.8-4.4 9.8-9.8 9.8zm5.4-7.34c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.66.15-.2.3-.76.96-.93 1.16-.17.2-.34.22-.63.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.65-2.05-.17-.3-.02-.46.13-.6.13-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.66-1.6-.9-2.19-.24-.58-.48-.5-.66-.5h-.56c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.87 1.22 3.07c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.75-.72 2-1.41.24-.7.24-1.29.17-1.41-.07-.13-.27-.2-.56-.35z"/></svg>
      </a>
    </div>
  );
}
export default App;

